/**
 * gm-chat-widget.js — P4 kundeflade
 *
 * ⛔ REN JS-ASSET, INGEN LIQUID. Det er bevidst: den kendte fejlklasse "Liquid renderer sine egne
 * udtryks-tags OGSÅ inde i <script>" kan pr. definition ikke ramme denne fil, fordi Shopify kun
 * kører Liquid-parseren på .liquid-filer. Alt dynamisk indhold (URL'er, tekster, shop-specifikke
 * beløb) kommer ind via data-*-attributter på #gmchat-root, sat af snippets/gm-chat-widget.liquid.
 *
 * ⛔⛔ RETTET 27/08/2026 — DENNE BLOK SAGDE «INGEN Storage-API», OG DET ER IKKE LÆNGERE SANDT.
 * Frem til i dag stod her, at filen ALDRIG kalder localStorage/sessionStorage/document.cookie.
 * CEO's direktiv v2.2, punkt 4 og 5, kræver det modsatte: samtalen skal overleve, at kunden
 * klikker på et produktlink, og chatten skal kende de sidste besete varer.
 * ⇒ Påstanden er skrevet om frem for slettet (ledelsesregel 7: et forbud overlever den
 *   kendsgerning, det bygger på — så det skal rettes DÉR hvor det står, samme dag).
 *
 * HVAD DER FAKTISK GEMMES I DAG, udtømmende — én nøgle, `sessionStorage["gmchat_v1"]`:
 *   1. `session.id`      — serverens EGET uigennemsigtige samtale-id. Vi opfinder det aldrig.
 *   2. `session.oprettet` — hvornår vi FØRSTE gang så id'et, så vi kan lade det udløbe.
 *   3. `historik[]`      — de sidste 4 produkter kunden selv har set: **handle og titel, intet
 *                          andet.** Ingen priser, ingen billeder, ingen ordre-, kontakt- eller
 *                          fritekstdata.
 * ⛔ SAMTALENS TEKST GEMMES IKKE. `persondata-rammer.md` §D's undtagelse tillader ordret kun
 *   «et uigennemsigtigt id og intet andet». Kundens egne sætninger er fritekst-persondata, og de
 *   bliver dér, hvor de allerede er styret af en opbevaringsfrist og en sletterutine: på
 *   serveren. Skal loggen kunne TEGNES igen efter et sideskift, hører den historik i et
 *   server-felt, ikke i browseren — se leverancens §5.
 * ⛔ `localStorage` er FRAVALGT. `sessionStorage` dør med fanen; localStorage ville lade en
 *   kundes samtale-id og browsing ligge på en delt computer i ugevis. Dertil en HÅRD udløbstid,
 *   se `GEMT_LEVETID_MS`.
 * ⛔ HVER eneste læsning og skrivning er pakket i try/catch: privat vindue, ryddet lager og
 *   blokeret site-data KASTER. Fladen skal virke, når lageret er tomt eller utilgængeligt —
 *   uden lager opfører widget'en sig nøjagtig som før i dag.
 * ⚠ Cookies bruges fortsat ALDRIG (Shopifys App Proxy stripper dem alligevel).
 * ⚠ Konsekvensen for samtykke er IKKE min at afgøre: `persondata-rammer.md` §D siger, at
 *   ordlyden i cookiepolitikken er CEO's (§57 T5 d/h). Afleveret som input i leverancens §5.
 * Verificér adfærden i DevTools → Application → Session Storage, ikke ved at grep'e efter
 * strengen — en streng-tælling er ikke en adfærdsmåling.
 */
// ⛔⛔ BYGGEMARKOEREN — TREDJE FALD, 04/09/2026 (roed hat R3).
// `data-gmchat-build` fandtes KUN i `gm-chat-widget.liquid`, mens hver eneste
// rettelse den dag boede i `.js`/`.css`. Et liquid-only push viste derfor
// «ajour» over GAMMEL JS, og markoeren kunne pr. konstruktion ikke gaa roed
// for netop den fejl, den var bygget imod. Tredje gang det skete.
// ⇒ Samme vaerdi staar nu i alle tre filer. `test_build_port.js` henter siden
//   OG dette asset over HTTP og sammenligner KILDE mod SERVERET.
// ⚠ MAALT PAA TESTTEMA 203548721495 (04/09), ikke antaget: Shopify minificerer
//   det serverede asset. Lokale `var`-navne OMDOEBES (`KONTAKT_BLOK_START` =
//   0 forekomster i den serverede fil), mens FUNKTIONSNAVNE og STRENGE staar
//   ordret (`buildTransskript`, `showServerState` = 1 hver). Derfor:
//     · markoeren er en STRENG, ikke et variabelnavn,
//     · og den skrives paa `window`, saa ingen minifier kan fjerne den som
//       «ubrugt». En tildeling til et globalt objekt har en sideeffekt.
// ⚠ Den staar FOER `if (!root) return`: markoeren skal kunne laeses ogsaa paa
//   en side, hvor widget'en bevidst ikke rendrer. Ellers maaler porten
//   «gammel JS», hver gang den rammer en side uden chat.
window.GM_CHAT_BUILD = "CHAT-20261015-T3H3";

(function () {
  "use strict";

  var root = document.getElementById("gmchat-root");
  if (!root) return; // gm_chat_enable var slået fra i temaet — nødstoppet virker ved simpelt fravær af markup

  // ⛔ EAGER FONT-LOAD — RETTET 20/08/2026 (bevis_design.sh K6). #gmchat-panel starter
  // [hidden] (display:none), og en browser henter som udgangspunkt kun web-fonte for tekst
  // der FAKTISK er synlig. Uden dette ville Figtree/Montserrat (deklareret i
  // gm-chat-widget.liquid's egen <style>, se kommentar dér) først begynde at hente i det
  // øjeblik kunden åbner panelet — en synlig FOUT-flash, og for sent til at være pålideligt
  // indlæst på måletidspunktet. document.fonts.load() er CSS Font Loading API'ets egen vej
  // til at tvinge en hentning i gang UANSET synlighed — intet nyt netværkskald udover selve
  // fontfilerne widget'en allerede er sat op til at bruge, ingen Storage, ingen cookie.
  if (window.document && document.fonts && document.fonts.load) {
    // ⛔ ROED HAT 26/08, G3: "700 15px Montserrat" tilfoejet. Tre CSS-regler beder
    //   om vaegt 700; uden den i eager-listen hentes den foerst ved foerste maling,
    //   og K6 kan maale "400, 600" paa en flade, hvis CSS paastaar 700.
    ["700 15px Figtree", "600 15px Figtree", "400 15px Montserrat", "600 15px Montserrat", "700 15px Montserrat"].forEach(
      function (spec) {
        try { document.fonts.load(spec); } catch (e) {}
      }
    );
  }

  var d = root.dataset;
  var faqUrl = d.faqUrl || "";
  // ⛔ ROED HAT RUNDE 2, G7: en URL i et temafelt er ikke en beslutning om at
  // taende AI-chatten. Bagenden bruges kun, naar nogen HAR truffet valget:
  // enten er persondatateksten godkendt, eller temaet er maerket testflade.
  // Ellers falder widget'en tilbage til FAQ-soegningen - praecis som foer.
  var aiGodkendt = (d.aiGodkendt || "") === "ja";
  var testflade = (d.testflade || "") === "ja";
  // ⛔ ROED HAT RUNDE 3, G3: `aiGodkendt || testflade` var et OR, og
  // `settings_data.json` rejser med et tema. Publiceres eller duplikeres
  // testtemaet, sendes kundetekst til en model uden for EU **med den korte
  // persondatatekst, der ikke naevner AI** - plus et gult baand med en intern
  // besked paa kundens skaerm (§40's princip). Det er formen paa 17/08-haendelsen.
  // ⇒ Persondatateksten er et AND. Der findes ingen tilstand, hvor kundetekst
  //   forlader huset uden en oplysning om det.
  var harPrivacy = (d.privacyUdfyldt || "") === "ja";
  // ⛔⛔ ROED HAT RUNDE 6, G8: TESTFLADE-FLAGET REJSER MED TEMAET.
  // `gm_chat_testflade` og persondatateksten bor i `config/settings_data.json`,
  // som KOPIERES med, naar et tema publiceres eller duplikeres. Sammen med R3
  // (nødstoppet var ikke tilsluttet) betød en helt almindelig tema-promovering:
  // AI-chat live paa g-m.dk med en persondatatekst, der ikke naevner AI.
  // `role=MAIN`-spaerren forhindrer scriptet i at skrive i live-temaet - den
  // forhindrer ikke temaet i at BLIVE live.
  // ⇒ Testvejen gates paa noget, der IKKE rejser med temaet: en parameter i
  //   adressen. Den skal skrives af et menneske ved hvert besoeg, og den
  //   overlever ingen publicering. Den godkendte vej (`aiGodkendt`) er uroert.
  var testNoegle = false;
  var temaGaest = (d.testTemaGaest || "") === "ja";
  try {
    testNoegle = new URLSearchParams(window.location.search).has("gmchat_test");
  } catch (e) { testNoegle = false; }
  if (temaGaest && testflade && harPrivacy) testNoegle = true;
  var apiEndpoint = (aiGodkendt || (testflade && harPrivacy && testNoegle))
    ? (d.apiEndpoint || "") : "";
  // Privat gæstetest: adgang kommer fra linkets fragment, aldrig temaets assets.
  // Gemmes kun i denne fane og fjernes fra adressen før kundens navigation.
  var testAdgang = "";
  if (temaGaest && /^[a-f0-9]{64}$/.test(d.testTemaAdgang || "")) {
    testAdgang = d.testTemaAdgang;
  }
  if (testflade && /^\/apps\/chat\/v1-test\/chat\/?$/.test(apiEndpoint)) {
    var testFragment = new URLSearchParams(window.location.hash.slice(1));
    var testLinkVaerdier = testFragment.getAll("gmchat_access");
    if (testLinkVaerdier.length) {
      if (testLinkVaerdier.length === 1 && /^[a-f0-9]{64}$/.test(testLinkVaerdier[0])) {
        testAdgang = testLinkVaerdier[0];
      }
      try {
        if (testAdgang) window.sessionStorage.setItem("gmchat_test_access", testAdgang);
        else window.sessionStorage.removeItem("gmchat_test_access");
      } catch (_testLagerFejl) {}
      testFragment.delete("gmchat_access");
      try {
        var restFragment = testFragment.toString();
        window.history.replaceState(window.history.state, "", window.location.pathname +
          window.location.search + (restFragment ? "#" + restFragment : ""));
      } catch (_testHistorikFejl) {}
    } else {
      try { testAdgang = testAdgang || window.sessionStorage.getItem("gmchat_test_access") || ""; }
      catch (_testLagerFejl) {}
      if (!/^[a-f0-9]{64}$/.test(testAdgang)) testAdgang = "";
    }
    if (testAdgang) testNoegle = true;
  }

  // ⛔ ROED HAT RUNDE 2, R5: her laa de danske standardvaerdier STADIG, efter at
  // runde 1's R8-modtraek havde fjernet dem fra settings-skemaet. Paastanden
  // "Tomt felt = widget'en renderer ikke" stod fire gange i skemaet og var
  // implementeret NUL steder. En svensk, norsk eller engroskunde ville have
  // faaet det danske telefonnummer, det danske svartidsloefte og info@g-m.dk -
  // altsaa praecis R8's skade, uaendret.
  // ⇒ Ingen fallbacks. Og en tidlig retur, saa paastanden bliver SAND.
  var responseTimeText = d.responseTimeText || "";
  var samplePriceText = d.samplePriceText || "";
  var fallbackMail = d.fallbackMail || "";

  // ⛔ ROED HAT RUNDE 2, R8 foerste halvdel (lukket i runde 4, G10).
  // Alle faste tekster kommer fra temaets oversaettelser via data-attributter.
  // ⚠ INGEN dansk fallback: en standardvaerdi ville slaa igennem paa SE/NO/B2B
  // praecis som defaults gjorde i R8. Mangler en noegle, vises noeglenavnet -
  // synligt, ikke tavst.
  function t(navn) {
    return d["t" + navn.replace(/(^|-)([a-z])/g, function (_, __, c) {
      return c.toUpperCase();
    })] || "[gmchat." + navn.replace(/-/g, "_") + "]";
  }

  // ⭐ TILFØJET 26/08 — VALGFRI TEKST. `t()` viser noeglenavnet, naar en noegle
  // mangler, og det er rigtigt for de tekster, widget'en ikke kan undvaere:
  // synligt slaar tavst (R8). Men de to funktioner, der kom til i dag
  // (emne-maerket og ordreopslaget), har en NOEDVEJ i .liquid-filen: findes
  // noeglen ikke, faar vi en TOM streng - dansk paa en dansk shop, tomt paa alle
  // andre. `tv()` er den tilsvarende halvdel her: tom betyder «udelad
  // funktionen», ikke «vis noeglenavnet».
  // ⛔ Brug ALDRIG `tv()` til en tekst, kunden skal se for at forstaa noget, hun
  //   allerede er i gang med. Den er kun til funktioner, der kan udeblive helt.
  function tv(navn) {
    var v = d["t" + navn.replace(/(^|-)([a-z])/g, function (_, __, c) {
      return c.toUpperCase();
    })];
    return (typeof v === "string" && v.trim()) ? v : "";
  }


  // Mangler en af de tre obligatoriske tekster, renderer widget'en ikke.
  // Et tomt felt bliver dermed en SYNLIG fejl i stedet for en tavs dansk
  // standard paa en svensk flade.
  // `responseTimeText` indgaar ikke laengere i kravet - teksten vises ikke,
  // og et krav uden virkning er en faelde (P1.7).
  // T3-R17 30/09 (afg. 252 og 286, CEO): telefonen er fjernet fra kravet. Kun mailen er obligatorisk.
  if (!fallbackMail) {
    if (window.console && console.warn) {
      console.warn("[gm-chat] Widget renderer ikke: en obligatorisk tekst " +
                   "mangler i temaindstillingerne (mail). " +
                   "Der er ingen dansk standardvaerdi - den skal udfyldes pr. shop.");
    }
    return;
  }

  var faqEntries = [];
  var faqLoaded = false;
  // ⛔ ROED HAT G14, 19/08: her stod `apiHealthy`, sat tre steder og LAEST
  // ingen steder, plus et sundhedskald mod `/apps/chat/health` - en sti nginx
  // bevidst ikke udstiller (maalt udefra: 404). Kommentaren lovede en
  // Det er husets fjerde forekomst af klassen: en paastand om en kontrol,
  // ingen har efterproevet.
  // ⇒ Fjernet. Den RIGTIGE degradering er catch-vejen i `spoergBotten`:
  //   aerlig fejltekst + kontaktformular. Den virker, og den er den eneste.
  var currentProductTitle = null;
  var currentProductUrl = null;

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ LAGERET — ÉN NØGLE, KORT LEVETID, HVER ADGANG I try/catch   27/08 v2.2
  // ═══════════════════════════════════════════════════════════════════════════
  // CEO's direktiv v2.2 punkt 4: «Samtaletilstanden skal gemmes i sessionStorage
  // /localStorage … så kunden kan fortsætte den igangværende dialog uforstyrret.»
  //
  // ⛔ VALGT: `sessionStorage`. Den dør med fanen. `localStorage` ville lade en
  //   kundes samtale-id og hendes browsing ligge på en delt familie- eller
  //   biblioteks-computer, til nogen aktivt ryddede den. Der er ingen gevinst
  //   ved det: chatten er en samtale, ikke en indstilling.
  //
  // ⛔⛔ RETTET 01/09/2026 (RØD HAT RUNDE 2, R3) — MÅLT MOD SKABELSE, IKKE
  //   AKTIVITET, OG DEN FEJL RETTELSEN SKULLE FJERNE VAR TILBAGE.
  //   Her stod `nu - o.session.oprettet < GEMT_LEVETID_MS` — et ur, der
  //   startede ved FØRSTE besked og ALDRIG blev sat tilbage, ligegyldigt
  //   hvor mange ture samtalen fik bagefter (`spoergBotten` bevarede
  //   `oprettet` uændret ved hver tur, se `nySession` nedenfor). Tallet
  //   (55 min) var valgt til at ligge lige under SERVERENS DAGÆRENDE
  //   60-minutters ABSOLUTTE loft — men serveren blev SAMME DAG rettet
  //   (`gm_chat/api.py`, R2: `Session.udloebet`) til at måle INAKTIVITET
  //   (`sidst_aktiv`) i stedet for `oprettet`. Klienten fulgte ikke med.
  //   MÅLT KONSEKVENS: en kunde, der chattede >55 minutter og klikkede et
  //   PRODUKTLINK, fik sin session KASSERET her ved næste sidevisning,
  //   selvom serveren stadig havde den levende (den var aktiv hele tiden).
  //   Dialogen delte sig i to i dashboardet UDEN link — nøjagtig det,
  //   forrige rettelse skulle fjerne — og botten mistede sin kontekst midt i
  //   samtalen. Det rammer netop de LANGE samtaler, CEO's "kunder ringer ind
  //   og refererer til chatten" handler om, og netop de kunder, der klikker
  //   produktlinks.
  //   ⇒ Målt mod AKTIVITET i stedet: `session.roert` sættes ved hvert kald
  //     til `gemTilstand()` — præcis samme mønster som `historik.roert`
  //     allerede bruger (se den linje i `gemTilstand` nedenfor). Ét felt,
  //     ingen ny konstant.
  //
  // ⛔ TALLET ER GENOVERVEJET, IKKE BLOT ARVET UÆNDRET. Serveren måler
  //   fortsat `SESSION_LEVETID_S = 3.600 s` (60 min) INAKTIVITET — R2
  //   ændrede kun MÅLEPUNKTET (fra `oprettet` til `sidst_aktiv`), ikke selve
  //   tallet. Oven i det fik serveren samme dag et separat, ABSOLUT bagstop
  //   på 24 timer (`SESSION_MAKS_LEVETID_S`) — men det er et
  //   RAM-hygiejne-loft mod en session, der "holdes kunstigt i live", ikke
  //   noget en normal, sammenhængende kundesamtale nogensinde rammer, og
  //   ikke noget klienten skal spejle: en `sessionStorage`-post uden
  //   aktivitet i 55 minutter er allerede udløbet HER, længe før et
  //   24-timers-loft nogensinde kunne blive relevant.
  //   ⇒ 55 MINUTTER STÅR VED MAGT — men nu som en margen under det tal, der
  //     faktisk styrer (60 min inaktivitet), ikke under et loft, der ikke
  //     længere findes (60 min fra skabelse). Samme begrundelse for margenen
  //     som før: vi ser sjældent id'et i samme millisekund, serveren
  //     stemplede `sidst_aktiv`, og vi kan komme til at smide en session væk,
  //     der stadig lever; vi kan ALDRIG holde liv i en, der er død. Den
  //     asymmetri er med vilje: persistensen må ikke få kunden til at tro,
  //     at en udløbet samtale lever.
  //
  // ⛔ OG DEN LOVER INTET. Der vises INGEN «vi fortsætter, hvor du slap»-linje.
  //   Vi kan ikke fra klienten VIDE, om serveren stadig har sessionen (den kan
  //   være genstartet, eller `GM_SESSION_LEVETID_S` kan være sat ned i miljøet).
  //   En sætning, der påstår kontinuitet, ville være et løfte uden dækning.
  //   Sker det rigtige, mærker kunden det ved, at botten husker; sker det ikke,
  //   er fladen præcis som i går. Skal linjen kunne vises, kræver det et
  //   server-felt, der BEKRÆFTER sessionen - foreslået i leverancens §5.
  // ⭐⭐ 10/09/2026 — 55 MINUTTER → 24 TIMER, OG MÅLT MOD NOGET ANDET.
  //   To ting var forkerte på én gang, og de er ikke samme fejl:
  //
  //   (1) TALLET. Planen af 10/09 er ordret: *«Samme enhed kan fortsætte
  //       samtalen indtil mere end 24 timer efter kundens seneste besked.»*
  //       Serveren er allerede rettet til netop det (`bevis_levetid`, exit 0,
  //       urstyret på før/præcis/efter 24 t). Klienten stod på 55 minutter og
  //       kasserede altså en session, serveren stadig havde levende — kunden
  //       mødte en tom log, mens dashboardet havde hendes samtale. Præcis den
  //       asymmetri, hele R3-noten ovenfor handler om, blot med et nyt tal.
  //
  //   (2) MÅLEPUNKTET, OG DET ER DEN VÆRSTE AF DE TO. `roert` blev sat af
  //       `gemTilstand()` ved HVERT skriv — også et rent sideskift, hvor
  //       `noterBesoegtVare` gemmer en handle. En kunde, der browsede i to
  //       døgn uden at skrive ét ord, holdt derfor sin samtale kunstigt i
  //       live, mens en kunde, der skrev og lukkede fanen, mistede sin.
  //       Ingen af delene er «kundens seneste besked».
  //   ⇒ `kundeRoert` er et EGET felt, sat PRÆCIS ét sted: i `spoergBotten`,
  //     når kunden faktisk har sendt noget. `roert` findes stadig, men er nu
  //     kun et spor af sidste skriv — den styrer INTET udløb.
  //   ⚠ To spørgsmål, to felter. Det er husets egen «ét felt, to betydninger»
  //     -regel, samme som `_kundens_ord`/`_nuvaerende_ord` i `samler.py`.
  //
  // ⛔ MARGENEN ER VÆK MED VILJE. Før lå klienten 5 minutter UNDER serveren, så
  //   vi hellere smed en levende session væk end holdt en død i live. Med 24
  //   timer på begge sider er den asymmetri flyttet et andet sted hen: klienten
  //   kan nu i teorien beholde et id, serveren har glemt. Det er håndteret ved
  //   KILDEN i stedet — `genoptag` spørger serveren, om sessionen findes, og
  //   `kendt:false` rydder lageret. Vi gætter ikke længere; vi spørger.
  var GEMT_NOEGLE = "gmchat_v1";
  // ⛔⛔ WA-HOTFIX 01/10/2026 (afg. 358): INGEN LAGRING VED INDLÆSNING.
  //   `gmchat_v1` skrives FØRST, når kunden åbner chatten eller sender sin
  //   første besked (`frigivLager`). Indtil da holdes de sidst sete varer i
  //   hukommelsen (`ventendeHistorik`) og dør med siden.
  //   Undtagelse: fanen har allerede en samtale, kunden selv har startet
  //   (gyldig `session` i lageret) — så er nøglen skrevet af kundens egen
  //   handling, og lageret er frigivet fra indlæsningen (se Init).
  var lagerFrigivet = false;
  var ventendeHistorik = null;
  var GEMT_LEVETID_MS = 24 * 60 * 60 * 1000;
  var HISTORIK_MAKS = 4;

  // ⚠ Hvert eneste kald hertil kan kaste: privat vindue, ryddet lager, blokeret
  //   site-data, kvote fyldt. Ingen af dem må kunne vælte widget'en, så begge
  //   funktioner fejler LUKKET og returnerer den tomme tilstand.
  function lagerLaes() {
    try {
      var raa = window.sessionStorage.getItem(GEMT_NOEGLE);
      if (!raa) return null;
      var o = JSON.parse(raa);
      return (o && typeof o === "object") ? o : null;
    } catch (e) { return null; }
  }

  function lagerSkriv(o) {
    try { window.sessionStorage.setItem(GEMT_NOEGLE, JSON.stringify(o)); return true; }
    catch (e) { return false; }
  }

  function lagerRyd() {
    try { window.sessionStorage.removeItem(GEMT_NOEGLE); } catch (e) {}
  }

  // Læser den gemte tilstand OG luger det udløbne bort i samme greb, så ingen
  // kaldssted kan komme til at bruge en post, der er for gammel.
  function gemtTilstand() {
    var o = lagerLaes();
    if (!o) return { session: null, historik: [] };
    var nu = Date.now();
    var ses = null, hist = [];
    // ⛔⛔ RETTET 01/09/2026 (RØD HAT RUNDE 2, R3) — MÅLT MOD `roert` (SIDSTE
    //   AKTIVITET), IKKE `oprettet` (SKABELSE). Se den store note ved
    //   `GEMT_LEVETID_MS` for hele fejlklassen. `roert` skrives af
    //   `gemTilstand()` nedenfor ved HVERT skriv, så en session, der stadig
    //   er i brug, aldrig kasseres her, selvom `oprettet` ligger langt
    //   tilbage.
    //   ⚠ En post skrevet af JS'en FØR denne rettelse har intet `roert`-felt
    //     endnu — for den ENE overgangs-læsning bruges `oprettet` som bedste
    //     tilnærmelse til "sidst set i live" (bedre end at kassere en
    //     session, der rent faktisk lever). Enhver NY skrivning (den næste
    //     tur, eller blot dette sideskift, jf. `noterBesoegtVare` i Init)
    //     sætter `roert` med det samme, så tilnærmelsen aldrig gentages.
    // ⭐⭐ 10/09: MÅLES NU MOD `kundeRoert` — KUNDENS SENESTE BESKED.
    //   Se den store note ved `GEMT_LEVETID_MS`: `roert` blev sat ved hvert
    //   skriv, også et rent sideskift, så to døgns browsing uden ét ord holdt
    //   samtalen kunstigt i live. Planen siger «24 timer efter kundens seneste
    //   besked», og det er et andet tidspunkt end «sidst rørt».
    //   ⚠ FALDBAKKEN ER EN OVERGANG, IKKE EN REGEL: en post skrevet FØR denne
    //     rettelse har intet `kundeRoert`. For den ENE læsning bruges `roert`
    //     (og derefter `oprettet`) som bedste tilnærmelse — bedre end at
    //     kassere en session, der lever. Første nye kundebesked sætter feltet,
    //     så tilnærmelsen aldrig gentages.
    var sesRoert = (o.session && typeof o.session.kundeRoert === "number")
      ? o.session.kundeRoert
      : ((o.session && typeof o.session.roert === "number")
          ? o.session.roert
          : (o.session ? o.session.oprettet : undefined));
    if (o.session && typeof o.session.id === "string" && o.session.id &&
        typeof o.session.oprettet === "number" &&
        typeof sesRoert === "number" &&
        nu - sesRoert < GEMT_LEVETID_MS) {
      ses = o.session;
    }
    if (o.historik && typeof o.historik.roert === "number" &&
        nu - o.historik.roert < GEMT_LEVETID_MS &&
        Object.prototype.toString.call(o.historik.poster) === "[object Array]") {
      hist = o.historik.poster.filter(function (p) {
        return p && typeof p.handle === "string" && p.handle;
      }).slice(0, HISTORIK_MAKS);
    }
    return { session: ses, historik: hist };
  }

  //: ⭐⭐ 10/09: TREDJE ARGUMENT — «KOM DETTE SKRIV FRA EN KUNDEBESKED?»
  //:   `kundeRoert` sættes KUN når det er sandt. Alle andre kaldere
  //:   (`noterBesoegtVare` ved et sideskift, kurvkvitteringen) forlænger
  //:   dermed IKKE samtalens levetid. Det er hele forskellen mellem «sidst
  //:   rørt» og «kundens seneste besked», og planen af 10/09 nævner kun det
  //:   sidste.
  //: ⚠ Argumentet er med vilje eksplicit og ikke udledt af kaldsstedet: en
  //:   udledning ville skulle gættes om igen, hver gang en ny kalder kom til.
  function gemTilstand(ses, hist, fraKundebesked) {
    var o = {};
    // ⛔⛔ RETTET 01/09/2026 (RØD HAT RUNDE 2, R3): `roert` sættes HER, ved
    //   hvert skriv — samme greb som `historik.roert` to linjer nedenfor,
    //   som filen allerede brugte. Enhver kalder (`spoergBotten` ved hver
    //   tur, `noterBesoegtVare` ved et sideskift) forlænger dermed
    //   session-levetiden ved AKTIVITET. `oprettet` sættes fortsat kun ÉN
    //   gang (i `spoergBotten`s `nySession`) og bevares uændret — den er
    //   stadig den ægte skabelsestid, blot ikke længere det, udløb måles
    //   imod.
    if (ses) {
      ses.roert = Date.now();
      if (fraKundebesked) ses.kundeRoert = Date.now();
      o.session = ses;
    }
    // ⚠ Historikken har sit EGET ur og sin egen betydning: den er «hvad har
    //   kunden set på», ikke «hvornår skrev hun sidst». Den forlænges derfor
    //   fortsat ved et sideskift — det er netop det, der gør den brugbar, når
    //   kunden ENDELIG åbner chatten efter tre varer.
    if (hist && hist.length) o.historik = { poster: hist.slice(0, HISTORIK_MAKS), roert: Date.now() };
    // ⛔⛔ ARVEN BÆRES UÆNDRET MED (10/09). `gemTilstand` bygger et FRISKT
    //   objekt og skriver det oven i posten — så enhver nøgle, den ikke selv
    //   sætter, blev slettet. Lå «Start ny samtale»-arven dér, ville den være
    //   væk ved det første sideskift, og den nye samtale ville få frisk, fuldt
    //   budget. Arven har sit EGET ur (`arv.roert`) og røres derfor ikke her.
    var _tidl = lagerLaes();
    if (_tidl && _tidl.arv && typeof _tidl.arv === "object") o.arv = _tidl.arv;
    if (!o.session && !o.historik && !o.arv) { lagerRyd(); return; }
    lagerSkriv(o);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐⭐ ARVEN EFTER «START NY SAMTALE» — I LAGERET, IKKE KUN I HUKOMMELSEN
  // ═══════════════════════════════════════════════════════════════════════════
  // ⛔⛔ HULLET, DER LUKKES HER (målt 10/09). `forrigeSession` og
  //   `forrigeVarOpbrugt` var MODULVARIABLER. En modulvariabel lever i ÉN
  //   JS-lukning og er væk ved hvert sideskift — og «Start ny samtale» rydder
  //   oven i købet hele lagerposten med `lagerRyd()`.
  //   ⇒ Kunden klikkede «Start ny samtale» og trykkede F5 (eller klikkede et
  //     produktlink, hvad hun gør hele tiden). Den næste besked bar da INGEN
  //     `forrige_session`, og serveren havde intet at kæde den til: frisk,
  //     fuldt budget. Den ENESTE bindende af knappens tre spærrer — arven —
  //     kunne omgås med et tryk på F5.
  //   ⚠ Karantænen (a) og loftet pr. sidevisning (b) forsvinder ved samme
  //     sideskift, men de er FRIKTION og har altid været det. (c) er spærren,
  //     og den skal overleve det, de to andre ikke behøver.
  // ⛔ INTET INDHOLD I LAGERET — kun serverens eget session-id og ét boolsk
  //   flag. Samme disciplin som `session`-posten.
  // ⚠ Arven har SIT EGET UR og lever 24 timer som resten. Den forlænges aldrig:
  //   et sideskift skriver `session.roert`, men rører ikke `arv.roert`.
  function gemtArv() {
    var o = lagerLaes();
    var a = o && o.arv;
    if (!a || typeof a !== "object") return null;
    if (typeof a.session !== "string" || !a.session) return null;
    if (typeof a.roert !== "number") return null;
    if (Date.now() - a.roert >= GEMT_LEVETID_MS) return null;
    return { session: a.session, opbrugt: !!a.opbrugt };
  }

  //: Tom `sid` ⇒ arven er BRUGT og fjernes. ⛔ Den må aldrig kunne bruges to
  //: gange: så ville to nye samtaler kunne kæde sig til samme forgænger og
  //: dele ét reduceret budget i stedet for at arve det hver.
  function skrivArv(sid, opbrugt) {
    var o = lagerLaes() || {};
    if (sid) o.arv = { session: String(sid), opbrugt: !!opbrugt, roert: Date.now() };
    else if (o.arv) { delete o.arv; }
    if (!o.session && !o.historik && !o.arv) { lagerRyd(); return; }
    lagerSkriv(o);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ AKTIV SIDE — HVAD KUNDEN STÅR PÅ LIGE NU              27/08 v2.2
  // ═══════════════════════════════════════════════════════════════════════════
  // CEO's direktiv v2.2 punkt 5: kunden står på et produkt og spørger «den
  // produkt jeg står inde på, er det en produkt du har på lager» - og botten
  // svarer «Hvilket stof eller varenummer står du inde på?».
  //
  // ⛔ RODÅRSAGEN ER MÅLT, OG DEN ER IKKE DEN, MAN VILLE GÆTTE.
  //   Widget'en HAR felterne `currentProductTitle`/`currentProductUrl` - men de
  //   sættes ét eneste sted: når kunden klikker et element med
  //   `[data-gmchat-open="product"]`, som `gm-chat-product-link.liquid` udsender.
  //   MÅLT 27/08 på testtemaet, produktsiden `/products/viscose-jersey-r`:
  //       document.querySelectorAll('[data-gmchat-open]').length   →  0
  //       document.querySelectorAll('.gmchat-product-link').length →  0
  //       sidekilden indeholder strengen 'gmchat-product-link'     →  false
  //   ⇒ Snippet'en er ALDRIG blevet indsat i produktskabelonen. De to felter er
  //     derfor `null` på HVER side, for HVER kunde, hver gang - og `spoergBotten`
  //     har aldrig sendt `krop.produkt` én eneste gang. Botten spørger ikke,
  //     fordi den er dum; den spørger, fordi den aldrig har fået noget at vide.
  //   ⚠ Det er husets egen fejlklasse: en mekanisme, der er bygget og målt i
  //     koden, men aldrig tilsluttet dér hvor den skulle virke.
  //
  // ⇒ Fladen læser nu selv den aktive vare fra sidens EGNE, kundesynlige
  //   kilder, så funktionen ikke afhænger af en temaændring, der ikke er sket.
  //   Bliver snippet'en indsat senere, vinder den (den er et udtrykkeligt valg).
  //
  // ⛔ VI SENDER ALDRIG NOGET, KUNDEN IKKE SELV KAN SE PÅ SIDEN. Alle tre kilder
  //   nedenfor er offentlig, synlig sidedata: adressen i browserens adressefelt,
  //   `og:title` og sidens `<h1>`. Der læses hverken pris, lager, kundedata,
  //   cookies eller analytics-objekter.
  // ⛔ OG VI RENDERER ALDRIG ET HANDLE. Handles bærer leverandør-præfikser
  //   (`wt-`, `vt-`, `tt-`), og et handle løftet op i synlig tekst ville være et
  //   §1-brud. Handlet sendes til bagenden - det står i forvejen i kundens egen
  //   adresselinje - men det bliver aldrig til noget, kunden læser.
  var PRODUKT_STI = /\/products\/([^\/?#]+)/;

  // ⭐⭐ KOLLEKTIONSSIDER — TILFØJET 10/09/2026.
  //   `laesAktivSide` kendte KUN `/products/`. En kunde, der stod på
  //   `/collections/moerklaegning` og skrev «har I noget mørkere end det her?»,
  //   sendte derfor `kontekst: null`, og botten havde intet at gå ud fra.
  //   Planen af 10/09 er ordret: *«Kend den aktuelle produkt-/kollektionsside
  //   og relevante nyligt besete produkter under besøget.»*
  // ⛔ RÆKKEFØLGEN ER IKKE LIGEGYLDIG: `/collections/<x>/products/<y>` er en
  //   LEVENDE sti på husets shops (målt 26/08 — temaerne linker netop den
  //   kollektions-scopede form). Står der `/products/` i stien, er kunden på
  //   en VARE, ikke på en kollektion, og produktgrenen skal vinde. Prøves
  //   kollektionen først, ville hver eneste produktside blive meldt som en
  //   kollektion.
  // ⚠ `/collections/all` er ikke en kollektion, kunden har valgt — det er
  //   shoppens komplette katalog, og «kunden ser på alt» er ikke kontekst.
  //   Den udelades, så botten ikke tror, den ved noget.
  var KOLLEKTION_STI = /\/collections\/([^\/?#]+)/;
  var KOLLEKTION_UDELAD = ["all", "types", "vendors"];

  function metaIndhold(vaelger) {
    var m = document.querySelector(vaelger);
    var v = m ? (m.getAttribute("content") || "") : "";
    return v.trim();
  }

  function jsonLdProduktNavn() {
    try {
      var s = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < s.length; i++) {
        var j = JSON.parse(s[i].textContent || "null");
        if (!j) continue;
        var liste = (j["@graph"] && j["@graph"].length) ? j["@graph"] : [j];
        for (var k = 0; k < liste.length; k++) {
          var n = liste[k];
          if (n && String(n["@type"] || "").indexOf("Product") !== -1 && n.name) {
            return String(n.name).trim();
          }
        }
      }
    } catch (e) {}
    return "";
  }

  //: MÅLT 27/08 på `/products/viscose-jersey-r`, alle tre til stede og enige:
  //:   og:title  = "RØD VISKOSE JERSEY – BLØD, ÅNDBAR & STRÆKBAR"
  //:   JSON-LD   = samme streng
  //:   <h1>      = samme streng (med et efterstillet linjeskift, derfor .trim())
  //: Rækkefølgen er efter troværdighed: de to første er strukturerede felter,
  //: <h1> er en visuel overskrift, der kan bære andet end varenavnet.
  //: ⚠ `/collections/<x>/products/<y>` er en LEVENDE sti på husets shops - huset
  //:   målte 26/08, at temaerne netop linker den kollektions-scopede form. Derfor
  //:   matcher mønstret `/products/` hvor som helst i stien, og `url` normaliseres
  //:   til den bare produktsti, som er den, bagenden kan slå op.
  function laesAktivSide() {
    if (currentProductTitle) {
      var mm = PRODUKT_STI.exec(String(currentProductUrl || location.pathname));
      return {
        handle: mm ? decodeURIComponent(mm[1]) : "",
        titel: currentProductTitle,
        url: mm ? "/products/" + mm[1] : (currentProductUrl || ""),
        type: "produkt"
      };
    }
    var m = PRODUKT_STI.exec(location.pathname);
    if (m) {
      var handle = "";
      try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; }
      var titel = metaIndhold('meta[property="og:title"]') || jsonLdProduktNavn();
      if (!titel) {
        var h1 = document.querySelector("h1");
        titel = h1 ? String(h1.textContent || "").trim() : "";
      }
      if (!handle && !titel) return null;
      return { handle: handle, titel: titel, url: "/products/" + m[1],
               type: "produkt" };
    }
    // ⭐ KOLLEKTIONSSIDEN. ⚠ JSON-LD prøves IKKE her: en kollektionsside bærer
    //   typisk `ItemList`/`CollectionPage`, og `jsonLdProduktNavn()` leder
    //   udtrykkeligt efter `Product`. Den ville derfor kunne returnere den
    //   FØRSTE vare i gitteret som «den side kunden står på» — en vare, kunden
    //   måske aldrig har set på. Kun `og:title` og `<h1>`, som begge er sidens
    //   egen overskrift.
    var k = KOLLEKTION_STI.exec(location.pathname);
    if (!k) return null;
    var khandle = "";
    try { khandle = decodeURIComponent(k[1]); } catch (e) { khandle = k[1]; }
    if (KOLLEKTION_UDELAD.indexOf(khandle.toLowerCase()) !== -1) return null;
    var ktitel = metaIndhold('meta[property="og:title"]');
    if (!ktitel) {
      var kh1 = document.querySelector("h1");
      ktitel = kh1 ? String(kh1.textContent || "").trim() : "";
    }
    if (!khandle && !ktitel) return null;
    // ⛔ `type` SKELNER, OG DET ER IKKE KOSMETIK. Uden feltet ville bagenden
    //   få et handle i `aktiv.handle` og slå det op som et PRODUKT — og en
    //   kollektions handle findes ikke som vare. Botten ville da svare «den
    //   vare kender jeg ikke» om en side, kunden står på.
    // ⚠ Kollektionen kommer IKKE i `historik`: `noterBesoegtVare` kræver et
    //   handle OG gemmer det som en set VARE. En kollektion blandet ind dér
    //   ville blive læst som et produkt, kunden har kigget på.
    return { handle: khandle, titel: ktitel, url: "/collections/" + k[1],
             type: "kollektion" };
  }

  // ⛔ HISTORIKKEN GEMMER KUN handle OG titel. Ikke pris, ikke lager, ikke
  //   billede, ikke tidspunkt pr. vare, intet personhenførbart. Det er
  //   udtrykkeligt afgrænset i briefen, og afgrænsningen står HER, hvor posten
  //   bliver til - ikke kun i et dokument ved siden af.
  // ⚠ Nyeste først, og en gentagelse af samme vare flytter den op i stedet for
  //   at fylde en plads. Ellers ville fire besøg på samme vare tømme historikken
  //   for indhold.
  function noterBesoegtVare(aktiv) {
    // ⛔ 10/09: KUN VARER. `laesAktivSide` kender nu også kollektionssider, og
    //   en kollektions handle i «nyligt besete varer» ville blive slået op som
    //   et produkt, der ikke findes — botten ville sige «den vare kender jeg
    //   ikke» om noget, kunden aldrig kaldte en vare.
    if (!aktiv || !aktiv.handle || aktiv.type !== "produkt") return;
    var t = gemtTilstand();
    var hist = (ventendeHistorik || t.historik).filter(function (p) { return p.handle !== aktiv.handle; });
    hist.unshift({ handle: aktiv.handle, titel: aktiv.titel || "" });
    hist = hist.slice(0, HISTORIK_MAKS);
    if (!lagerFrigivet) { ventendeHistorik = hist; return; }
    ventendeHistorik = null;
    gemTilstand(t.session, hist);
  }

  // WA-hotfix: kaldes ved kundens egen handling (åbning, første besked,
  // billede/kontakt). Skriver den ventende historik ÉN gang; derefter
  // skriver alt som før.
  function frigivLager() {
    if (lagerFrigivet) return;
    lagerFrigivet = true;
    if (!ventendeHistorik) return;
    var h = ventendeHistorik;
    ventendeHistorik = null;
    gemTilstand(gemtTilstand().session, h);
  }

  // Kontrakten mod bagenden, ordret som lederen har låst den:
  //   kontekst = {"aktiv": {handle, titel, url} | null,
  //               "historik": [ {handle, titel}, ... ]}   # højst 4, nyeste først
  // ⚠ Den AKTIVE vare må ikke også stå i historikken - så ville botten se den
  //   samme vare to gange og kunne tro, at kunden har sammenlignet den med sig
  //   selv.
  function byggKontekst() {
    var aktiv = laesAktivSide();
    var hist = ventendeHistorik || gemtTilstand().historik;
    // ⚠ Kun en VARE kan stå i historikken, så kun en vare kan filtreres ud af
    //   den. En kollektion med samme handle som et produkt findes ikke.
    if (aktiv && aktiv.handle && aktiv.type === "produkt") {
      hist = hist.filter(function (p) { return p.handle !== aktiv.handle; });
    }
    hist = hist.slice(0, HISTORIK_MAKS).map(function (p) {
      return { handle: p.handle, titel: p.titel || "" };
    });
    if (!aktiv && !hist.length) return null;
    return { aktiv: aktiv || null, historik: hist };
  }

  // ---------- DOM-referencer ----------
  var launcher = root.querySelector(".gmchat-launcher");
  var panel = root.querySelector(".gmchat-panel");
  var closeBtn = root.querySelector(".gmchat-close");
  var body = root.querySelector(".gmchat-body");
  var introEl = root.querySelector(".gmchat-intro");
  var suggestionsEl = root.querySelector(".gmchat-suggestions");
  var logEl = root.querySelector(".gmchat-log");
  var humanLink = root.querySelector(".gmchat-human-link");
  var contactSection = root.querySelector(".gmchat-contact");
  var contactForm = root.querySelector("#gm-chat-contact");
  var contactSubmit = contactSection ? contactSection.querySelector(".gmchat-submit") : null;
  var contactMessageField = contactSection ? contactSection.querySelector("[name='contact[body]']") : null;
  // ⛔⛔ R2, 05/09/2026 — SEND-KNAPPEN BLEV LAAST OG BLEV DET ALDRIG ANDET.
  //   Submit-handleren nederst i filen satte `disabled = true` + «Sender…».
  //   `grep` gav 0 hits paa `disabled = false` og 0 paa `pageshow`: der fandtes
  //   INGEN vej tilbage i hele filen.
  //   MAALT 04/09 paa 390x844, tre veje - alle tre endte med en doed knap
  //   (`disabled=true`, teksten «SENDER…», opacitet 0,6, `cursor:not-allowed`):
  //     1. afbrudt afsendelse (submit fyret, navigationen skete aldrig)
  //     2. to hurtige klik
  //     3. kunden lukker panelet og aabner det igen
  //   Paa en ALMINDELIG side (uden `form.errors`) er fejlboksen 0x0 og usynlig,
  //   saa mailto/tel er der ikke - kunden staar med NUL udveje paa skaermen.
  //   Det er ordret CEO's laaste krav 03/09: «Kunden maa aldrig efterlades i
  //   en blindgyde.»
  // ⇒ TRE GREB, fordi de tre veje ikke rammes af ét:
  //     a) et tidsrum: er vi stadig paa siden efter `SEND_GENDAN_MS`, skete
  //        navigationen ikke, og knappen gendannes. (Navigerer siden, doer
  //        timeren med siden - den kan altsaa ikke fyre «for sent».)
  //     b) `pageshow`: bfcache giver kunden PRAECIS den DOM hun forlod, med
  //        knappen laast. `pageshow` er den ENESTE haendelse, der fyrer paa en
  //        bfcache-genskabelse - `load` goer det ikke.
  //     c) hver overgang til en tilstand, hvor formularen SES
  //        (`saetKontaktTilstand`), frigiver knappen. Det er vej 3.
  // ⚠ SIG HOEJT HVAD DET KOSTER: gendannes knappen mens en langsom POST
  //   stadig er undervejs, kan kunden trykke igen og sende sagen TO gange.
  //   Retningen er valgt bevidst: to mails er en irritation for os, en doed
  //   knap er en blindgyde for hende. `SEND_GENDAN_MS` er sat saa hoejt, at
  //   en normal afsendelse for laengst har navigeret.
  // ⚠ ETIKETTEN LAESES FOER VI ROERER DEN. Den kommer fra `gmchat.send` i
  //   temaets locales og er dermed allerede paa kundens sprog; havde vi
  //   hardkodet en tekst her, ville vi indfoere praecis den danske streng paa
  //   SE/NO, som G1 samme dag fjerner.
  var sendKnapEtiket = contactSubmit ? String(contactSubmit.textContent || "") : "";
  var sendGendanTimer = null;
  var SEND_GENDAN_MS = 8000;

  function frigivSendKnap() {
    if (sendGendanTimer) { clearTimeout(sendGendanTimer); sendGendanTimer = null; }
    // ⛔⛔ LAASEN OG «ÉN INDSENDELSE AD GANGEN» DOER SAMMEN (11/09).
    //   Se `indsendelseIGang` i kontaktafsnittet: spaerren maa vare PRAECIS
    //   saa laenge knappen er doed - hverken kortere (saa var den ingen
    //   spaerre) eller laengere (saa var en frigivet knap en blindgyde).
    //   ⚠ FOER `if (!contactSubmit) return;`: mangler knappen, skal spaerren
    //     ALLIGEVEL loeftes, ellers kunne én indsendelse laase fladen for evigt
    //     paa en flade uden den knap.
    indsendelseIGang = false;
    if (!contactSubmit) return;
    contactSubmit.disabled = false;
    // ⛔ G2 (06/09): igangs-signalet doer sammen med laasen. `removeAttribute`
    //   og ikke `= "false"`: knappen skal ende PRAECIS i den tilstand, den
    //   havde foer klikket — en tilstandsmelding, der bliver staaende som
    //   «false», er stoej i skaermlaeserens traeoversigt og en byte-forskel,
    //   ingen proeve kan retfaerdiggoere.
    contactSubmit.removeAttribute("aria-busy");
    if (sendKnapEtiket) contactSubmit.textContent = sendKnapEtiket;
  }
  var statusOk = root.querySelector(".gmchat-status--ok");
  var statusFejl = root.querySelector(".gmchat-status--fejl");
  var searchInput = root.querySelector(".gmchat-search-input");
  var searchForm = root.querySelector(".gmchat-search-form");

  var lastFocused = null;

  // ⛔ RETTET 21/08 (P0.5): Escape lukkede panelet korrekt, men fokus landede
  // paa <body> i stedet for paa launcheren - MAALT direkte: `lastFocused =
  // document.activeElement` blev kaldt FOER panelet selv flytter fokus ind,
  // saa den fanger hvad der var aktivt UMIDDELBART FOER aabningen. For en
  // rigtig museklik er det launcheren selv (fokus saettes paa mousedown, FOER
  // click-handleren koerer) - men findes intet aktivt element paa det
  // tidspunkt (fx et allerede-blurret dokument), er det <body>. `body.focus()`
  // er ikke en fejl i sig selv - det goer PRAECIS hvad der blev bedt om - men
  // <body> er ikke et meningsfuldt sted at lande fokus for en kunde. Et
  // gyldigt maal er et rigtigt, tilstedevaerende, fokuserbart element - aldrig
  // dokumentets rod.
  function erGyldigtFokusMaal(el) {
    return !!el && el !== document.body && el !== document.documentElement &&
      typeof el.focus === "function" && document.contains(el);
  }

  // ---------- Åbn/luk ----------
  function openPanel(context) {
    try { frigivLager(); } catch (e) {}
    // ⛔⛔ 04/09 (R6): TILSTANDEN HUSKES FOER, OG GENSKABES EFTER.
    //   Her stod `hideContact()` i den ene gren, og den anden gren kaldte
    //   `renderIntro()`, som goer det samme. Begge veje kollapsede altsaa
    //   kontaktomraadet ved HVER aabning. MAALT: kunden faar en fejl, lukker
    //   chatten et sekund, aabner igen - fejltekst og udfyldte felter vaek.
    //   Panelet maa gerne bygge sin intro op paany; det maa bare ikke smide
    //   den tilstand vaek, kunden stod i.
    var huskTilstand = kontaktTilstand;
    var foerAabning = document.activeElement;
    lastFocused = erGyldigtFokusMaal(foerAabning) ? foerAabning : null;
    panel.hidden = false;
    launcher.setAttribute("data-open", "true");
    panel.setAttribute("aria-hidden", "false");
    if (!harEksisterendeSamtale()) {
      // ⛔ RETTET 21/08 (P0.3): samtalen skal IKKE rives ned igen, bare fordi
      // panelet genaabnes - se noten ved harEksisterendeSamtale().
      renderIntro(context || null);
    } else {
      // ⭐ GENOPTAGET SAMTALE. `renderIntro` koerer med vilje IKKE her, saa
      //   klassen ville aldrig blive sat ad den vej - og en kunde, der vender
      //   tilbage til en igangvaerende samtale, ville faa velkomsten tilbage
      //   oeverst. Det er netop den tilstand, roden maalte.
      opdaterSamtalePlads();
    }
    // ⛔ ALTID til sidst: `renderIntro()` kalder selv `hideContact()`, saa
    //   genskabelsen skal ske EFTER den - ellers vinder nedrivningen igen.
    saetKontaktTilstand(huskTilstand);
    var firstFocusable = panel.querySelector("button, [href], input, textarea, select");
    if (firstFocusable) firstFocusable.focus();
    document.addEventListener("keydown", onKeydown, true);
  }

  function closePanel() {
    panel.hidden = true;
    launcher.setAttribute("data-open", "false");
    panel.setAttribute("aria-hidden", "true");
    document.removeEventListener("keydown", onKeydown, true);
    // ⛔ Samme tjek igen ved LUKNING, ikke kun ved AABNING: DOM'et kan i
    // mellemtiden have aendret sig under den (fx et element der ikke laengere
    // findes). "Vi stoler ikke, vi tjekker" - to gange er billigere end én
    // kunde, der mister sin plads paa siden.
    if (erGyldigtFokusMaal(lastFocused)) lastFocused.focus();
    else launcher.focus();
  }

  function onKeydown(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      // ⛔ RETTET 21/08 (P0.5) — DEN RIGTIGE rodårsag, fundet empirisk, ikke
      // gaettet: `closePanel()` satte fokus KORREKT paa launcheren (bekraeftet
      // direkte i browseren) - men fordi denne lytter aldrig stoppede
      // haendelsen i at fortsaette, naaede den samme Escape-tastetryk ogsaa
      // TEMAETS EGEN globale Escape-handler (Impulse-temaer lukker typisk
      // kurv/soeg/menu-drawere paa Escape) - som saa selv flyttede fokus
      // videre til <body> BAGEFTER os. `preventDefault()` sluk kun
      // BROWSERENS egen standardhandling; den stopper IKKE andre lytteres
      // JS. MAALT: fjernes forplantningen (stopPropagation), lander fokus
      // korrekt paa launcheren hver gang - uden det, gaar den til <body> i
      // 2/2 forsoeg, ogsaa med et AEGTE museklik.
      e.stopPropagation();
      closePanel();
      return;
    }
    if (e.key === "Tab") {
      trapFocus(e);
    }
  }

  // Fokusfælde: Tab/Shift+Tab cirkler INDENFOR panelet, aldrig ud på resten af siden
  function trapFocus(e) {
    var focusables = panel.querySelectorAll(
      "button:not([disabled]), [href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])"
    );
    if (!focusables.length) return;
    var list = Array.prototype.slice.call(focusables).filter(function (el) {
      return el.offsetParent !== null; // kun synlige elementer
    });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // ---------- T3E (06/10/2026): launcher-pille «Spørg om stof» + anonym åbningstælling ----------
  // Pillen er kun TEKST oven på den eksisterende knap (ikonet og det skjulte navn står uændret). Teksten vælges af
  // sidens sprog (`<html lang>`); et sprog uden tekst her får den gamle ikonknap, aldrig en forkert tekst. SE/NO er
  // klargjort, men kun DK-temaet får denne fil i dag.
  // ⛔ TÆLLINGEN: ÉN `sendBeacon` til `/aabnet` (aldrig fetch med credentials), kun ved kundens EGET klik på launcheren
  //   (`isTrusted`: et script-kald til `launcher.click()`, genoptagelse og enhver automatisk åbning tæller ikke), højst
  //   ÉN gang pr. sidevisning (modulvariabel, intet lager). Ingen krop, ingen cookie-skrivning, intet lagret i browseren,
  //   intet id: serveren tæller +1 på (dag, shop, flade) udledt af Shopifys signerede query.
  var PILLE_TEKST = {
    sv: { lang: "Fråga om tyg", kort: "Fråga" }
  };
  var aabnetSendt = false;
  (function byggPille() {
    try {
      var sprog = String((document.documentElement && document.documentElement.lang) || "").toLowerCase().slice(0, 2);
      var tk = Object.prototype.hasOwnProperty.call(PILLE_TEKST, sprog) ? PILLE_TEKST[sprog] : null;
      if (!tk || launcher.querySelector(".gmchat-launcher-label")) return;
      var etiket = document.createElement("span");
      etiket.className = "gmchat-launcher-label";
      var lang = document.createElement("span");
      lang.className = "gmchat-launcher-lang";
      lang.textContent = tk.lang;
      var kort = document.createElement("span");
      kort.className = "gmchat-launcher-kort";
      kort.textContent = tk.kort;
      etiket.appendChild(lang);
      etiket.appendChild(kort);
      var ikon = launcher.querySelector(".gmchat-launcher-icon");
      if (ikon && ikon.nextSibling) launcher.insertBefore(etiket, ikon.nextSibling);
      else launcher.appendChild(etiket);
      launcher.className = launcher.className + " gmchat-launcher--pille";
    } catch (e) { /* uden pille: den gamle ikonknap */ }
  })();

  function taelAabning(e) {
    try {
      if (aabnetSendt || !e || e.isTrusted !== true) return;
      var url = apiSti("/aabnet");
      if (!url) return;                       // FAQ-tilstand (ingen endpoint): intet at tælle
      aabnetSendt = true;
      var sendt = false;
      try { sendt = !!(navigator.sendBeacon && navigator.sendBeacon(url)); } catch (e1) { sendt = false; }
      if (!sendt && typeof fetch === "function") {
        fetch(url, { method: "POST", keepalive: true, credentials: "omit" }).catch(function () {});
      }
    } catch (e2) { /* en tæller må aldrig forhindre åbningen */ }
  }

  launcher.addEventListener("click", function (e) {
    skjulHilsen();
    taelAabning(e);
    openPanel(null);
  });
  closeBtn.addEventListener("click", closePanel);

  // ---------- Hilsenen ----------
  // Laert af Clerks chat paa live-shoppen (maalt 21/08): en lille boble over
  // knappen, der siger hvad chatten er til. Den inviterer uden at overtage
  // skaermen, og den kan lukkes.
  // ⛔ VI GEMMER IKKE, AT DEN ER LUKKET. Widget'en maa intet lagre i browseren
  // foer samtykke (§7.4), og en hilsen er ikke vaerd at bruge et samtykke paa.
  // I stedet: vises én gang pr. sidevisning, skjuler sig selv igen, og kommer
  // aldrig tilbage i samme besoeg. Ingen localStorage, ingen cookie.
  var hilsen = root.querySelector(".gmchat-hilsen");
  var hilsenBrugt = false;

  function skjulHilsen() {
    hilsenBrugt = true;
    if (hilsen) hilsen.hidden = true;
  }

  // ⭐⭐ 10/09: «ÉN GANG PR. BESØG» — LØST UDEN AT RØRE SAMTYKKEREGLEN.
  //
  // ⛔ RAMMEN FØRST, FOR DEN ER DEN BINDENDE. §7.4: widget'en må intet lagre i
  //   browseren FØR samtykke, og hilsenen kommer før kunden har rørt noget.
  //   *«En hilsen er ikke værd at bruge et samtykke på.»* Enhver løsning med
  //   `localStorage`, `sessionStorage`, cookie — eller `window.name`, som er
  //   det samme i forklædning — er derfor udelukket. Ikke som en smagssag:
  //   som en regel.
  //
  // ⛔ PROBLEMET, MÅLT: `hilsenBrugt` er kun en sidevariabel. Klikkede kunden
  //   hilsenen væk og navigerede videre, kom den igen på næste side, og igen
  //   på den næste. Planen af 10/09 forbyder netop det: *«Ingen automatisk
  //   åbning, gentagne popups eller beskeder om at kunden bliver fulgt.»*
  //
  // ⇒ LØSNINGEN ER ET SIGNAL, BROWSEREN GIVER OS I FORVEJEN: `document.referrer`.
  //   Kom kunden hertil fra vores EGET domæne, er dette ikke besøgets første
  //   side — så har hun med overvejende sandsynlighed allerede set hilsenen,
  //   og den vises ikke igen. Kom hun udefra (eller uden referrer), er det
  //   besøgets begyndelse, og hilsenen vises ÉN gang.
  //   Ingen lagring, ingen cookie, intet at samtykke til.
  //
  // ⚠ SIG HØJT HVAD DEN IKKE KAN — dette er en tilnærmelse, ikke en tæller:
  //   · Lander kunden udefra på side 2 af sit besøg, får hun hilsenen dér.
  //   · Åbner hun et produkt i en NY fane, er referreren vores egen ⇒ ingen
  //     hilsen i den fane. (Ønsket retning: hellere for få end for mange.)
  //   · Er referreren strippet af en `Referrer-Policy` eller en privatlivs-
  //     browser, ser vi «udefra» ⇒ hilsenen kan komme igen. Dét er den ene
  //     tilstand, hvor gentagelsen stadig kan ske, og den er prisen for ikke
  //     at lagre noget.
  //   · Trykker kunden BACK, er referreren typisk vores egen ⇒ ingen gentagelse.
  //   Alle fire fejler mod FÆRRE invitationer, ikke flere. Det er den rigtige
  //   retning for netop denne funktion.
  function erFoersteSideIBesoeget() {
    var r = "";
    try { r = String(document.referrer || ""); } catch (e) { r = ""; }
    if (!r) return true;                       // direkte, bogmærke, ukendt
    var v;
    try { v = new URL(r); } catch (e) { return true; }
    // ⛔⛔ SAMME OPRINDELSE — IKKE «ET AF HUSETS DOMÆNER». RETTET 10/09 EFTER
    //   ET RØDT BROWSERBEVIS, ikke efter en gennemlæsning.
    //   Her stod `erEgetVaertsnavn(v.hostname)`. Den funktion findes til noget
    //   ANDET: at afgøre, om en URL, MODELLEN har skrevet, må blive klikbar —
    //   og den kender derfor kun husets fem PRODUKTIONSDOMÆNER.
    //   MÅLT i fixturen: på enhver anden vært end de fem — testtemaets
    //   `*.myshopify.com`, en preview-URL, en lokal fixture — læste den hver
    //   intern navigation som «kunden kom udefra», og hilsenen kom igen på
    //   HVER side. Altså præcis den gentagelse, planen forbyder, på alle de
    //   flader hvor vi selv prøver widget'en af.
    //   ⇒ Spørgsmålet er ikke «er dette et af husets domæner», men «kom kunden
    //     fra den side, hun står på nu». Det svar hedder samme oprindelse.
    //   ⚠ Og det er strengere, ikke løsere: en anden af husets shops (DK → SE)
    //     er en anden oprindelse og dermed et NYT besøg — hvilket er rigtigt,
    //     for det er en anden butik med sin egen chat.
    return v.origin !== location.origin;
  }

  // ⭐ RELEVANS (planen 10/09): *«Diskrete, relevante invitationer på produkt-/
  //   kollektionssider er tilladt.»* Ordet er «relevante», og en invitation på
  //   forsiden eller i kurven er ikke relevant — den er bare en popup.
  //   ⇒ Hilsenen vises KUN, hvor `laesAktivSide()` faktisk kender siden.
  function hilsenErRelevant() {
    var s = null;
    try { s = laesAktivSide(); } catch (e) { s = null; }
    return !!(s && s.titel);
  }

  if (hilsen) {
    var hilsenLuk = hilsen.querySelector(".gmchat-hilsen-luk");
    var hilsenTekst = hilsen.querySelector(".gmchat-hilsen-tekst");
    if (hilsenLuk) hilsenLuk.addEventListener("click", skjulHilsen);
    if (hilsenTekst) {
      hilsenTekst.addEventListener("click", function () {
        skjulHilsen();
        openPanel(null);
      });
    }
    // ⚠ Respekterer `prefers-reduced-motion` ved at komme UDEN animation, ikke
    //   ved at udeblive - beskeden er indhold, ikke effekt.
    window.setTimeout(function () {
      // Aabnede kunden allerede chatten, skal hilsenen ikke dukke op bagefter.
      // ⛔ OG HAR HUN EN SAMTALE I GANG, ER HUN IKKE EN, DER SKAL INVITERES.
      //   `sessionId` er sat af Init'ens `genoptag`, når serveren bekræfter en
      //   levende samtale — så er invitationen i bedste fald overflødig og i
      //   værste fald en besked om, at vi følger hende.
      if (!hilsenBrugt && panel.hidden && !sessionId &&
          erFoersteSideIBesoeget() && hilsenErRelevant()) {
        hilsen.hidden = false;
        window.setTimeout(function () {
          if (!hilsenBrugt) hilsen.hidden = true;
        }, 12000);
      }
    }, 3500);
  }

  // ---------- "Spørg om dette stof" — delegeret lytter, virker uanset hvor på siden knappen sidder ----------
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest ? e.target.closest("[data-gmchat-open]") : null;
    if (!trigger) return;
    e.preventDefault();
    if (trigger.dataset.gmchatOpen === "product") {
      currentProductTitle = trigger.dataset.gmchatProductTitle || null;
      currentProductUrl = trigger.dataset.gmchatProductUrl || null;
      openPanel("product");
    } else {
      openPanel(null);
    }
  });

  // ---------- Første besked: KONKRET, tre forslagsknapper — ikke "hvordan kan jeg hjælpe?" ----------
  // FORMODNING: rækkefølgen af de tre generelle knapper er IKKE en målt rangering af de 37
  // ikke-produktrelaterede samtaler i grundlaget (kun at produkt = 89/126 er målt, spor-a-design.md).
  // Designvalg, ikke datapåstand.
  var GENERELLE_FORSLAG = [
    { tekst: t("forslag1"), faqId: "K-01" },
    { tekst: t("forslag2"), faqId: "K-21" },
    { tekst: t("forslag3"), faqId: "K-16" }
  ];

  // ⭐ TILFØJET 26/08 — DEN FJERDE CHIP: en indgang til ordreopslag.
  // MAALT samme dag paa den levende bagende: paa «Hvor er min ordre?» svarer
  // botten «Hvis du oplyser dit ordrenummer og den e-mailadresse, du brugte ved
  // bestillingen, slår jeg den gerne op» - og saa skal kunden selv gaette, at
  // BEGGE dele skal med i samme linje. `min_ordre(nummer, mail)` kraever begge
  // (CEO-beslutning 3, 14/08). Der fandtes ingen indgang til ordreopslag blandt
  // de tre chips (levering / retur / stofproeve).
  // ⚠ Fire chips er praecis paa graensen for, hvad et menneske overskuer paa én
  //   gang (arbejdshukommelse ≤4). Der maa ikke komme en femte uden at en anden
  //   gaar ud.
  // ⚠ `tv()` og ikke `t()`: mangler noeglen paa en ikke-dansk shop, udebliver
  //   chippen helt frem for at vise et noeglenavn. Se noten ved `tv()`.
  // ⛔ ROED HAT 26/08, G2: `apiEndpoint` SKAL med i gaten. Toemmes endepunktet -
  //   husets dokumenterede NOEDSTOP - stod chippen der stadig, kunden afgav
  //   ordrenummer OG mailadresse, og indsendelsen ramte `spoergBotten` paa det ene
  //   kaldested uden endepunkts-gate. `fetch("")` rammer siden selv og kaster.
  //   Kunden havde da afgivet persondata til ingenting, og noedstoppet gjorde
  //   fladen RINGERE end foer. Et noedstop skal degradere nedad, aldrig sidelaens.
  if (apiEndpoint && tv("forslag-ordre")) {
    GENERELLE_FORSLAG.push({ tekst: tv("forslag-ordre"), ordre: true });
  }

  var PRODUKT_FORSLAG = [
    { tekst: t("pforslag1"), eskalerer: true },
    { tekst: t("pforslag2"), eskalerer: true },
    { tekst: t("pforslag3"), faqId: "K-16" }
  ];

  // ⛔ TILFØJET 21/08 (P0.3): `renderIntro` rev body/log ned ved HVER
  // aabning af panelet, selvom server-sessionen (`sessionId`) levede videre.
  // Kunden oplevede en bot, der glemte hende, netop naar hun havde brugt tid
  // paa at forklare sig. Samtalen skal blive staaende, saa laenge SIDEN gør
  // det (samme regel som serverens session) - UDEN at noget gemmes i
  // browseren (§7.4: intet i storage foer samtykke). Loesningen er derfor
  // ikke lagring, men at LADE VAERE med at rive den ned igen: `logEl` er den
  // samme DOM-node hele scriptets levetid, og saa laenge `renderIntro` ikke
  // kaldes en gang til, staar dens indhold uroert.
  function harEksisterendeSamtale() {
    return !!logEl.querySelector(".gmchat-msg");
  }

  //: ⭐⭐ FØRSTE SKÆRM GIVER PLADS, NÅR SAMTALEN ER I GANG (UX-handoff punkt 2).
  //:   Roden målte 10/09 i browser: *«Start-FAQ og velkomst bliver stående OVER
  //:   samtalen.»* Det er målt rigtigt, og det er værst på mobil, hvor de to
  //:   elementer æder den plads, svarene skal læses i.
  //:   Mekanismen fandtes halvt: `renderIntro` springes over ved GENÅBNING af
  //:   panelet (`openPanel`), men der var intet, der gav plads MIDT i en
  //:   samtale — intro og forslag blev liggende øverst, uanset hvor mange
  //:   beskeder der kom nedenunder.
  //:
  //: ⛔ DE FORSVINDER IKKE — DE VIGER. Handoff'en er eksplicit: *«Bevar
  //:   ordre/levering/retur som hjælpetilgængelighed.»* Velkomsttekstens job er
  //:   udført, når kunden HAR skrevet (den præsenterer botten og bliver sagt én
  //:   gang — se `intro_generel`s note i `udrul_tema.py`), så den trækker sig
  //:   helt. Forslagsknapperne er kundens genvej til ordre, levering og retur og
  //:   bliver derfor ved med at være der, men som én kompakt, vandret rullende
  //:   række i stedet for en blok. Ingen knap fjernes, ingen bliver
  //:   utilgængelig, og tastaturvejen er uændret.
  //:
  //: ⛔ INGEN NY TEKSTNØGLE OG INGEN NY KNAP. En «vis mere»-udvider ville kræve
  //:   en etiket, altså en ny `data-t-*` i `.liquid` — som et andet spor ejer.
  //:   Derfor bærer CSS'en hele forskellen, og JS'en sætter ÉT klassenavn.
  //: ⚠ ÉN SANDHED STYRER DEN: indeholder loggen en besked? Derfor er funktionen
  //:   idempotent og kaldes fra hvert sted, hvor det svar kan ændre sig —
  //:   aldrig som en `toggle`, der kan komme ud af trit med DOM'et.
  //: ⛔ INTET LAGRES. §7.4 (intet i storage før samtykke) er uberørt: tilstanden
  //:   læses af DOM'et hver gang og overlever med vilje ikke et sideskift.
  function opdaterSamtalePlads() {
    if (!body) return;
    if (harEksisterendeSamtale()) body.classList.add("gmchat-body--samtale");
    else body.classList.remove("gmchat-body--samtale");
  }

  function renderIntro(context) {
    body.innerHTML = "";
    logEl.innerHTML = "";

    // ⭐ TILFØJET 26/08 — EMNE-MÆRKET: «Du spørger om: <varenavn>».
    // Mekanismen fandtes allerede: klikker kunden «Spørg om dette stof» paa en
    // produktside, gemmer vi `currentProductTitle`/`currentProductUrl`, vaelger
    // en anden aabningstekst og tre produkt-specifikke forslag. **Varenavnet
    // blev bare aldrig vist.** Kunden fik altsaa ingen bekraeftelse paa, at
    // botten ved hvilken vare hun spoerger om - og kunne ikke se det, hvis den
    // vidste noget forkert. Ingen backend-aendring; dataen laa der.
    // ⚠ Bevidst ikke et link (se noten i CSS'en): `bevis_design.sh` kraever
    //   44x44 paa hvert `<a>` i panelet, og maerket er en bekraeftelse - ikke
    //   en navigation. Kunden staar allerede paa varens side.
    if (context === "product" && currentProductTitle) {
      var emne = document.createElement("div");
      emne.className = "gmchat-emne";
      var praefiks = tv("emne-praefiks");
      if (praefiks) {
        var praefiksEl = document.createElement("span");
        praefiksEl.className = "gmchat-emne-praefiks";
        praefiksEl.textContent = praefiks;
        emne.appendChild(praefiksEl);
      }
      var navnEl = document.createElement("span");
      navnEl.className = "gmchat-emne-navn";
      navnEl.textContent = currentProductTitle;
      emne.appendChild(navnEl);
      body.appendChild(emne);
    }

    var intro = document.createElement("p");
    intro.className = "gmchat-intro";
    var forslag;
    if (context === "product" && currentProductTitle) {
      intro.textContent = t("intro-produkt");
      forslag = PRODUKT_FORSLAG;
    } else {
      intro.textContent =
        t("intro-generel");
      forslag = GENERELLE_FORSLAG;
    }
    body.appendChild(intro);

    var suggestionsWrap = document.createElement("div");
    suggestionsWrap.className = "gmchat-suggestions";
    suggestionsWrap.setAttribute("role", "group");
    suggestionsWrap.setAttribute("aria-label", t("aria-forslag"));
    forslag.forEach(function (f) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gmchat-suggestion";
      btn.textContent = f.tekst;
      btn.addEventListener("click", function () {
        // ⭐ ORDRE-CHIPPEN AABNER TO FELTER, den sender ikke fri tekst.
        // Det er hele pointen med den: kunden skal ikke gaette formatet paa en
        // opslagsnoegle, der kraever to dele.
        if (f.ordre) { visOrdreFelter(f.tekst); return; }
        // ⛔ FINDES DER EN BAGENDE, ER DEN SVARET - ogsaa paa et forslag.
        // Ellers ville knapperne give FAQ-tekster, mens fritekst gav bottens
        // svar, og kunden ville faa to forskellige sandheder i samme boble.
        // Widget'ens egen FAQ er RESERVEN, ikke en parallel kilde.
        if (apiEndpoint) { spoergBotten(f.tekst); return; }
        if (f.eskalerer) {
          answerWithEscalation(f.tekst);
        } else {
          answerFromFaq(f.faqId, f.tekst);
        }
      });
      suggestionsWrap.appendChild(btn);
    });
    body.appendChild(suggestionsWrap);
    body.appendChild(logEl);

    // ⛔ SKRIVEFELTET SKAL MED TILBAGE.
    // `renderIntro` starter med `body.innerHTML = ""`, og formularen ligger i
    // Liquid'en INDE i `.gmchat-body`. Den blev derfor revet ud ved hver
    // aabning af panelet - og aldrig sat ind igen.
    // ⚠ MAALT 19/08 med en rigtig browser paa kundens flade: `.gmchat-search-
    // form` fandtes SLET IKKE i DOM'et. Kunden havde tre forslagsknapper og
    // intet sted at skrive. Alle markup-tjek stod groenne, fordi de spurgte om
    // `gmchat-root` var til stede - ikke om man kunne bruge widget'en.
    // ⇒ Et element, der er hentet FOER en innerHTML-nulstilling, lever videre
    //   som en loesrevet node med sine lyttere i behold. Vi saetter den samme
    //   node ind igen; vi bygger ikke en ny, for saa mistede vi lytteren.
    //
    // ⭐ OG DEN SAETTES UDEN FOR `.gmchat-body`, ikke inden i den.
    // Body'en ruller (`overflow-y: auto`). Laa feltet derinde, ville det rulle
    // vaek, saa snart samtalen blev laengere end panelet - og kunden skulle
    // scrolle for at finde det sted, han skal skrive. I en samtale hoerer
    // skrivefeltet fast i bunden. Panelet er en flex-kolonne, saa det er nok
    // at haenge feltet under body'en og over "skriv til et menneske".
    // ⛔ RETTET 21/08 da «skriv til et menneske» blev fjernet. Feltet blev
    // placeret i forhold til DEN knap; uden den faldt koden til
    // `body.appendChild(searchForm)` - altsaa ned I den rullende samtale,
    // praecis den fejl kommentaren ovenfor advarer imod. Feltet haenges nu
    // direkte efter body'en i panelets flex-kolonne, hvor det hoerer hjemme.
    // ⭐ 10/09: FLYTNINGEN STÅR ÉT STED NU (`flytSkrivefeltUdAfBody`), fordi
    //   den også skal ske, når `renderIntro` ALDRIG kører — nemlig når en
    //   genoptaget samtale allerede har beskeder i loggen. To kopier af den
    //   samme flytning ville drive fra hinanden.
    flytSkrivefeltUdAfBody();

    // ⭐ `renderIntro` bygger den TOMME førsteskærm (den rydder selv `logEl`),
    //   så her skal klassen af igen — ellers ville en ny samtale arve den
    //   sammenklappede tilstand fra den forrige.
    opdaterSamtalePlads();

    // ⛔ 04/09: `hideStatus()` stod her ogsaa. Se noten i `openPanel`.
    hideContact();
  }

  // ---------- FAQ-søgning (client-side, ingen backend krævet) ----------
  function loadFaq() {
    if (faqLoaded || !faqUrl) return Promise.resolve();
    return fetch(faqUrl, { credentials: "omit" })
      .then(function (r) {
        if (!r.ok) throw new Error("FAQ-fil svarede " + r.status);
        return r.json();
      })
      .then(function (json) {
        faqEntries = (json && json.emner) || [];
        faqLoaded = true;
      })
      .catch(function () {
        faqEntries = [];
        faqLoaded = false; // ét mislykket forsøg blokerer ikke — prøves igen ved næste søgning
      });
  }

  function findFaqById(id) {
    for (var i = 0; i < faqEntries.length; i++) {
      if (faqEntries[i].id === id) return faqEntries[i];
    }
    return null;
  }

  function searchFaq(query) {
    var q = query.trim().toLowerCase();
    if (!q) return [];
    return faqEntries.filter(function (entry) {
      var ord = entry.soegeord || [];
      for (var i = 0; i < ord.length; i++) {
        if (ord[i].toLowerCase().indexOf(q) !== -1 || q.indexOf(ord[i].toLowerCase()) !== -1) return true;
      }
      return false;
    });
  }

  // ⛔ RETTET 26/08 — EN HAENGENDE FORMULAR MIDT I EN SAMTALE.
  // MAALT i en rigtig 4-turs samtale gennem den levende bagende: efter tur 2
  // eskalerede botten og indsatte `.gmchat-kontakt` i loggen. Kunden skrev
  // videre (tur 3 og 4), og formularen stod stadig KLEMT INDE MELLEM to senere
  // beskeder - `kontaktform_stadig_i_log: true`, 8 bobler i loggen.
  // `visOrdreFelter()` rydder kun sit EGET forrige saet;
  // ingen af dem ved, at samtalen er gaaet videre.
  // ⇒ `addUserMsg` er det ene punkt, ALT passerer, naar kunden siger noget nyt
  //   (`spoergBotten`, `answerFromFaq`, `answerWithEscalation` kalder den alle).
  //   Porten hoerer derfor til her, ikke i hver enkelt vej derhen.
  // ⚠ SAGT HOEJT: skriver kunden videre, mens hun er halvvejs gennem
  //   kontaktfelterne, forsvinder de. Det er det rigtige valg - hun har selv
  //   valgt at gaa videre - og sagen er allerede skrevet paa serversiden af
  //   `eskaler`; felterne BERIGER den, de skaber den ikke.
  function ryddInlineFormularer() {
    var gl = logEl.querySelectorAll(".gmchat-kontakt, .gmchat-ordre");
    for (var i = 0; i < gl.length; i++) gl[i].remove();
  }

  function addUserMsg(text) {
    ryddInlineFormularer();
    var el = document.createElement("div");
    el.className = "gmchat-msg gmchat-msg--user";
    el.textContent = text;
    logEl.appendChild(el);
    // ⭐ SAMTALEN ER I GANG I DET ØJEBLIK, KUNDEN HAR SKREVET — ikke når botten
    //   svarer. Venter vi på svaret, står velkomsten og FAQ'en og fylder under
    //   hele ventetiden, netop hvor hun kigger efter svaret.
    opdaterSamtalePlads();
  }

  // ⛔ RETTET 21/08 (lanceringsblokerende hul): botten kunne ALDRIG give kunden
  // et klikbart link - `addBotMsg` satte altid `textContent`, saa selv en
  // korrekt produkt-URL blev doed tekst. Kunden fik det rigtige svar om et
  // stof og kunne ikke komme videre til varen. Se `tilfoejMedLinks` nedenfor.
  //
  // ⛔⛔ `innerHTML` er FORBUDT her og bliver det ALDRIG: botten skriver ud fra
  // en sprogmodel, og saetter man dens tekst som HTML, er der en XSS-vej lige
  // ind i kundens browser - modellen kan gengive hvad som helst, en kunde selv
  // har skrevet (vaerktoejssvar er data, ikke instruktioner - men prosaen
  // ovenpaa er stadig modellens EGET sprog, ikke en godkendt skabelon, hver
  // eneste gang). Noderne bygges derfor i haanden: teksten splittes i tekst-
  // og link-stykker, og hvert link bliver et RIGTIGT `document.createElement
  // ("a")` med `textContent` - aldrig `innerHTML`, aldrig `insertAdjacentHTML`.
  //: Egne vaerter - SPEJLER `gm_chat/porte.py`s `EGNE_VAERTER` ordret (den
  //: udgaaende ports egen liste over husets domaener, brugt til at afgoere om
  //: en URL i svaret er en fremmed leverandoer-lignende adresse). Kun disse
  //: domaener - og relative stier, som pr. definition deler siden kunden
  //: allerede staar paa - maa blive klikbare. Alt andet forbliver ren tekst,
  //: ellers kunne et injiceret svar sende kunden til en fremmed side.
  var EGNE_VAERTER = [
    "g-m.dk", "gmtextiles.se", "tygeruchtextil.com", "garnogmetervarer.no", "g-merhverv.dk"
  ];

  function erEgetVaertsnavn(host) {
    host = String(host || "").toLowerCase();
    for (var i = 0; i < EGNE_VAERTER.length; i++) {
      var d = EGNE_VAERTER[i];
      if (host === d || host.slice(-(d.length + 1)) === "." + d) return true;
    }
    return false;
  }

  // ⭐ T3H (14/10/2026) — FASTE UTM PÅ ALLE EGNE CHAT-LINKS, ÉT FÆLLES PUNKT.
  //   `egetLinkMaal` er porten for ALLE tre link-steder (prosa-link, «Se varen», forslagsknap), så UTM sættes dér og
  //   ikke tre steder. Præcis `utm_source=gm_chat&utm_medium=chat`: aldrig utm_term/campaign/content/id og aldrig noget
  //   fra samtalen. Eksisterende `utm_*`-parametre droppes (idempotent: sætter serveren dem også, bliver der ingen
  //   dubletter), øvrig query og anker bevares byte for byte. Kaldes kun med et mål, `egetLinkMaal` har godkendt.
  var CHAT_UTM = "utm_source=gm_chat&utm_medium=chat";
  function medChatUtm(adresse) {
    var s = String(adresse);
    var h = s.indexOf("#");
    var anker = h === -1 ? "" : s.slice(h);
    var uden = h === -1 ? s : s.slice(0, h);
    var q = uden.indexOf("?");
    var sti = q === -1 ? uden : uden.slice(0, q);
    var dele = q === -1 ? [] : uden.slice(q + 1).split("&");
    var ud = [];
    for (var i = 0; i < dele.length; i++) {
      if (!dele[i]) continue;
      var navn = dele[i].split("=")[0];
      try { navn = decodeURIComponent(navn); } catch (e) { /* ugyldig procent-kodning: behold som den er */ }
      if (navn.slice(0, 4).toLowerCase() === "utm_") continue;
      ud.push(dele[i]);
    }
    ud.push(CHAT_UTM);
    return sti + "?" + ud.join("&") + anker;
  }

  // Returnerer URL'en, hvis den maa blive et link - ellers null (saa den
  // forbliver almindelig tekst). Relative stier (/products/…, /pages/…) er
  // ALTID egen oprindelse (samme shop kunden allerede er paa) og skal ikke
  // domaene-tjekkes; absolutte URL'er tjekkes mod EGNE_VAERTER via en RIGTIG
  // URL-parsing (aldrig indexOf/includes - en URL som
  // "https://g-m.dk.exempel-ondsindet.dk" indeholder ordret "g-m.dk", men
  // vaertsnavnet er "g-m.dk.exempel-ondsindet.dk", en fremmed adresse).
  // ⛔⛔ R8 (03/09/2026) — «STARTER MED / » ER IKKE DET SAMME SOM «EGEN OPRINDELSE».
  //   Kommentaren ovenfor påstod ordret, at en sti der starter med `/` ALTID er
  //   egen oprindelse. MÅLT i node v22 (WHATWG-URL, samme regler som browseren)
  //   mod netop denne funktions egne bytes:
  //       "//evil.example/x"   → slap igennem → https://evil.example/x
  //       "/\\evil.example/x"  → slap igennem → https://evil.example/x
  //   To tegn efter skråstregen gør stien til en AUTORITET, ikke en sti — og
  //   browseren læser `\` som `/` på den plads. Værnet fejlede altså ÅBENT på
  //   præcis den fejlklasse, dets egen kommentar to linjer over advarer imod
  //   ("aldrig indexOf/includes … værtsnavnet er en fremmed adresse").
  // ⚠ SIG HØJT HVAD DER **IKKE** ER MÅLT: bagenden kan i dag ikke frembringe
  //   nogen af de to former — `Samler._gem_kort` sætter altid `/products/`
  //   foran. Dette er derfor et BÆLTE, ikke en lukning af et set misbrug.
  //   Det koster intet lovligt: en ægte relativ sti begynder aldrig med `//`
  //   eller `/\`.
  function egetLinkMaal(raa) {
    // ⛔ ROED HAT RUNDE 2 (03/09), G4: browseren STRIPPER ASCII tab, LF og
    //   CR FOER den parser en URL. Vaernets `charAt(1)`-kontrol saa derfor det
    //   forkerte tegn. MAALT i node (samme WHATWG-parser som browseren):
    //     "/<TAB>/evil.example/x"  -> SLAP IGENNEM -> https://evil.example/x
    //     "/<LF>/evil.example/x"   -> SLAP IGENNEM
    //     "/<CR>/evil.example/x"   -> SLAP IGENNEM
    //     "/<TAB>\\evil.example/x" -> SLAP IGENNEM
    //   Uopnaaelig i dag (`URL_MOENSTER` taaler ikke whitespace, og
    //   `_gem_kort` saetter altid `/products/` foran) - men vaernet kalder sig
    //   selv «et BAELTE, ikke en lukning», og baeltet havde et hul.
    if (/[\t\n\r]/.test(raa)) return null;
    if (raa.charAt(0) === "/") {
      var t = raa.charAt(1);
      return (t === "/" || t === "\\") ? null : medChatUtm(raa);
    }
    var u;
    try {
      u = new URL(raa);
    } catch (e) {
      return null;
    }
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    if (!erEgetVaertsnavn(u.hostname)) return null;
    return medChatUtm(raa);
  }

  // ⭐ 26/08 runde 2 — OPKALDSLINK, KUN FRA HUSETS EGNE FORSLAG.
  // `chat-konvertering-oejenhoejde.md` fund 2 foreskriver ordret forslaget
  // `{"tekst":"Ring 70 60 59 52","slags":"link","url":"tel:+4570605952"}` som
  // vejen ud af blindgyden. `egetLinkMaal` afviser det korrekt (protokollen er
  // hverken http eller https) og skal BLIVE ved med det: den bruges ogsaa paa
  // modellens egen prosa, hvor et `tel:` aldrig maa kunne opstaa.
  // ⇒ Denne funktion er den snaevre undtagelse, og den kaldes KUN fra
  //   `visNaesteSkridt`, hvor teksterne kommer fra serverens `svar.NAESTE_SKRIDT`
  //   - husets egne, faste strenge. Moenstret tillader `+`, cifre og mellemrum,
  //   4-20 tegn efter `tel:`. Ingen bogstaver, ingen kommaer, intet andet.
  var TEL_MOENSTER = /^tel:\+?[0-9][0-9 ]{3,19}$/;
  function telMaal(raa) {
    var s = String(raa || "").replace(/\s+$/, "");
    return TEL_MOENSTER.test(s) ? s : null;
  }

  // ⭐ 26/08 runde 2 — pilen paa et forslag, der forlader samtalen.
  // Tegnet SVG, stregvaegt 1,8 som fladens oevrige tre ikoner (launcher,
  // send-pil, luk) - ALDRIG en unicode-glyf som «→». `craft-floor`: ikoner
  // tegnes, i én ensartet stregvaegt; en glyf baerer skriftens vaegt, ikke
  // ikonsaettets. `aria-hidden`: knappens navn er dens tekst, og en pil, der
  // laeses op, er stoej for en skaermlaeserbruger.
  function pilIkon() {
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("class", "gmchat-pil");
    svg.setAttribute("viewBox", "0 0 18 18");
    svg.setAttribute("fill", "none");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    var p = document.createElementNS(ns, "path");
    p.setAttribute("d", "M4 9h9M9.5 5l4 4-4 4");
    p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "1.8");
    p.setAttribute("stroke-linecap", "round");
    p.setAttribute("stroke-linejoin", "round");
    svg.appendChild(p);
    return svg;
  }

  // ⭐ 26/08 runde 2 — ROED HAT H2/H3: TASTATURET PAA ORDRENUMMER-FELTET.
  // `inputmode="numeric"` var haardkodet. Rigtigt for DK (`######`), FORKERT
  // for SE (`#####SV`) og B2B (`ER####`) - iOS' numeriske tastatur har hverken
  // bogstaver eller `#`. Ingen port maaler tastaturtype, saa fejlen ville vaere
  // tavs paa den shop, der aabner.
  // ⇒ Vaerdien kommer nu fra `.liquid`-trappen (`gmchat.ordre_inputmode`):
  //   dansk shop uden noeglen -> `numeric` (uaendret adfaerd paa DK i dag),
  //   ethvert andet sprog uden noeglen -> INTET inputmode, altsaa kundens
  //   almindelige tastatur. Den sikre tilstand er default.
  // ⛔ HVIDLISTEN ER IKKE PYNT: vaerdien kommer fra en oversaettelsesfil, som et
  //   menneske redigerer. Uden den kunne en tastefejl skrive vilkaarlig tekst
  //   ind i en DOM-egenskab. Er vaerdien ikke paa listen, saettes INTET - vi
  //   gaetter aldrig paa, hvad der var ment.
  var LOVLIGE_INPUTMODE = ["none", "text", "tel", "url", "email", "numeric", "decimal", "search"];
  function ordreInputmode() {
    var v = tv("ordre-inputmode").toLowerCase().trim();
    return LOVLIGE_INPUTMODE.indexOf(v) !== -1 ? v : "";
  }

  // Matcher enten en absolut http(s)-URL eller en relativ /products/…
  // eller /pages/…-sti. "<" og ">" er bevidst udelukket fra URL-tegnene, saa
  // et forsøg paa at smugle et HTML-tag lige efter en URL (uden mellemrum)
  // ikke traekkes ind i selve linket.
  var URL_MOENSTER = /(https?:\/\/[^\s<>"']+|\/(?:products|pages)\/[^\s<>"']+)/g;

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ RÅ MARKDOWN — CEO'S PUNKT 2                                27/08 v2.2
  // ═══════════════════════════════════════════════════════════════════════════
  // CEO, ordret: *«Ved søgning på "Rød visksoe" svarer botten med rå markdown/
  // stjerner omkring produkttitlerne i store bogstaver (f.eks.
  // `*RØD VISKOSE JERSEY – BLØD, ÅNDBAR & STRÆKBAR*`) … Ingen rå
  // markdown-stjerner eller overdimensionerede tekstblokke.»*
  //
  // ⚠ SAGT HØJT: JEG REPRODUCEREDE IKKE STJERNERNE. Jeg kørte CEO's egen
  //   søgning «Rød visksoe» gennem den levende bagende 27/08 og fik et rent
  //   prosasvar uden ét eneste `*`. Det betyder IKKE, at fejlen ikke findes -
  //   modellen formulerer sig frit, og et enkelt rent svar er en stikprøve, ikke
  //   en modbevisning. CEO har set den; den skal håndteres uanset hvad. Det er
  //   samme klasse som fund 2's spærring, der heller ikke er deterministisk.
  //
  // ⛔ HVORFOR STRIP OG IKKE «RENDER SOM MARKDOWN»: CEO klager over TO ting i
  //   samme sætning - de rå tegn OG «overdimensionerede tekstblokke». En rigtig
  //   markdown-motor ville lave `#`-linjer til overskrifter og gøre problemet
  //   værre. Her fjernes tegnene, og den ENESTE tilbageblevne udmærkelse er
  //   `**dobbelt**` → `<strong>`: samme skriftstørrelse, kun vægt. Ingen ny
  //   størrelse, ingen ny farve, intet der kan råbe.
  // ⛔ INGEN `innerHTML`, hverken her eller nogen andre steder: teksten kommer
  //   fra en sprogmodel. Noderne bygges i hånden, præcis som `tilfoejMedLinks`
  //   allerede gør - markdown-laget arver dermed XSS-værnet uændret.
  // ⚠ RÆKKEFØLGEN ER ET SIKKERHEDSVALG: links udskilles FØRST, og vægt-laget
  //   røres kun ved de stykker, der IKKE er en URL. Ellers ville et handle som
  //   `/products/wt_soft_tulle` få sine understreger læst som kursiv-markører og
  //   blive brækket midt over.

  //: Linje-niveau: overskrifts- og punkttegn. Køres på hele strengen FØR
  //: link-opdelingen, fordi et markør-tegn i starten af en linje aldrig kan være
  //: en del af en URL.
  //: ⚠ `* ` og `- ` i linjestart er et PUNKTTEGN, ikke kursiv. Behandles derfor
  //:   her og fjernes fra vægt-lagets rækkevidde - ellers ville en punktliste
  //:   blive læst som en halv kursivmarkering og æde teksten til næste stjerne.
  var MD_OVERSKRIFT = /^[ \t]{0,3}#{1,6}[ \t]+/;
  var MD_PUNKT = /^([ \t]{0,4})[-*+][ \t]+/;
  function renseLinjeMarkdown(text) {
    var linjer = String(text == null ? "" : text).split("\n");
    for (var i = 0; i < linjer.length; i++) {
      var l = linjer[i];
      l = l.replace(MD_OVERSKRIFT, "");
      l = l.replace(MD_PUNKT, "$1• ");
      linjer[i] = l;
    }
    return linjer.join("\n");
  }

  //: Inline-niveau. Hvert mønster har SAMME form: [1] tegnet FORAN markøren,
  //: [2] selve markøren, [3] indholdet.
  //:
  //: ⛔⛔ «INTET ORDTEGN OMKRING MARKØREN» ER IKKE PYNT — DEN LUKKER EN FEJL,
  //:   JEG SELV BYGGEDE OG FANGEDE VED AT PRØVE DEN AF.
  //:   Første udgave var `/(\*|_)(?=\S)([^\*_\n]*?\S)\1/`. Den læser
  //:   `fabric_weight_gsm` som `fabric` + kursiv(`weight`) + `gsm` og
  //:   renderer **`fabricweightgsm`** — altså en tavs ødelæggelse af en tekst,
  //:   ingen bad om. Botten skriver ikke feltnavne i dag, men den skriver frit,
  //:   og et understregnings-ord er ikke et kantstilfælde, man kan udelukke.
  //:   ⇒ En markør tæller kun, når der hverken står et ordtegn FORAN eller
  //:     EFTER den. Det er standard-markdowns egen regel om `_` inde i ord, og
  //:     her gælder den begge markører.
  //: ⚠ ORDKLASSEN ER DANSK, IKKE `\w`. JavaScripts `\w` er `[A-Za-z0-9_]` og
  //:   indeholder **ikke** æøå. Med `\w` ville «blød_test_» tælle som en
  //:   markør efter et ikke-ordtegn, fordi `ø` regnes som ikke-ord. Klassen er
  //:   derfor skrevet ud med de danske bogstaver.
  //: ⚠ INGEN LOOKBEHIND. `(?<=…)` ville være den korte vej, men den er en
  //:   SYNTAKSFEJL i ældre Safari — og en syntaksfejl i en asset dræber hele
  //:   scriptet ved indlæsning, ikke bare den ene funktion. Tegnet foran
  //:   fanges derfor i en gruppe og skrives ud igen.
  var MD_ORD = "A-Za-z0-9_åäöÅÄÖ";
  var MD_STAERK = new RegExp("(^|[^" + MD_ORD + "])(\\*\\*|__)(?=\\S)([\\s\\S]*?\\S)\\2(?![" + MD_ORD + "])");
  var MD_SVAG   = new RegExp("(^|[^" + MD_ORD + "*])([*_])(?=\\S)([^*_\\n]*?\\S)\\2(?![" + MD_ORD + "])");
  var MD_KODE   = new RegExp("(^|[^" + MD_ORD + "])(`)([^`\\n]+)`");

  // Bygger tekst-noder og `<strong>`-noder. Kaldes KUN med stykker, der
  // beviseligt ikke er en URL.
  function tilfoejTekstMedVaegt(container, text) {
    var rest = String(text == null ? "" : text);
    var vagt = 0;
    while (rest && vagt++ < 400) {
      var mS = MD_STAERK.exec(rest);
      var mV = MD_SVAG.exec(rest);
      var mK = MD_KODE.exec(rest);
      // Vælg den markør, der kommer FØRST i strengen; ved samme position vinder
      // den dobbelte, så `**x**` aldrig læses som `*` + `*x*`.
      var valgt = null, idx = Infinity;
      if (mS && mS.index < idx) { valgt = { m: mS, staerk: true }; idx = mS.index; }
      if (mK && mK.index < idx) { valgt = { m: mK, staerk: false }; idx = mK.index; }
      if (mV && mV.index < idx) { valgt = { m: mV, staerk: false }; idx = mV.index; }
      if (!valgt) break;
      // Alt før markøren PLUS det tegn, mønstret fangede foran den.
      var foer = rest.slice(0, idx) + valgt.m[1];
      if (foer) container.appendChild(document.createTextNode(foer));
      if (valgt.staerk) {
        var st = document.createElement("strong");
        st.textContent = valgt.m[3];
        container.appendChild(st);
      } else {
        container.appendChild(document.createTextNode(valgt.m[3]));
      }
      rest = rest.slice(idx + valgt.m[0].length);
    }
    if (rest) container.appendChild(document.createTextNode(rest));
  }

  // Adskiller tekst og link-stykker og bygger noderne selv - ALDRIG
  // `innerHTML`. `container` er en TOM DOM-node, kalderen selv har oprettet.
  function tilfoejMedLinks(container, text) {
    var sidst = 0, m, raa, hale, maal, a;
    URL_MOENSTER.lastIndex = 0;
    while ((m = URL_MOENSTER.exec(text)) !== null) {
      if (m.index > sidst) {
        tilfoejTekstMedVaegt(container, text.slice(sidst, m.index));
      }
      raa = m[0];
      // Traek slutteren fra, hvis den er almindelig saetningstegnsaetning
      // ("...se https://g-m.dk/products/x." skal ikke laegge punktummet ind
      // i linket).
      hale = "";
      while (raa.length && /[.,;:!?)\]"'>]/.test(raa.charAt(raa.length - 1))) {
        hale = raa.charAt(raa.length - 1) + hale;
        raa = raa.slice(0, -1);
      }
      maal = egetLinkMaal(raa);
      if (maal) {
        a = document.createElement("a");
        a.href = maal;
        a.textContent = raa;
        // Samme fane - kunden er midt i en samtale, en ny fane er en
        // blindgyde tilbage til chatten. rel="noopener": linket er egen
        // shop, men vanen holdes ensartet.
        a.rel = "noopener";
        container.appendChild(a);
      } else {
        container.appendChild(document.createTextNode(raa));
      }
      if (hale) container.appendChild(document.createTextNode(hale));
      sidst = URL_MOENSTER.lastIndex;
    }
    if (sidst < text.length) {
      tilfoejTekstMedVaegt(container, text.slice(sidst));
    }
  }

  function addBotMsg(text) {
    var el = document.createElement("div");
    el.className = "gmchat-msg gmchat-msg--bot";
    el.setAttribute("role", "status");
    // ⭐ 27/08 v2.2: linje-markørerne fjernes FØR link-opdelingen; vægt-laget
    //   ligger inde i `tilfoejMedLinks` og rører kun ikke-URL-stykker.
    tilfoejMedLinks(el, renseLinjeMarkdown(text));
    logEl.appendChild(el);
    // ⛔ RETTET 20/08/2026: her stod `logEl.scrollTop = logEl.scrollHeight`.
    // `.gmchat-log` har ingen fast højde og intet overflow sat - den vokser
    // frit, saa `scrollHeight === clientHeight` altid (maalt 90=90), og
    // linjen var et no-op. Den RIGTIGE scroll-container er `.gmchat-body`
    // (overflow-y:auto, flex:1 1 auto) - det er DEN, der skal have nyt
    // scrollTop, for at et nyt svar rulles i syne uden at kunden selv scroller.
    body.scrollTop = body.scrollHeight;
    // ⭐ 01/09 (Spor 2, opgave A): returnerer boblen, saa en kalder
    //   (`visFeedback`) kan haenge noget PRAECIS under DENNE besked - ikke
    //   bare nederst i loggen, hvor referencen til svaret ville gaa tabt.
    return el;
  }

  function answerFromFaq(faqId, userLabel) {
    addUserMsg(userLabel);
    loadFaq().then(function () {
      var entry = findFaqById(faqId);
      if (entry) {
        var svar = entry.svar || entry.svar_generisk || "";
        if (samplePriceText && faqId === "K-16" && entry.opslag_paakraevet) {
          svar = svar + " " + samplePriceText;
        }
        addBotMsg(svar);
        if (entry.eskalerer_altid) {
          addBotMsg(t("svar-kollega"));
          // ⛔ RETTET 21/08 (P0.6): teksten spurgte "vil du skrive til os?"
          // uden at kontaktformularen nogensinde blev vist - kunden fik et
          // spoergsmaal uden en vej til at svare paa det. Samme moenster som
          // `answerWithEscalation` nedenfor: en saetning, der henviser til
          // formularen, og formularen SKAL foelges ad, altid.
          // B3 30/09 (afg. 204): formular-banneret er fjernet; teksten peger paa telefon/chat.
        }
      } else {
        showNoResult();
      }
    });
  }

  function answerWithEscalation(userLabel) {
    addUserMsg(userLabel);
    addBotMsg(
      t("svar-produkt")
    );
    // B3 30/09 (afg. 204): formular-banneret er fjernet; teksten peger paa telefon/chat.
  }

  function showNoResult() {
    addBotMsg(
      t("svar-intet")
    );
    logSoegningUdenTraeffer();
    // B3 30/09 (afg. 204): formular-banneret er fjernet; teksten peger paa telefon/chat.
  }

  function logSoegningUdenTraeffer() {
    // Sendes IKKE nogen steder i P4 (der findes intet backend at logge til). Feltet står klar til
    // spor B: en ægte session vil poste { type: "soegning-uden-traeffer" } til apiEndpoint.
    // I dag: ingen effekt, ingen lagring — bevidst tomt hook, ikke en løgn om at noget logges.
  }

  // ---------------------------------------------------------------------------
  // SAMTALEN — kun når der FINDES en bagende. Ellers er FAQ-søgningen svaret.
  // ---------------------------------------------------------------------------
  // ⛔ SESSIONEN ER SERVERENS. Vi opfinder aldrig et id; vi husker kun det, som
  // serveren udstedte.
  // ⛔⛔ RETTET 27/08 (v2.2) — HER STOD «kun i denne lukning. Ingen localStorage,
  //   ingen cookie … widget'en er bygget, så den slet ikke kræver samtykke».
  //   Første halvdel er nu FORKERT: CEO's direktiv punkt 4 kræver, at samtalen
  //   overlever et sideskift, og id'et ligger derfor i `sessionStorage` under
  //   nøglen `gmchat_v1`. `localStorage` og cookies bruges fortsat ALDRIG.
  //   ⚠ Sidste halvsætning — «kræver slet ikke samtykke» — er en JURIDISK
  //     påstand, og den er ikke min at føre videre uændret. Den hvilede på, at
  //     der intet blev gemt. `persondata-rammer.md` §D har en skreven undtagelse
  //     netop for dette tilfælde (uigennemsigtigt id · session-levetid · kun til
  //     at parre browseren med samtalen — alle tre er opfyldt her), men ordlyden
  //     i cookiepolitikken er udtrykkeligt CEO's (§57 T5 d/h). Sagen er
  //     afleveret i leverancens §5 og må ikke betragtes som afgjort af denne fil.
  //   ⇒ Ledelsesregel 7: en påstand rettes dér, hvor den står — samme dag den
  //     holder op med at være sand.
  var sessionId = "";
  var venter = false;
  // ⛔ `botSvarTaeller` FJERNET 01/09 (Spor 5, HUL 1 - "en stemme kan lande
  //   paa den forkerte tur"). Her stod en taeller over AI-svar i DENNE
  //   sidevisning, brugt udelukkende til at give `visFeedback` et ordinal.
  //   Netop DÉR laa hullet: taelleren nulstilles til 0 ved hvert sideskift,
  //   mens samtalen (og serverens `tur_nr`) fortsaetter uaendret -
  //   genindlaeste kunden siden midt i en samtale og stemte bagefter, pegede
  //   stemmen paa en AELDRE, aegte tur, og INGEN af de to sider kunne se det
  //   (begge tal var gyldige - serveren kan ikke opdage det).
  //   ⇒ `spoergBotten` bruger nu svarets EGEN `tur_nr` (se `api.py::do_POST`s
  //     sidste `_svar(200, ...)`, tilfoejet netop til dette) - gemt PAA
  //     SELVE BOBLEN, ikke i en sidevisnings-taeller. En taeller ved siden
  //     af, der ikke styrer noget laengere, er kun en faelde for den naeste,
  //     der laeser filen og tror den stadig goer det.

  // ⛔ T3H (15/10/2026): KURV-KOBLINGEN ER FJERNET. SE-widgetten skriver INGEN kurv-attribut, ingen note og ingen markering, og den sender
  //   hverken session-id, hash eller tidspunkt til /cart/*. Det eneste chatten rører i kurven, er kundens egen «læg i kurv»/ret/fjern (`kurvUdfoer`).
  //   Måling sker aggregeret på UTM (`medChatUtm`) - aldrig på en nøgle til samtalen.

  function skriverIndikator(vis) {
    var gl = logEl.querySelector(".gmchat-skriver");
    if (!vis) { if (gl) gl.remove(); return; }
    if (gl) return;
    var el = document.createElement("div");
    el.className = "gmchat-msg gmchat-msg--bot gmchat-skriver";
    // ⚠ Loggen er aria-live="polite". En animeret prik-stribe må ikke læses op
    // som et svar — den er visuel status, ikke indhold.
    el.setAttribute("aria-hidden", "true");
    el.innerHTML = '<span></span><span></span><span></span>';
    logEl.appendChild(el);
    // Samme rettelse som addBotMsg: .gmchat-body er scroll-containeren.
    body.scrollTop = body.scrollHeight;
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ VENTELINJEN — 20 SEKUNDERS TAVSHED ER OGSÅ ET SVAR         26/08 runde 2
  // ═══════════════════════════════════════════════════════════════════════════
  // MAALT i dag paa den levende bagende, fire rigtige ture gennem `/apps/chat`:
  //   tur 1 (spaerret)  >15,8 s og <=20,0 s
  //   tur 2              <=4,2 s
  //   tur 3              4,2-8,5 s
  //   tur 4              8,5-12,7 s
  // `chat-konvertering-oejenhoejde.md` fund 14 maalte over 39 kald: gennemsnit
  // 13,3 s, 12 ture over 15 s, vaerste 28,2 s - og de LANGSOMSTE ture er de
  // spaerrede, altsaa dem kunden alligevel ikke faar et svar paa.
  //
  // ⛔ INGEN CSS OG INGEN TEKST GOER 20 SEKUNDER HURTIGE. Det er bagendens
  //   sag (afleveret som input i leverancens §5). Det fladen KAN, er at holde
  //   kunden i haanden imens - og at goere det uden at love noget.
  // ⚠ Linjen kommer FOERST efter 8 s (fund 14's eget maaltal). En besked om
  //   ventetid paa en tur, der var hurtig, goer turen langsommere at opleve.
  //   Med dagens maalinger ville den have vist sig paa 1 af 4 ture.
  // ⚠ Den er et <p>, IKKE en `.gmchat-msg`. Baade `bevis_kundeflade.sh` og
  //   `bevis_design.sh` taeller bot-svar som
  //   `.gmchat-log .gmchat-msg--bot:not(.gmchat-skriver)` - en ventelinje i den
  //   klasse ville taelle som et SVAR i begge porte og i `buildTransskript()`.
  // ⚠ `role="status"` og IKKE `aria-hidden` som skriveindikatoren: tre
  //   animerede traade er visuel status, men en saetning er indhold - en
  //   skaermlaeserbruger er netop den, der ikke kan se, at der sker noget.
  var VENTELINJE_MS = 8000;
  var ventelinjeTimer = null;

  function fjernVentelinje() {
    var e = logEl.querySelector(".gmchat-venter");
    if (e) e.remove();
  }

  function ventelinjeStyr(paa) {
    if (ventelinjeTimer) { window.clearTimeout(ventelinjeTimer); ventelinjeTimer = null; }
    if (!paa) { fjernVentelinje(); return; }
    // `tv()` og ikke `t()`: mangler noeglen paa en shop, udebliver linjen helt
    // frem for at vise et noeglenavn midt i en ventetid. Se noten ved `tv()`.
    var tekst = tv("venter-laenge");
    if (!tekst) return;
    ventelinjeTimer = window.setTimeout(function () {
      ventelinjeTimer = null;
      if (!venter) return;                                  // svaret naaede frem imens
      if (logEl.querySelector(".gmchat-venter")) return;
      var el = document.createElement("p");
      el.className = "gmchat-venter";
      el.setAttribute("role", "status");
      el.textContent = tekst;
      var ind = logEl.querySelector(".gmchat-skriver");
      if (ind && ind.parentNode) ind.parentNode.insertBefore(el, ind.nextSibling);
      else logEl.appendChild(el);
      body.scrollTop = body.scrollHeight;
    }, VENTELINJE_MS);
  }

  function saetVenter(paa) {
    venter = paa;
    if (searchInput) {
      searchInput.disabled = paa;
      searchInput.setAttribute("aria-busy", paa ? "true" : "false");
    }
    skriverIndikator(paa);
    ventelinjeStyr(paa);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ PRODUKTKORT — CEO'S PUNKT 2 OG 3                            27/08 v2.2
  // ═══════════════════════════════════════════════════════════════════════════
  // CEO punkt 2: *«Produkterne skal præsenteres overskueligt og elegant - ideelt
  // som produktkort/karrusel/galleri direkte i chatten med titel, kort
  // beskrivelse og direkte klikbare links/knapper til hvert enkelt produkt.»*
  // CEO punkt 3: *«Hvert foreslået produkt skal have sit eget, uafhængige link/
  // handlingsknap … Der må aldrig være en tvetydig fællesknap, når samtalen
  // omhandler flere varer.»*
  //
  // ⛔ FEJLEN ER MÅLT, IKKE REFERERET. 27/08 gennem den levende bagende, CEO's
  //   egen søgning «Rød visksoe». Bottens svar nævnte TRE kvaliteter:
  //     «Vi har både en klassisk vævet viskose, en strækbar viskose jersey og en
  //      hør/viskoseblanding i rød.»
  //   og under svaret stod ÉN knap: `[Se varen]` → `/products/viscose-jersey-r`.
  //   Tre varer omtalt, én knap, og den peger på den ene. Præcis CEO's punkt 3.
  //
  // KONTRAKTEN (låst af lederen, bindende for widget og bagende):
  //   svar["produkter"] = [ {titel, url, billede|null, pris|null, lager|null} ]
  //   Højst 3, rækkefølgen er relevans.  (var 5 indtil R8, 03/09/2026)
  //
  // ⛔ HVERT FELT UD OVER `titel`+`url` KAN VÆRE `null`, OG ET KORT MÅ ALDRIG
  //   BLIVE TOMT. Mangler billedet, træder husets egen stofprøve-flade i stedet
  //   (samme takkede kant som signaturen) - ikke en grå kasse med et brækket
  //   billedikon. Mangler pris eller lager, UDELADES linjen helt; der renderes
  //   aldrig en tom etiket, og der gættes aldrig en værdi.
  //
  // ⛔ HELE KORTET ER ÉT `<a>`, ikke et kort med en knap i. To grunde, begge
  //   målte husregler: (1) `bevis_design.sh`s K3 kræver 44x44 på HVERT
  //   `#gmchat-root a` - ét stort mål er trivielt over, to små er en risiko;
  //   (2) `craft-floor` ordret: *«nested cards are always wrong»* - bot-boblen
  //   ER allerede et kort, så rækken lægges som SØSKENDE i loggen, aldrig inde i
  //   boblen.
  // ⛔⛔ R8 (03/09/2026): 5 → 3. CEO's krav ordret: *«1-3 klikbare produktkort»*.
  //   MÅLT samme dag mod den KØRENDE bagende: 9 af 11 ikke-blokerede ture
  //   sendte FEM kort. Bagenden er nu sænket til 3 (`Samler.MAKS_KORT`), og
  //   dette tal er BÆLTET: driver bagenden igen, holder widget'en linjen.
  // ⛔ DE TO TAL SKAL VÆRE ENS. `bevis_r8_produktkort` DEL 1 læser præcis denne
  //   linje og går rød, hvis den ikke matcher `Samler.MAKS_KORT`. Grunden er
  //   husets dyreste fejlklasse i denne pakke: ét tal i to kopier driver fra
  //   hinanden, og i går producerede kurvkoblingen nul, fordi den udrullede
  //   bagende var en ældre udgave end den, temaet regnede med.
  //
  // ⭐⭐ 3 → 4 DEN 10/09/2026. HJEMLEN ER PLANEN, IKKE MIT VALG.
  //   `GM-CHAT-STRATEGI-OG-PLAN-2026-09-10.md`, «Design og købshjælp», ordret:
  //   *«Første anbefaling viser 2-4 produktkort i et galleri, der kan swipes
  //   på mobil.»* Planen er godkendt af Saleh (Q1-Q18 + afsluttende
  //   bekræftelse samme dag) og står over R8-ordlyden «1-3» fra 03/09.
  //   Nyere CEO-ordlyd styrer over ældre — også over kommentarerne ovenfor,
  //   som er bevaret, fordi de forklarer HVORFOR koblingen findes.
  // ⛔ TRE STEDER SAMTIDIG: dette tal · `Samler.MAKS_KORT` i `samler.py` ·
  //   `CEO_MAKS_KORT` i `bevis_r8_produktkort.py`. Prøven måler mod CEO's tal,
  //   ALDRIG mod kodens eget — det var netop den blindhed, der lod fem kort gå
  //   ud i ni af elleve målte ture.
  var PRODUKT_MAKS = 4;

  //: ⛔ §1-VÆRN PÅ BILLEDFILNAVNET. NULTOLERANCE §1 er ordret: forbuddet mod
  //: leverandørnavne gælder også **BILLEDFILNAVN og CDN-URL**, fordi URL'en er
  //: synlig i sidekilden. Forgængerens leverance noterede (citeret, ikke min egen
  //: måling), at 93 filnavne allerede har røbet en leverandørs modelnavne på
  //: 39 SKU'er. Et produktkort er den første flade, der ville trække sådan en URL
  //: ind i chatten.
  //: ⇒ Er navnet urent, vises kortet UDEN billede. Vi udelader hellere et billede
  //:   end at udstille et leverandørnavn.
  //: ⚠ Dette er et BÆLTE, ikke en løsning: den kanoniske liste hører i bagendens
  //:   `porte.py`, og bagenden bør slet ikke sende en uren URL. Aftalt afgrænsning
  //:   afleveret i leverancens §5.
  //:
  //: ⛔⛔ OG DERFOR STÅR NAVNENE IKKE HER — DE STÅR SOM TAL.
  //: Første udgave af dette værn havde de ni firmanavne som almindelige strenge.
  //: Min egen fil-kontrol fangede det: `gm-chat-widget.js` udleveres af Shopifys
  //: CDN som en OFFENTLIG asset, enhver kunde kan hente og læse. En
  //: blokeringsliste i klartekst ville altså have gjort præcis dét, §1 forbyder
  //: — udstillet ni leverandørers firmanavne på en kundevendt flade — for at
  //: forhindre, at ét af dem blev udstillet. Værnet ville have været sin egen
  //: overtrædelse.
  //: ⇒ Listen er FNV-1a-32-hashes af de ni navne. Ingen af dem kan læses ud af
  //:   filen. Ingen kryptografisk påstand: formålet er ikke hemmeligholdelse
  //:   over for en angriber, men at asseten ikke SKRIVER navnene.
  //: ⚠ Prisen, sagt højt: listen kan ikke vedligeholdes i hånden. Regenerering
  //:   sker med den fire-linjers FNV-1a, der står i leverancens §5, og listen
  //:   SKAL følge bagendens kanoniske liste. Gør den ikke det, er værnet
  //:   forældet, uden at nogen kan se det.
  //:
  //: ⛔⛔ OG PRÆCIS DET VAR SKET — MÅLT 10/09/2026, RETTET SAMME MINUT.
  //:   Listen stod på NI hashes. Regnet mod `porte.LEVERANDOERNAVNE` (husets
  //:   kanoniske liste, 11 navne) er de rigtige TOLV former, fordi et navn kan
  //:   optræde både samlet og som sine enkelte ord i et filnavn:
  //:       9 gamle hashes  ·  3 former manglede helt  ·  1 gammel hash var
  //:       en ordform, der stadig gælder
  //:   Konsekvens, mens det stod sådan: tre leverandørers navne i en CDN-URL
  //:   ville være gået lige igennem værnet og stået i sidekilden — nøjagtig
  //:   det §1 forbyder, og nøjagtig det, kommentaren ovenfor advarede om at
  //:   ingen kunne se. Værnet var forældet i tavshed.
  //:   ⇒ Listen er regenereret fra `porte.LEVERANDOERNAVNE` med formen:
  //:       for hvert navn: alle `[a-z]+`-løb ≥6 tegn, plus navnet uden
  //:       ikke-bogstaver, hvis det er ≥5 tegn.
  //:     `bevis_galleri.py` DEL «§1-BÆLTET» genberegner netop den formel fra
  //:     `porte.py` og går RØD ved uenighed. Drift kan derfor ikke længere
  //:     være tavs.
  //: ⚠ Navnene står stadig ALDRIG i klartekst her: filen er en offentlig
  //:   Shopify-asset, og en blokeringsliste i klartekst ville selv være §1-bruddet.
  var LEV_HASH = [214010568, 466211151, 1067049232, 1095703062, 1104117165,
                  1389920686, 1706553283, 1911180625, 2418215559, 2671671750,
                  3584716794, 4179545652];
  //: ⛔⛔ `LEV_MIN` SÆNKET TIL 5 (10/09). Husets egen formel (`bevis_galleri`
  //:   DEL 1, genberegnet fra `porte.LEVERANDOERNAVNE`) tager et navn SAMLET
  //:   ned til **5** tegn — men vinduet begyndte ved 6, så en 5-tegns form
  //:   kunne pr. konstruktion ALDRIG blive prøvet, og dens hash i listen ville
  //:   være ren pynt. I dag er den korteste kanoniske form 6 tegn, så dette
  //:   koster NUL nye falske positiver lige nu (intet 5-tegns vindue kan
  //:   ramme, når ingen hash er 5 tegn lang) — det er en spærre, der virker
  //:   den dag listen får et kort navn, i stedet for en, der tier om det.
  var LEV_MIN = 5, LEV_MAKS = 11;   // korteste og længste form på listen
  var CDN_VAERTER = ["cdn.shopify.com", "shopifycdn.com", "shopify.com"];

  function fnv1a(s) {
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      // 32-bit FNV-prime-multiplikation uden at ryge ud i flydende tal.
      h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h >>> 0;
  }

  //: ⚠ DELSTRENGE, IKKE ORDGRÆNSER — ET BEVIDST SKÆVT VALG.
  //:   Med ordgrænser slipper et filnavn igennem, hvor navnet er klistret sammen
  //:   med et kvalitetsord uden bindestreg. Med delstrenge fanges det — men så
  //:   rammer et af de kortere navne også et par lovlige danske ord, der
  //:   tilfældigvis indeholder det.
  //:   MÅLT på seks prøver ved bygningen: 2 urene filnavne BLOKERET (rigtigt) ·
  //:   2 lovlige ord BLOKERET (falsk positiv, kendt og accepteret) · et
  //:   `tt-`-præfikset navn og et rent hash-filnavn RENE.
  //:   ⚠ Prøvernes egne strenge står IKKE her, af samme grund som listen ikke
  //:     gør: to af dem ER leverandørnavne. De står i leverancens §3, som ikke
  //:     er en kundevendt flade.
  //: ⇒ Skævheden er valgt med vilje: en falsk positiv koster ét manglende
  //:   billede på et kort, der stadig virker. En falsk negativ er et §1-brud med
  //:   «forretningsskade» som nedskrevet konsekvens. De to fejl er ikke lige
  //:   dyre, så porten skal ikke være neutral mellem dem.
  //: ⛔⛔ SEPARATORERNE SØGES HEN OVER (10/09). Bæltet prøvede oprindeligt kun
  //:   UBRUDTE bogstavløb, så bindestreg, understreg, punktum, et ciffer midt
  //:   i navnet og `%20` delte navnet i to løb, hvor ingen af delene var lange
  //:   nok til at ramme en hash. Et filnavn som `lev-erandoer-blaa.jpg` var
  //:   usynligt for værnet.
  //:   ⇒ Der søges derfor BÅDE i hvert løb for sig OG i alle løb SAMLET uden
  //:     separatorer. Det er formen, ikke en liste over hvilke tegn nogen
  //:     måtte finde på at skyde ind.
  //:
  //: ⛔⛔ OG PRÆCIS DEN SAMMENFØJNING INDFØRTE SELV TRE GENNEMSLIP — MÅLT
  //:   10/09 MED `billedeErRent` KØRT I RIGTIG `node`, IKKE LÆST.
  //:   Sammenføjningen samler alt, hvad der ligner bogstaver, ind i navnet —
  //:   OGSÅ en procent-escapes hex-BOGSTAV. `%20` blev blokeret netop fordi
  //:   «20» ingen bogstaver har; `%2d`, `%2e` og `%5f` har `d`, `e` og `f`:
  //:       `lev%2Derandoer.jpg` → løb `lev` · `d` · `erandoer`
  //:                            → samlet `levderandoer` ≠ `leverandoer`
  //:   Målt pr. URL-form over husets 12 kanoniske former (sådan som
  //:   `bevis_galleri` DEL 1 regner dem ud af `porte.py`):
  //:       rent navn · `-` · `_` · `.` · ciffer · `%20` · `+`  →  0/12 slap
  //:       `%2D` · `%2E` · `%5F` · `%252D` · `%25252D`         → 12/12 SLAP
  //:       halvkodet navn (hvert andet bogstav som `%XX`)      → 12/12 SLAP
  //:   Altså: bæltets ene rettelse var dens eget hul. **72 af 156 prober**
  //:   (13 URL-former × 12 kanoniske former) slap.
  //:   ⇒ HVER `%XX` oversættes NU, FØR løbene udtrækkes: er det afkodede tegn
  //:     et bogstav eller ciffer, sættes tegnet ind (så `%73` bliver `s`); er
  //:     det hvad som helst andet, sættes en SEPARATOR ind. Efter rettelsen:
  //:     **0 af 156** prober slipper, og de 10 rene kontrolnavne er uændret
  //:     RENE (ingen ny falsk positiv).
  //: ⚠ TALLENE ER IKKE TIL AT TRO PÅ — DE SKAL KØRES. `bevis_galleri.py` DEL 1
  //:   udskriver dem selv («MÅLT §1-bæltet i node: … af … prober»), og
  //:   `--saboter procent` fremkalder tilstanden før rettelsen igen.
  //: ⚠ HVORFOR IKKE `decodeURIComponent` — et bevidst valg, sagt højt:
  //:     1. Den KASTER på en ugyldig escape (`%zz`, `100%.jpg`, et nøgent `%`).
  //:        Den skulle i try/catch, og det eneste fornuftige fald tilbage ville
  //:        være den UAFKODEDE streng — altså præcis hullet igen, nu bare
  //:        stille. Formen her kaster pr. konstruktion ikke: `parseInt` på to
  //:        hex-cifre lykkes altid, og en ugyldig escape står uberørt.
  //:     2. Den afkoder ÉT lag. `%252D` ville blive `%2D` — stadig en escape,
  //:        stadig et hul — og en løkke, der afkoder til den står stille, er
  //:        husets «ubegrænset afkodning»-fælde. `%(?:25)*` tager alle lag i
  //:        ét hug, målt til og med `%25252D`.
  //:     3. Vi har ikke brug for den RIGTIGE streng, kun for spørgsmålet «kan
  //:        disse bogstaver stave et leverandørnavn». En escape er aldrig en
  //:        del af et navn, så «bogstav ⇒ tegnet, alt andet ⇒ separator» er
  //:        den rigtige semantik — ikke en billigere version af en afkodning.
  //: ⚠ `.toLowerCase()` PÅ DET AFKODEDE TEGN ER IKKE PYNT. Strengen er
  //:   lowercase'et FØR erstatningen, men `%57` bærer sit store `W` med sig:
  //:   uden den sidste lowercase blev `%57outers.jpg` til `-outers.jpg` og
  //:   SLAP. Målt i node, fanget i min egen første udgave af denne rettelse.
  //: ⚠ NAVNGIVEN REST, IKKE ET SKJULT HUL: et filnavn, der skriver sin
  //:   separator som LITTERALE bogstaver — `lev-erandoer` (12/12 slipper
  //:   stadig, målt) eller `lev&ndash;erandoer` — bryder sammenføjningen med
  //:   `u`/`d`/`ndash`, og det kan en escape-oversættelse pr. konstruktion
  //:   ikke se. Det er ikke lukket, og det lukkes ikke ved at kaste endnu en
  //:   heuristik ind: en spærre, der kaster løb på under tre bogstaver væk,
  //:   ville lukke netop disse to og blive slået af et tre-bogstavs-fyld
  //:   (`lev-abc-erandoer`). Sammenføjningen kan ikke gøres komplet over for
  //:   indskudte BOGSTAVER. Den dag det ses i et rigtigt filnavn, er svaret
  //:   serverens liste, ikke en tredje heuristik her.
  //: ⚠ PRISEN, SAGT HØJT: sammenføjningen går hen over grænser, så to
  //:   uskyldige stykker af URL'en kan tilsammen danne en form og koste ét
  //:   manglende billede på et kort, der stadig virker. Det er den samme
  //:   bevidst skæve afvejning som noten ovenfor: en falsk negativ er et
  //:   §1-brud med «forretningsskade» som nedskrevet konsekvens, en falsk
  //:   positiv er et tomt billedfelt. De to fejl er ikke lige dyre.
  //: ⚠ Serveren er PRIMÆR bærer af §1 (`porte.py`s kanoniske liste, og
  //:   bagenden bør slet ikke sende en uren URL). Dette er dybdeforsvar — men
  //:   et dybdeforsvar, der kun dækker den ene af to skrivemåder, er ikke et
  //:   forsvar; det er en påstand.
  //: ⛔ OG DEN PÅSTAND MÅLES NU FRA DEN ANDEN SIDE: `bevis_galleri.py` DEL 1
  //:   kører DENNE funktion i rigtig `node` mod formerne ovenfor og kræver
  //:   nul gennemslip. Før i dag hvilede dommen på en TEKSTSØGNING efter
  //:   `emner.push(loeb.join(""))` — en sabotage, der lod strengen stå og
  //:   fjernede adfærden, gav GRØNT. En tilstand målt med en tekstsøgning er
  //:   ikke målt.
  function billedeErRent(url) {
    var s = String(url || "").toLowerCase();
    // ⛔ PROCENT-ESCAPERNE OVERSÆTTES FØR LØBENE UDTRÆKKES. Uden dette linje-
    //   stykke samler sammenføjningen nedenfor escapens hex-BOGSTAV ind i
    //   navnet og bryder matchet — `%2D`/`%2E`/`%5F` slap 12/12. Bogstav eller
    //   ciffer ⇒ tegnet selv (så `%73` bliver `s`); alt andet ⇒ separator.
    //   `(?:25)*` tager dobbelt- og tripelkodning (`%252D`, `%25252D`) i ét
    //   hug. Kaster aldrig — se noten ovenfor om `decodeURIComponent`.
    s = s.replace(/%(?:25)*([0-9a-f]{2})/g, function (_hele, hex) {
      var c = String.fromCharCode(parseInt(hex, 16)).toLowerCase();
      return /[a-z0-9]/.test(c) ? c : "-";
    });
    var loeb = s.match(/[a-z]+/g) || [];
    // ⛔ De enkelte løb OG løbene samlet. Er der kun ét løb, er de to det
    //   samme, og sammenføjningen tilføjes ikke (intet at vinde, dobbelt
    //   arbejde at tabe).
    var emner = loeb.slice(0);
    if (loeb.length > 1) emner.push(loeb.join(""));
    for (var i = 0; i < emner.length; i++) {
      var r = emner[i];
      for (var L = LEV_MIN; L <= LEV_MAKS && L <= r.length; L++) {
        for (var j = 0; j + L <= r.length; j++) {
          if (LEV_HASH.indexOf(fnv1a(r.substr(j, L))) !== -1) return false;
        }
      }
    }
    return true;
  }

  //: Billedet skal komme fra Shopifys eget CDN eller en af husets egne værter -
  //: aldrig en fremmed vært. Samme princip som `egetLinkMaal`, og af samme grund:
  //: et opslag kan blive forgiftet, og en `<img src>` mod en fremmed vært lækker
  //: kundens IP og sidevisning dertil.
  function billedMaal(raa) {
    var s = String(raa || "").trim();
    if (!s) return null;
    if (!billedeErRent(s)) return null;
    if (s.charAt(0) === "/") return s;
    var u;
    try { u = new URL(s); } catch (e) { return null; }
    if (u.protocol !== "https:" && u.protocol !== "http:") return null;
    var h = u.hostname.toLowerCase();
    if (erEgetVaertsnavn(h)) return s;
    for (var i = 0; i < CDN_VAERTER.length; i++) {
      var d = CDN_VAERTER[i];
      if (h === d || h.slice(-(d.length + 1)) === "." + d) return s;
    }
    return null;
  }

  // ⭐⭐ GALLERIET — OMBYGGET 10/09/2026 PÅ DEN GODKENDTE PLAN.
  //   `GM-CHAT-STRATEGI-OG-PLAN-2026-09-10.md`, «Design og købshjælp», ordret:
  //     *«Første anbefaling viser 2-4 produktkort i et galleri, der kan swipes
  //      på mobil. Billede, navn, pris/enhed, kort begrundelse og
  //      SELVSTÆNDIGE HANDLINGER pr. vare. Vis relevante egenskaber i enkel
  //      sammenligning på forespørgsel.»*
  //
  // ⛔ HVAD DER ÆNDREDE SIG, OG HVORFOR DET IKKE ER EN SMAGSSAG.
  //   Indtil i dag var HELE kortet ét `<a>`. Det var rigtigt under R8's
  //   ordlyd («direkte link»), men planen af 10/09 kræver flere handlinger pr.
  //   vare — og et kort, der ER et link, kan pr. konstruktion ikke rumme en
  //   knap: et `<button>` inde i et `<a>` er ugyldigt HTML, og et klik ville
  //   både aktivere knappen og navigere væk. Kunden ville miste sin samtale
  //   midt i en handling.
  //   ⇒ Kortet er nu en `role="group"`-beholder. «Se varen» er stadig et
  //     rigtigt `<a href="/products/…">` — den direkte vej er urørt — men den
  //     står som ÉN af flere selvstændige handlinger i stedet for at være hele
  //     fladen.
  // ⚠ `bevis_design.sh`s K3 (44×44 på hvert `#gmchat-root a` og hver knap)
  //   gælder uændret: handlingerne har derfor deres eget min-højde-mål i
  //   CSS'en, ikke bare linjehøjden.
  // ⛔ «NESTED CARDS ARE ALWAYS WRONG» står ved magt: rækken lægges fortsat som
  //   SØSKENDE til bot-boblen i loggen, aldrig inde i den.
  //
  // ⛔ §1-BÆLTET ER UÆNDRET OG SKAL FORBLIVE DET. `billedMaal()` dropper
  //   billedet, hvis filnavn eller CDN-URL røber et leverandørnavn — 93
  //   filnavne har allerede gjort det på 39 SKU'er. Galleriet åbner ingen vej
  //   udenom: der findes præcis ét sted, hvor en billed-URL bliver til en
  //   `src`, og det går gennem `billedMaal()`.
  //
  // KONTRAKTEN (udvidet 10/09, bagudkompatibelt — alle nye felter er valgfrie):
  //   svar.svar.produkter = [ {titel, url, billede|null, pris|null, lager|null,
  //                            begrundelse|null, fakta|null, enhed|null} ]
  //   `fakta` = [ {navn, vaerdi} ], højst 4, husets egne metafelter.
  //   ⚠ Et ældre bagende uden de tre nye felter renderer NØJAGTIG som i går.
  //     Nødstoppet degraderer nedad, aldrig sidelæns.

  //: Sidste renderede række — grundlaget for sammenligningen. Ingen lagring,
  //: ingen persondata: rene produktfakta fra netop dette svar.
  var sidsteVarer = [];

  //: ⛔ HVER HANDLING BLIVER TIL EN ENTYDIG KUNDEBESKED — ALDRIG TIL EN
  //:   KVITTERING FRA FLADEN. Planen: *«Teksten «tilføjet» er ikke bevis; den
  //:   faktiske kurv skal stemme.»* Widget'en påstår derfor ingenting om
  //:   udfaldet; den beder om handlingen med kundens egne ord og lader
  //:   serverens dom stå i næste svar. Se `kurvUdfoerInstrukser`.
  function varensBesked(skabelon, vare, antal) {
    var s = String(skabelon || "");
    if (!s) return "";
    // ⛔ ALDRIG ET HANDLE I SYNLIG TEKST. Handles bærer leverandør-præfikser
    //   (`wt-`, `vt-`, `tt-`); titlen er husets egen, kundevendte streng.
    s = s.replace(/\{vare\}/g, vare.titel);
    s = s.replace(/\{antal\}/g, antal === undefined || antal === null ? "" : String(antal));
    s = s.replace(/\{enhed\}/g, vare.enhed || "");
    return s.replace(/\s+/g, " ").trim();
  }

  function varensKnap(klasse, etiket) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "gmchat-vare-knap " + klasse;
    b.textContent = etiket;
    return b;
  }

  //: ⛔ MÆNGDEFELTET VISES KUN, NÅR ENHEDEN ER KENDT — DEN GÆTTES ALDRIG.
  //:   `enhed_for()` i bagenden fejler ÅBENT mod «meter» (målt: `STYK_TYPER`
  //:   mangler garn), så en gættet enhed i fladen ville lægge endnu et lag
  //:   ovenpå en kendt fejl. «12» kan betyde 12 meter eller 12 knapper, og en
  //:   forkert enhed er en forkert ordre.
  //:   ⇒ Uden `enhed` sender knappen en ÅBEN bestilling, og botten spørger selv
  //:     om mængde og variant — præcis planens regel: *«Spørg før handling,
  //:     hvis vare, variant eller antal er uklart.»*
  //: ⭐⭐ KØBSHJÆLPEN, OMBYGGET 11/09/2026 (UX-handoff punkt 1).
  //:   FØR (browsermålt af roden 10/09): kortets knap åbnede et felt med
  //:   etiketten «Antal (meter)» og en GENERISK «Send». Kunden kunne hverken se
  //:   hvad hun købte, eller på hvilket grundlag.
  //:   NU: panelet navngiver varen, gentager husets EGEN pristekst ORDRET, og
  //:   handlingsknappen siger hvad der sker — «Læg 4 meter i kurven.»
  //:
  //: ⛔⛔ DER REGNES IKKE EN TOTAL HER. DET ER ET MÅLT VALG, IKKE EN MANGEL.
  //:   Tre forhold, hvert for sig nok:
  //:   (1) Kortets `pris` er en FORMATERET STRENG («129,00 kr. pr. meter»), ikke
  //:       et tal. Tallet findes serverside, men `kilde_shopify.py:779` fladgør
  //:       det med vilje: `ud[KORT_PRIS] = Beloeb(...).tekst(sprogflade)`.
  //:   (2) `produkt.Beloeb`s egen låste regel (plan §4.1): *«Et beløb forlader
  //:       ALDRIG systemet som et bart tal … Mangler en af dem, blokeres
  //:       svaret»*. En total, fladen selv havde ganget sig frem til, bærer
  //:       ingen af de fire nøgler.
  //:   (3) MÆNGDERABATTEN ER AUTOMATISK OG TRAPPET. `kurv.py` læser trinnene af
  //:       shoppens egen `settings.gm_qtyd_tiers` (målt 10/09: 5 m→5 % ·
  //:       15 m→10 % · 30 m→15 %) og huset har en Shopify Function, der giver
  //:       dem i checkout. `antal × meterpris` er derfor FORKERT fra og med
  //:       5 meter — og forkert i KUNDENS DISFAVØR. Præcis den fejlklasse
  //:       `visKurvkvittering`s egen note kalder «mersalg forklædt som hjælp».
  //:   ⇒ GRUNDLAGET vises ordret; TOTALEN er fortsat serverens, i kvitteringen
  //:     efter dommen. Degradering NEDAD (færre påstande), aldrig sidelæns
  //:     (en gættet total).
  //:
  //: ⛔ VARIANTEN VISES IKKE, FORDI DEN IKKE FINDES I KONTRAKTEN. Kortet bærer
  //:   `{titel, url, billede, pris, lager, begrundelse, fakta, enhed}` — ingen
  //:   `variant_id`, intet variantnavn. Og det er med vilje: `kilde_shopify.py`
  //:   sætter kun en pris, når ALLE varianter er enige (§54 — rulle og pakke er
  //:   forskellige varer med forskellig meterpris). Er de uenige, siger kortet
  //:   intet, og botten afklarer selv. At navngive en variant her ville være at
  //:   opfinde den.
  //:
  //: ⛔ INGEN NYE TEKSTNØGLER, OG INGEN DANSK STRENG I JS'EN (R8).
  //:   `bevis_galleri` (linje 797-798) kræver, at hver `t()`/`tv()`-nøgle i
  //:   JS'en har en `data-t-*` i `.liquid` — og `.liquid` ejes af et andet spor.
  //:   Knapteksten bygges derfor af husets EGEN, allerede udrullede skabelon
  //:   `vare-kurv-tekst` («Læg {antal} {enhed} {vare} i kurven.») med varenavnet
  //:   TOMT, fordi panelet nævner varen lige ovenfor. `varensBesked` kollapser
  //:   selv dobbelt mellemrum, så resultatet er ordret «Læg 4 meter i kurven.»
  //:   SE/NO/B2B får deres egen skabelon fra deres egen locale-fil.
  //: ⚠ `maengde-send` beholdes som faldbakke, så en flade, der mangler
  //:   `vare-kurv-tekst`, opfører sig som i dag i stedet for at miste knappen.
  function maengdeKnaptekst(vare, antal) {
    var specifik = varensBesked(tv("vare-kurv-tekst"),
                                { titel: "", enhed: vare.enhed }, antal);
    return specifik || tv("maengde-send");
  }

  function visMaengdefelt(kort, vare) {
    var gl = kort.querySelector(".gmchat-vare-maengde");
    if (gl) { gl.remove(); return; }          // et nyt klik lukker igen
    var etiketTekst = tv("maengde-label");
    var sendTekst = tv("maengde-send");
    if (!etiketTekst || !sendTekst) return;
    var boks = document.createElement("form");
    boks.className = "gmchat-vare-maengde";

    // ⭐ HVAD KØBER HUN. Kortets egen titel, ordret — aldrig et handle (§1:
    //   handles bærer leverandør-præfikser). Panelet ligger inde i kortet, men
    //   galleriet ruller vandret i en 245 px bred rude, så kortets hoved kan
    //   være rullet ud af syne netop når beslutningen træffes.
    if (vare.titel) {
      var varenavn = document.createElement("p");
      varenavn.className = "gmchat-maengde-vare";
      varenavn.textContent = vare.titel;
      boks.appendChild(varenavn);
    }
    // ⭐ PÅ HVILKET GRUNDLAG. Husets egen pristekst, ORDRET som serveren
    //   formaterede den — ikke parset, ikke omregnet, ikke genformateret.
    //   Mangler den (ukendt enhed, uenige varianter), vises INTET felt — aldrig
    //   et tomt felt og aldrig et gæt.
    if (vare.pris) {
      var prisEl = document.createElement("p");
      prisEl.className = "gmchat-maengde-pris";
      prisEl.textContent = vare.pris;
      boks.appendChild(prisEl);
    }

    var id = "gmchat-maengde-" + Math.random().toString(36).slice(2, 8);
    var lab = document.createElement("label");
    lab.setAttribute("for", id);
    lab.className = "gmchat-vare-maengde-etiket";
    lab.textContent = etiketTekst + (vare.enhed ? " (" + vare.enhed + ")" : "");
    var felt = document.createElement("input");
    felt.type = "number";
    felt.id = id;
    felt.className = "gmchat-vare-maengde-felt";
    felt.min = "1";
    felt.step = "1";
    felt.value = "1";
    felt.inputMode = "numeric";
    var send = document.createElement("button");
    send.type = "submit";
    send.className = "gmchat-vare-knap gmchat-vare-knap--send";
    send.textContent = maengdeKnaptekst(vare, 1);
    // ⭐ KNAPPEN FØLGER FELTET. En specifik knap, der står på et andet tal end
    //   feltet, er værre end en generisk: den siger noget forkert om handlingen.
    // ⚠ Ugyldigt tal ⇒ knappen falder tilbage til den generiske etiket i stedet
    //   for at love «Læg NaN meter i kurven».
    felt.addEventListener("input", function () {
      var n = parseInt(felt.value, 10);
      send.textContent = (isFinite(n) && n >= 1)
        ? maengdeKnaptekst(vare, n) : sendTekst;
    });
    boks.appendChild(lab);
    boks.appendChild(felt);
    boks.appendChild(send);
    boks.addEventListener("submit", function (e) {
      e.preventDefault();
      var n = parseInt(felt.value, 10);
      // ⚠ Et tomt eller ugyldigt tal sender INTET. En bestilling på «NaN
      //   meter» er ikke entydig, og en uklar bestilling må ikke afsted.
      if (!isFinite(n) || n < 1) { felt.focus(); return; }
      var tekst = varensBesked(tv("vare-kurv-tekst"), vare, n);
      if (!tekst) return;
      boks.remove();
      spoergBotten(tekst);
    });
    kort.appendChild(boks);
    felt.focus();
    felt.select();
  }

  //: ⭐ TASTATURET ER EN LIGEVÆRDIG «SWIPE». Planen kræver swipe på mobil;
  //:   tilgængelighed kræver, at den samme bevægelse kan udføres uden en
  //:   finger. Pil højre/venstre flytter fokus til nabokortet OG ruller det i
  //:   syne — Home/End til første/sidste.
  //: ⚠ Fokus flyttes til kortets FØRSTE handling, ikke til kortet selv: en
  //:   `role="group"` er ikke et fokuserbart mål, og en tabindex på hvert kort
  //:   ville lægge fire ekstra stop ind i tabulatorrækken.
  function galleriNavigation(wrap, vaert) {
    if (wrap.children.length < 2) return;
    wrap.tabIndex = 0;
    var nav = document.createElement("div");
    nav.className = "gmchat-galleri-nav";
    function pil(retning, navn, tegn) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "gmchat-galleri-knap";
      b.setAttribute("aria-label", navn);
      b.textContent = tegn;
      b.addEventListener("click", function () {
        var kort = wrap.querySelector(".gmchat-vare");
        var trin = kort ? kort.getBoundingClientRect().width + 12 : wrap.clientWidth;
        wrap.scrollBy({left: retning * trin, behavior: "auto"});
      });
      nav.appendChild(b);
      return b;
    }
    var forrige = pil(-1, "Föregående produkter", "←");
    var naeste = pil(1, "Nästa produkter", "→");
    function opdater() {
      forrige.disabled = wrap.scrollLeft <= 1;
      naeste.disabled = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 1;
    }
    wrap.addEventListener("scroll", opdater, {passive: true});
    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function () {
        if (!wrap.isConnected) { ro.disconnect(); return; }
        opdater();
      });
      ro.observe(wrap);
    }
    vaert.appendChild(nav);
    requestAnimationFrame(opdater);
  }

  function galleriTaster(wrap) {
    wrap.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft" &&
          e.key !== "Home" && e.key !== "End") return;
      if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
      var kort = Array.prototype.slice.call(wrap.querySelectorAll(".gmchat-vare"));
      if (kort.length < 2) return;
      var nu = -1;
      for (var i = 0; i < kort.length; i++) {
        if (kort[i].contains(document.activeElement)) { nu = i; break; }
      }
      var maal;
      if (e.key === "Home") maal = 0;
      else if (e.key === "End") maal = kort.length - 1;
      else if (nu === -1) maal = 0;
      else maal = nu + (e.key === "ArrowRight" ? 1 : -1);
      if (maal < 0 || maal >= kort.length) return;   // ingen ombrydning i ring
      e.preventDefault();
      var f = kort[maal].querySelector("a, button");
      if (f) f.focus();
      // ⚠ `block: "nearest"` — ellers ruller browseren OGSÅ lodret, og kunden
      //   mister sin plads i samtalen for at se et kort, der allerede var synligt.
      if (kort[maal].scrollIntoView) {
        try {
          kort[maal].scrollIntoView({ block: "nearest", inline: "center", behavior: "auto" });
        } catch (err) { kort[maal].scrollIntoView(false); }
      }
    });
  }

  //: ⭐ ENKEL SAMMENLIGNING PÅ FORESPØRGSEL. «På forespørgsel» er knappen: der
  //:   åbnes aldrig en tabel af sig selv.
  //: ⛔ TABELLEN OPFINDER INGEN CELLER. Har en vare ikke en given egenskab,
  //:   står feltet TOMT — der skrives aldrig «nej», «ingen» eller en tom
  //:   streg, som kunne læses som en oplysning om varen. Vi ved kun, at vi
  //:   ikke har feltet.
  function visSammenlign(vaerter, varer) {
    var gl = vaerter.querySelector(".gmchat-sammenlign");
    if (gl) { gl.remove(); return; }
    var navne = [];
    varer.forEach(function (v) {
      (v.fakta || []).forEach(function (f) {
        if (navne.indexOf(f.navn) === -1) navne.push(f.navn);
      });
    });
    if (!navne.length) return;
    var rul = document.createElement("div");
    rul.className = "gmchat-sammenlign";
    var tabel = document.createElement("table");
    var thead = document.createElement("thead");
    var hr = document.createElement("tr");
    var hj = document.createElement("th");
    hj.scope = "col";
    hj.textContent = "";
    hr.appendChild(hj);
    varer.forEach(function (v) {
      var th = document.createElement("th");
      th.scope = "col";
      th.textContent = v.titel;
      hr.appendChild(th);
    });
    thead.appendChild(hr);
    tabel.appendChild(thead);
    var tbody = document.createElement("tbody");
    navne.forEach(function (navn) {
      var tr = document.createElement("tr");
      var th = document.createElement("th");
      th.scope = "row";
      th.textContent = navn;
      tr.appendChild(th);
      varer.forEach(function (v) {
        var td = document.createElement("td");
        var traef = null;
        (v.fakta || []).forEach(function (f) { if (f.navn === navn) traef = f; });
        td.textContent = traef ? traef.vaerdi : "";
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    tabel.appendChild(tbody);
    rul.appendChild(tabel);
    vaerter.appendChild(rul);
    body.scrollTop = body.scrollHeight;
  }

  function visProdukter(produkter) {
    if (!produkter || !produkter.length) return 0;
    var rene = [];
    for (var i = 0; i < produkter.length && rene.length < PRODUKT_MAKS; i++) {
      var p = produkter[i];
      if (!p || typeof p !== "object") continue;
      var titel = String(p.titel || "").trim();
      var maal = p.url ? egetLinkMaal(String(p.url)) : null;
      // ⛔ Uden BÅDE en titel og en gyldig, egen URL er kortet ikke et kort - det
      //   er en tom plads med en knap, der ikke ved hvor den skal hen. Springes
      //   over, uden at resten af rækken går tabt.
      if (!titel || !maal) continue;
      rene.push({ titel: titel, url: maal, billede: billedMaal(p.billede),
                  pris: String(p.pris || "").trim(),
                  lager: String(p.lager || "").trim(),
                  begrundelse: String(p.begrundelse || "").trim(),
                  enhed: String(p.enhed || "").trim(),
                  fakta: reneFakta(p.fakta) });
    }
    if (!rene.length) return 0;
    sidsteVarer = rene;

    var vaerter = document.createElement("div");
    vaerter.className = "gmchat-varer-vaert";

    var wrap = document.createElement("div");
    wrap.className = "gmchat-varer";
    // ⚠ Galleri-klassen sættes KUN ved flere end ét kort. Ét kort i en
    //   swipe-bane ser ud som om noget mangler ved siden af.
    if (rene.length > 1) wrap.className += " gmchat-varer--galleri";
    wrap.setAttribute("role", "group");
    var ariaVarer = tv("varer-aria");
    if (ariaVarer) wrap.setAttribute("aria-label", ariaVarer);

    var cta = tv("vare-se");
    var proeveTekst = tv("vare-proeve");
    var kurvTekst = tv("vare-kurv");

    rene.forEach(function (p) {
      // ⛔ IKKE ET `<a>` MERE — se den store note øverst. Kortet er en gruppe;
      //   handlingerne er selvstændige.
      var kort = document.createElement("div");
      kort.className = "gmchat-vare";
      kort.setAttribute("role", "group");
      kort.setAttribute("aria-label", p.titel);

      var bil = document.createElement("span");
      bil.className = "gmchat-vare-billede";
      if (p.billede) {
        var img = document.createElement("img");
        img.src = p.billede;
        // ⛔ ALT-TEKSTEN ER VARENS TITEL - ALDRIG FILNAVNET. §1 gælder også
        //   alt-tekst. Titlen er husets egen, kundevendte streng.
        img.alt = p.titel;
        img.loading = "lazy";
        img.decoding = "async";
        // Pladsen reserveres, så kortet ikke hopper når billedet lander
        // (ui-ux-pro-max §3, CLS).
        img.width = 60; img.height = 60;
        // ⛔⛔ ET BILLEDE, DER IKKE SVARER, MÅ IKKE EFTERLADE ET BRÆKKET KORT.
        //   FUNDET PÅ ET SKÆRMBILLEDE, IKKE AF EN MÅLING: i EFTER-billedet ved
        //   375 px pegede stub'ens billed-URL på en sti, der ikke findes. Browseren
        //   viste da alt-teksten i stedet — og alt-teksten er varens FULDE titel,
        //   som flød ud i en 60 px bred kasse og gjorde rækken ulæselig.
        //   Alle mine tal var grønne imens: kontrast, berøringsmål, overløb og
        //   rul måler ikke, om et billede kom frem.
        //   ⚠ Det er ikke en kunstig tilstand. En URL fra bagenden kan pege på et
        //     slettet medie, CDN'et kan svare 404, og kunden kan sidde bag et
        //     billed-blokerende filter.
        //   ⇒ Svarer billedet ikke, fjernes det, og den tomme stofprøve-flade
        //     træder i stedet — nøjagtig samme tilstand som `billede: null`, som
        //     allerede er en normal, designet tilstand.
        img.addEventListener("error", function () {
          if (img.parentNode) img.parentNode.removeChild(img);
          if (bil.className.indexOf("gmchat-vare-billede--tom") === -1) {
            bil.className += " gmchat-vare-billede--tom";
          }
        });
        bil.appendChild(img);
      } else {
        // Husets egen flade i stedet for et brækket billedikon: papir med den
        // klippede kant, samme signatur som panelets hoved.
        bil.className += " gmchat-vare-billede--tom";
      }
      kort.appendChild(bil);

      var krop = document.createElement("div");
      krop.className = "gmchat-vare-krop";

      var t = document.createElement("span");
      t.className = "gmchat-vare-titel";
      t.textContent = p.titel;
      krop.appendChild(t);

      // ⭐ KORT BEGRUNDELSE (planen 10/09). ⚠ Den er HUSETS kendsgerninger fra
      //   varens egne metafelter — ikke modellens prosa og ikke en vurdering.
      //   Se `samler._kortbegrundelse`: en sætning ville være en vurdering, og
      //   en vurdering hører til i bottens svar, hvor porten kan se den.
      if (p.begrundelse) {
        var beg = document.createElement("span");
        beg.className = "gmchat-vare-begrundelse";
        beg.textContent = p.begrundelse;
        krop.appendChild(beg);
      }

      // ⚠ Pris og lager er hver for sig valgfrie. Findes ingen af dem, kommer
      //   linjen slet ikke - en tom meta-linje ville lave et hul i kortet.
      if (p.pris || p.lager) {
        var meta = document.createElement("span");
        meta.className = "gmchat-vare-meta";
        if (p.pris) {
          var pr = document.createElement("span");
          pr.className = "gmchat-vare-pris";
          pr.textContent = p.pris;
          meta.appendChild(pr);
        }
        if (p.lager) {
          var lg = document.createElement("span");
          lg.className = "gmchat-vare-lager";
          lg.textContent = p.lager;
          meta.appendChild(lg);
        }
        krop.appendChild(meta);
      }
      kort.appendChild(krop);

      // ---------- SELVSTÆNDIGE HANDLINGER PR. VARE ----------
      var handlinger = document.createElement("div");
      handlinger.className = "gmchat-vare-handlinger";

      // ⛔ «Se varen» er stadig et RIGTIGT `<a href>`. Den direkte vej til
      //   produktsiden er ikke blevet en JS-knap: en knap kan ikke åbnes i ny
      //   fane, kan ikke kopieres som link og virker ikke uden JS.
      if (cta) {
        var a = document.createElement("a");
        a.className = "gmchat-vare-knap gmchat-vare-knap--se";
        a.href = p.url;
        a.rel = "noopener";
        a.appendChild(document.createTextNode(cta));
        a.appendChild(pilIkon());
        handlinger.appendChild(a);
      }

      // ⚠ Hver knap udelades HELT, hvis dens tekst mangler i temaet (R8's
      //   regel: ingen dansk standard i JS'en, som ville slå igennem på
      //   SE/NO/B2B). Bemærk at BÅDE etiketten og beskedskabelonen skal
      //   findes — en knap uden besked ville være en knap, der intet gør.
      if (proeveTekst && tv("vare-proeve-tekst")) {
        var kp = varensKnap("gmchat-vare-knap--proeve", proeveTekst);
        kp.addEventListener("click", function () {
          var tekst = varensBesked(tv("vare-proeve-tekst"), p);
          if (tekst) spoergBotten(tekst);
        });
        handlinger.appendChild(kp);
      }

      if (kurvTekst && (tv("vare-kurv-tekst") || tv("vare-kurv-aaben-tekst"))) {
        var kk = varensKnap("gmchat-vare-knap--kurv", kurvTekst);
        kk.addEventListener("click", function () {
          // Kendt enhed → spørg om mængden her. Ukendt enhed → åben
          // bestilling, og botten spørger selv. Se `visMaengdefelt`.
          if (p.enhed && tv("vare-kurv-tekst") && tv("maengde-label")) {
            visMaengdefelt(kort, p);
            return;
          }
          var tekst = varensBesked(tv("vare-kurv-aaben-tekst"), p);
          if (tekst) spoergBotten(tekst);
        });
        handlinger.appendChild(kk);
      }

      if (handlinger.childNodes.length) kort.appendChild(handlinger);
      wrap.appendChild(kort);
    });

    galleriTaster(wrap);
    vaerter.appendChild(wrap);
    galleriNavigation(wrap, vaerter);

    // ⭐ SAMMENLIGN — kun når der ER noget at sammenligne: mindst to varer, og
    //   mindst to af dem bærer kendsgerninger. En knap, der åbner en tom
    //   tabel, er en knap, der lyver om hvad vi ved.
    var medFakta = rene.filter(function (v) { return v.fakta && v.fakta.length; });
    var sammenlignTekst = tv("varer-sammenlign");
    if (sammenlignTekst && rene.length > 1 && medFakta.length > 1) {
      var sk = document.createElement("button");
      sk.type = "button";
      sk.className = "gmchat-sammenlign-knap";
      sk.textContent = sammenlignTekst;
      sk.setAttribute("aria-expanded", "false");
      sk.addEventListener("click", function () {
        visSammenlign(vaerter, medFakta);
        sk.setAttribute("aria-expanded",
          vaerter.querySelector(".gmchat-sammenlign") ? "true" : "false");
      });
      vaerter.appendChild(sk);
    }

    logEl.appendChild(vaerter);
    body.scrollTop = body.scrollHeight;
    return rene.length;
  }

  //: ⛔ KENDSGERNINGERNE TYPESIKRES, DE STOLES IKKE PÅ. Feltet er nyt i
  //:   kontrakten, og en ældre eller fremmed bagende kan sende hvad som helst.
  //:   En streng, der lander i `textContent`, er harmløs — men en `undefined` i
  //:   en tabelcelle ville stå som ordet «undefined» på kundens skærm.
  function reneFakta(raa) {
    if (Object.prototype.toString.call(raa) !== "[object Array]") return [];
    var ud = [];
    for (var i = 0; i < raa.length && ud.length < 4; i++) {
      var f = raa[i];
      if (!f || typeof f !== "object") continue;
      var navn = String(f.navn || "").trim();
      var vaerdi = String(f.vaerdi || "").trim();
      if (!navn || !vaerdi) continue;
      ud.push({ navn: navn, vaerdi: vaerdi });
    }
    return ud;
  }

  // ⛔ NAESTE SKRIDT under et bot-svar. Adskilt fra `renderIntro()`s knapper,
  // fordi de to lever forskellige steder: introens ligger i `body` og ryddes
  // ved hver `renderIntro`, disse ligger i `logEl` og foelger den besked, de
  // hoerer til.
  // ⚠ KUN ÉT SAET AD GANGEN. Uden oprydning ville hver tur laegge nye knapper
  //   oven i de gamle, og kunden ville se en voksende mur af forslag, hvoraf de
  //   fleste hoerte til et svar laengere oppe.
  // A product card owns its sample action. A generic suggestion must not
  // duplicate it or submit an ambiguous order without a selected product.
  function relevanteProeveForslag(forslag, harProduktkort) {
    return forslag.reduce(function (ud, f) {
      if (!f) return ud;
      var tekst = String(f.tekst || "").trim().toLowerCase();
      var generelProeve = f.slags === "spoergsmaal" &&
        (tekst === "beställ ett tygprov" || tekst === "beställ tygprov");
      if (generelProeve && harProduktkort) return ud;
      if (generelProeve) {
        var kopi = {};
        Object.keys(f).forEach(function (k) { kopi[k] = f[k]; });
        kopi.tekst = "Hur beställer jag ett tygprov?";
        kopi.besked = "Hur beställer jag ett tygprov?";
        ud.push(kopi);
      } else {
        ud.push(f);
      }
      return ud;
    }, []);
  }

  function visNaesteSkridt(forslag) {
    var gl = logEl.querySelectorAll(".gmchat-naeste");
    for (var i = 0; i < gl.length; i++) gl[i].remove();

    var wrap = document.createElement("div");
    wrap.className = "gmchat-suggestions gmchat-naeste";
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", t("aria-forslag"));
    forslag.forEach(function (f) {
      if (!f || !f.tekst) return;

      // ⭐ 26/08 runde 2 — VEJEN UD AF BLINDGYDEN (`chat-konvertering-oejenhoejde.md`
      //   fund 2, UI-halvdelen). MAALT live i dag: paa en spaerret tur svarer
      //   botten «Det tør jeg ikke svare på herfra…» og widget'en viste
      //   **0 naeste-skridt-knapper** - praecis de 16 af 39 ture, fundet beskriver.
      //   Kode-sporet aabner `forslag` ogsaa under en nedgradering; naar det sker,
      //   sender det efter fundets egen ordlyd to slags forslag, som widget'en
      //   indtil nu ikke kunne rendere:
      //     · `{"slags":"kontakt"}`            -> aabn vores egne to felter
      //     · `{"slags":"link","url":"tel:…"}` -> et rigtigt opkaldslink
      //   Begge er INAKTIVE, indtil bagenden sender dem. De er bygget nu, saa
      //   rettelsen paa den anden side lander uden en runde mere her.
      // ⛔ VEJ B FJERNET 29/08 (CEO: «fjerne og slukke extra navn + mail»).
      //   Her stod en `f.slags === "kontakt"`-gren, der aabnede widget'ens
      //   EGNE navn+mail-felter og POSTede dem til vores bagende -> en
      //   spool-fil, som relaeet skulle have toemt. Relaeet er stoppet, saa
      //   koeen havde ingen modtager.
      //   ⚠ Grenen var i forvejen UDEN TRIGGER: `svar.NAESTE_SKRIDT` kan kun
      //     sende `link` og `spoergsmaal`, aldrig `kontakt` (maalt 29/08).
      //     Den blev alligevel SLETTET og ikke slukket - et parkeret udkast
      //     er ikke inert, og naeste haand ville finde den.
      //   ⇒ Shoppens rigtige kontaktformular (`showContact`, vej A) er den
      //     eneste vej. Den leverer til info@g-m.dk - bevist med 799
      //     modtagne mails, senest 17/08/2026.

      // ⛔ ET LINK-FORSLAG SKAL PEGE PAA VORES EGET DOMAENE. Adressen kommer
      // fra serverens `produkt_url`, som `port_produkt_link` allerede kraever
      // er slaaet op - men widget'en tjekker selv, praecis som
      // `tilfoejMedLinks` goer for links i selve teksten. To kontroller om
      // samme ting er billigere end den ene, der svigter.
      if (f.slags === "link") {
        // `egetLinkMaal` parser adressen RIGTIGT (new URL) og returnerer null,
        // hvis vaerten ikke er vores - «https://g-m.dk.ondsindet.dk» indeholder
        // ordret "g-m.dk", men er en fremmed adresse. Samme funktion som
        // `tilfoejMedLinks` bruger; to steder om samme regel er ét for meget.
        // ⭐ 26/08: `tel:` tillades OGSAA her - og KUN her.
        //   `egetLinkMaal` er bevidst uroert: den bruges ogsaa paa MODELLENS
        //   egen prosa i `tilfoejMedLinks`, og dér maa der aldrig kunne staa et
        //   `tel:`-link, en model selv har fundet paa. Forslagene her kommer
        //   derimod fra serverens `svar.NAESTE_SKRIDT` - husets egne, faste
        //   tekster, aldrig modellens. Moenstret er stramt: kun `+`, cifre og
        //   mellemrum, 4-20 tegn. Alt andet giver ingen knap.
        var maal = f.url ? egetLinkMaal(String(f.url)) : null;
        // HOTFIX 30/09 (afg. 252, CEO): et `tel:`-forslag giver ingen knap. Chatten henviser aldrig til telefonen.
        if (!maal) return;              // ikke vores vaert / ikke et gyldigt nummer -> ingen knap
        var a = document.createElement("a");
        // ⭐ 26/08 — EN KNAP DER FORLADER SAMTALEN, MAA IKKE LIGNE EN DER
        //   FORTSAETTER DEN. Maalt paa fladen i dag: `[Se varen]` og
        //   `[Bestil en stofprøve]` stod side om side, visuelt identiske - men
        //   den ene navigerer kunden VAEK fra samtalen, den anden sender en
        //   besked i den. Kunden kan ikke se forskel foer efter klikket, og en
        //   samtale, man er faldet ud af, vender man sjaeldent tilbage til.
        //   Pilen er en affordance, ikke pynt - samme rolle som send-pilen i
        //   feltet, samme tegnede stregvaegt (1,8) som fladens oevrige ikoner.
        a.className = "gmchat-suggestion gmchat-suggestion--link";
        a.appendChild(document.createTextNode(f.tekst));
        a.appendChild(pilIkon());
        a.href = maal;
        a.rel = "noopener";
        wrap.appendChild(a);
        return;
      }
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gmchat-suggestion";
      btn.textContent = f.tekst;
      btn.addEventListener("click", function () {
        wrap.remove();                  // et valgt forslag er ikke laengere et forslag
        // ⭐ 26/08 — `besked` FOER `tekst` (fund 11 og 12, UI-halvdelen).
        //   Fund 11: en kunde, der spoerger generelt om stofproever, skal have
        //   knappen «Bestil en stofprøve» - men den maa ikke pege paa en URL,
        //   turen ikke har. Fundets egen ordlyd: knappen «skal da sende teksten
        //   *Hvordan bestiller jeg en stofprøve?* videre».
        //   ⇒ Det kraever, at ETIKETTEN og den BESKED, der sendes, kan vaere to
        //     forskellige ting. Indtil nu sendte widget'en altid etiketten, saa
        //     botten modtog «Bestil en stofprøve» - en ordre, ikke et spoergsmaal.
        //   Fund 12 bruger samme greb: naar knapperne skal understoette bottens
        //   EGET sidste spoergsmaal, er etiketten og spoergsmaalet ikke ens.
        //   Uden feltet er adfaerden praecis som foer.
        spoergBotten((f.besked && String(f.besked).trim()) ? String(f.besked) : f.tekst);
      });
      wrap.appendChild(btn);
    });
    if (!wrap.childNodes.length) return;
    logEl.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
  }

  // ⛔⛔ KUNDENS NAVN OG MAIL PAA SAGEN (CEO 25/08).
  // Hans klage, ordret: *«naar mailen kommer ind, fremgaar der ingen kunde,
  // mail information. Det vil desvaerre sige, at vi ikke kan svare paa
  // henvendelsen fra kunden, da vi ikke ved hvem den kommer fra.»*
  // Serveren skrev `kundens_navn=""` og `kundens_mail=""` haardkodet, fordi
  // felterne aldrig blev spurgt om. Widget'en havde en kontaktformular - men
  // det er SHOPIFYS egen, og den gaar sin egen vej til kundeservice uden at
  // roere vores sag.
  // ⇒ To felter, inline, lige under bottens svar. De POSTer til vores EGEN
  //   bagende og beriger den sag, `eskaler` allerede har skrevet.
  // ⚠ Ét saet ad gangen: uden oprydning ville hver eskalering i en lang
  //   samtale laegge et nyt felt-par oven i det forrige.
  // ⛔ `visKontaktFelter()` FJERNET 29/08 (CEO). Den byggede to felter -
  //   navn og mail - og POSTede `{kontakt:{navn,mail}}` til `/apps/chat`,
  //   hvor bagenden skrev en spool-sag. Ingen henter den koe.
  //   ⚠ `visOrdreFelter()` nedenfor er en ANDEN formular og bliver: den
  //     slaar en ordre op og gemmer intet. Den genbruger `.gmchat-kontakt*`
  //     -CSS'en og `t("kontakt-mail")` - derfor er BEGGE bevaret.

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ ORDREOPSLAG — TO FELTER, IKKE FRI TEKST                        26/08/2026
  // ═══════════════════════════════════════════════════════════════════════════
  // `min_ordre(nummer, mail)` kraever BEGGE dele, og begge skal matche samme
  // ordre (CEO-beslutning 3, 14/08). I dag skal kunden selv gaette det - maalt
  // 26/08, se noten ved den fjerde chip.
  //
  // ⛔ HVAD DEN SENDER, OG HVORFOR DEN IKKE SENDER ET NYT FELT.
  // Widget'en poster `{besked, session}`. Et nyt, ukendt felt (`krop.ordre`)
  // ville vaere den rigtige, varige loesning - men om bagenden TAALER en ukendt
  // noegle er ikke maalt, og en uafproevet aendring paa den vej, kunden bruger,
  // er ikke noget, denne koersel skal indfoere. `krop.produkt` tolereres (den
  // bruges), men det beviser ikke noget om `krop.ordre`.
  // ⇒ Her bygges den STRUKTURELLE del: formularen. Datafeltet er FORESLAAET i
  //   leverancens §6 og bygget paa intet gaetteri.
  //
  // ⛔ OG DEN LAEKKER IKKE DANSK. Beskeden saettes sammen af SHOPPENS EGNE
  // etiketter (`ordre-nummer`, `kontakt-mail`), som allerede er oversat pr.
  // shop. En hardkodet dansk saetning her ville vaere R8-fejlklassen igen:
  // en svensk kunde ville sende dansk til botten.
  function visOrdreFelter(etiket) {
    ryddInlineFormularer();
    if (etiket) addUserMsg(etiket);

    var wrap = document.createElement("form");
    wrap.className = "gmchat-kontakt gmchat-ordre";

    var forklaring = document.createElement("p");
    forklaring.className = "gmchat-kontakt-forklaring";
    forklaring.textContent = tv("ordre-forklaring");
    if (forklaring.textContent) wrap.appendChild(forklaring);

    function felt(navn, type, etiketTekst, autocomplete, inputmode) {
      var id = "gmchat-o-" + navn;
      var l = document.createElement("label");
      l.className = "gmchat-kontakt-label";
      l.setAttribute("for", id);
      l.textContent = etiketTekst;
      var i2 = document.createElement("input");
      i2.type = type; i2.id = id; i2.name = navn;
      i2.className = "gmchat-kontakt-felt";
      i2.autocomplete = autocomplete;
      // ⛔ `spellcheck=false` paa mailfeltet: browserens stavekontrol
      //   understreger - og retter paa mobil - en fuldt gyldig adresse.
      //   Aabent guidelines-fund fra 21/08.
      if (type === "email") i2.spellcheck = false;
      // Rigtigt tastatur paa mobil: mail-tastatur til mailen (ui-ux-pro-max §8,
      // `input-type-keyboard`). Ordrenummerets tastatur er en SHOP-indstilling,
      // ikke en konstant - se `ordreInputmode()` og roed hat H2/H3.
      if (inputmode) i2.inputMode = inputmode;
      wrap.appendChild(l); wrap.appendChild(i2);
      return i2;
    }
    var fNr = felt("ordrenummer", "text", tv("ordre-nummer"), "off", ordreInputmode());
    var fMail = felt("mail", "email", t("kontakt-mail"), "email");

    var knap = document.createElement("button");
    knap.type = "submit";
    knap.className = "gmchat-submit gmchat-kontakt-send";
    knap.textContent = tv("ordre-send");
    wrap.appendChild(knap);

    var status = document.createElement("p");
    status.className = "gmchat-kontakt-status";
    status.setAttribute("role", "status");
    wrap.appendChild(status);

    wrap.addEventListener("submit", function (e) {
      e.preventDefault();
      var nr = fNr.value.trim(), mail = fMail.value.trim();
      // ⛔ BEGGE dele kraeves - opslaget kan ikke lade sig goere med én af dem,
      //   og det er aerligere at sige det her end at sende et halvt opslag af
      //   sted og lade botten svare «det kunne jeg ikke finde».
      //   Fejlen staar VED felterne og flytter fokus til det foerste tomme
      //   (ui-ux-pro-max §8, `focus-management`).
      if (!nr || !mail) {
        status.textContent = tv("ordre-mangler");
        (nr ? fMail : fNr).focus();
        return;
      }
      var linjer = [];
      if (tv("ordre-nummer")) linjer.push(tv("ordre-nummer") + ": " + nr);
      else linjer.push(nr);
      linjer.push(t("kontakt-mail") + ": " + mail);
      wrap.remove();
      spoergBotten(linjer.join("\n"));
    });

    logEl.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
    fNr.focus();
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // FAKTA-MÆRKER — den STRUKTURELLE halvdel                         26/08/2026
  // ═══════════════════════════════════════════════════════════════════════════
  // Laeser `svar.svar.fakta` (en liste af {etikette, vaerdi}) og goer INTET,
  // hvis feltet mangler. Der er ingen moenstergenkendelse mod fri tekst nogen
  // steder: et regex efter tal i et modelsvar fejler stille paa formuleringer
  // som «89 kr., proeven koster 15», og et forkert tal loeftet ud i et maerke er
  // vaerre end intet maerke.
  // ⇒ Feltet er foreslaaet til bagende-sporet i leverancens §6. Indtil det
  //   findes, er denne funktion inaktiv - og det er den aerlige tilstand.
  function visFakta(fakta) {
    if (!fakta || !fakta.length) return;
    var wrap = document.createElement("div");
    wrap.className = "gmchat-fakta";
    fakta.forEach(function (f) {
      if (!f || !f.vaerdi) return;
      var m = document.createElement("span");
      m.className = "gmchat-fakta-maerke";
      if (f.etikette) {
        var e = document.createElement("span");
        e.className = "gmchat-fakta-etikette";
        e.textContent = String(f.etikette);
        m.appendChild(e);
      }
      var v = document.createElement("span");
      v.className = "gmchat-fakta-vaerdi";
      v.textContent = String(f.vaerdi);
      m.appendChild(v);
      wrap.appendChild(m);
    });
    if (!wrap.childNodes.length) return;
    logEl.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐ TILFREDSHED — TOMMEL OP/NED PÅ ET AI-SVAR                01/09 (Spor 2, A)
  // ═══════════════════════════════════════════════════════════════════════════
  // Design, ikke bare en knap: to smaa, tegnede ikoner (stregvaegt 1,5 - laent
  // op ad husets øvrige fire, ALDRIG en unicode-glyf, se `pilIkon()`s egen
  // note om netop det), sat DIREKTE under den boble, de bedømmer - ikke
  // nederst i loggen, hvor referencen til svaret ville gaa tabt. Ét sæt pr.
  // svar, ét valg ad gangen, og valget kan fortrydes ved at klikke igen.
  //
  // ⛔ TEKSTEN GAAR GENNEM OVERSAETTELSESLAGET, IKKE HARDKODET. Huset fandt
  //   for nylig en haardkodet "Sender…"-streng UDEN for `t()`/`tv()` (denne
  //   fil, `contactSubmit.textContent = "Sender…"` - urørt af denne kørsel,
  //   en anden agents fund). Samme fejlklasse maa ikke gentages her: BEGGE
  //   stemme-etiketter kommer fra `tv()`, som følger husets faste trappe i
  //   `.liquid`-filen (find nøglen → dansk fallback KUN paa en dansk shop →
  //   tom streng ellers). Mangler ÉN af de to, udebliver HELE raekken - en
  //   halv afstemning (kun "godt", intet "daarligt") er vaerre end ingen.
  //
  // ⛔⛔ RETTET 01/09/2026 (RETTELSE X, G5) — DENNE NOTE PAASTOD, AT FUNKTIONEN
  //   IKKE MAATTE KOSTE ET MODELKALD, FORDI SERVEREN "I DAG" INGEN STI HAVDE
  //   TIL AT MODTAGE EN STEMME FØR `foer()`. Det var sandt, DA noten blev
  //   skrevet - det er IKKE laengere sandt om koden 25 linjer nede.
  //   `sendFeedbackHook()` laver et RIGTIGT `fetch(apiEndpoint, ...)`-kald, og
  //   bagenden genkender det: `gm_chat/api.py::do_POST` tjekker
  //   `isinstance(krop.get("feedback"), dict)` LIGE EFTER HMAC-kontrollen og
  //   FØR `botten_er_stoppet()`/`foer()` overhovedet naas (~linje 638-640,
  //   `_behandl_feedback`/`_feedback_fra_krop`) - saa hverken en stemme eller
  //   en fortrudt stemme koster et modelkald.
  //   ⇒ Ledelsesregel 7: et forbud/en paastand rettes DÉR hvor den staar,
  //     samme dag den holder op med at vaere sand - filens egen top-note
  //     (Storage-blokken, 27/08) beskriver samme princip.
  function tommelIkon() {
    // ⭐ ÉT tegnet ikon, to retninger - "ned" er en CSS-spejling
    //   (`.gmchat-feedback-knap--ned .gmchat-tommel { transform: scaleY(-1) }`
    //   i `gm-chat-widget.liquid`s egen <style>-blok), ikke to haandtegnede
    //   stier der kan drive fra hinanden.
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("class", "gmchat-tommel");
    svg.setAttribute("viewBox", "0 0 20 20");
    svg.setAttribute("fill", "none");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    var p = document.createElementNS(ns, "path");
    p.setAttribute("d",
      "M7.3 8.2v8.6a1 1 0 01-1 1H4.6a1.3 1.3 0 01-1.3-1.3V9.5a1.3 1.3 0 011.3-1.3h2.7zm0 0l3.3-5.9c.3-.5.9-.7 1.4-.4.9.5 1.4 1.6 1.1 2.7l-.7 2.6h3.2a1.9 1.9 0 011.9 2.2l-1 5.6a2 2 0 01-2 1.7H7.3");
    p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "1.5");
    p.setAttribute("stroke-linecap", "round");
    p.setAttribute("stroke-linejoin", "round");
    svg.appendChild(p);
    return svg;
  }

  // ⛔⛔ RETTET 01/09/2026 (RETTELSE X, G5) — DENNE NOTE KALDTE KONTRAKTEN
  //   "FORESLAAET, IKKE BYGGET" og henviste til et fravaerende hook. Den ER
  //   bygget og live (se noten ovenfor). Hvad funktionen FAKTISK sender, hver
  //   gang kunden klikker en tommel:
  //        { "session": "<sessionVedRender>",  // FROSSET ved RENDER, ikke
  //                                             //   laest ved KLIK - se R1
  //                                             //   nedenfor og `visFeedback`
  //          "feedback": {
  //            "vaerdi": "op" | "ned" | "ingen",  // "ingen" = fortrudt, HUL 2
  //            "tur": <heltal>             // svarets EGET `tur_nr`, HUL 1
  //          } }
  //   `tur` er BEVIDST ikke et uddrag af selve svarteksten - §D i
  //   `persondata-rammer.md` peger paa at holde en stemme saa fritekst-fri
  //   som muligt. Bagenden slaar `tur` op i `s.historik` (som allerede gemmer
  //   samtalen i raekkefølge) for at se, HVILKET svar der blev bedømt, uden
  //   at klienten selv sender teksten igen.
  //
  //   TRE LUKNINGER AF DENNE FUNKTIONS EGNE HULLER, ALLE 01/09:
  //     HUL 2 (Spor 5) - EN FORTRUDT STEMME: klikker kunden den knap, der
  //       allerede er valgt, sendes IKKE laengere ingenting. `vaelg()` sender
  //       nu "ingen", og `gem_feedback()` (logg.py) skriver det som AEGTE
  //       NULL/NULL - ikke som strengen "ingen" - saa en fortrudt stemme rent
  //       faktisk forsvinder fra basen igen.
  //     HUL 1 (Spor 5) - `tur` ER IKKE `botSvarTaeller`. Den taeller
  //       nulstilles ved hvert sideskift, mens samtalen ikke goer - `tur` er
  //       svarets eget `tur_nr` (se `spoergBotten`), gemt PAA BOBLEN, ikke i
  //       en sidevisnings-taeller.
  //     R1 (RETTELSE X) - SAMME FEJLKLASSE, ÉN TUR-CYKLUS SENERE: HUL 1
  //       lukkede SIDESKIFT (F5), men ikke SESSIONSROTATION. `tur` blev laest
  //       fra boblen (render-tid, korrekt) - men `session` blev laest fra
  //       MODULVARIABLEN `sessionId` VED KLIK, ikke ved render. Serveren
  //       udsteder et NYT session-id ved genstart (~6x/dag) og efter 60
  //       minutters udloeb; loggen ryddes ikke ved rotationen, saa AELDRE
  //       bobler stod med levende knapper og et GAMMELT tur-nummer, mens
  //       `sessionId` allerede pegede paa den NYE session. Parret (nyt id,
  //       gammelt tur-nr) er GYLDIGT i basen - blot for en ANDEN samtale - saa
  //       stemmen blev skrevet paa en tur, kunden ikke bedoemte.
  //       ⇒ Samme raettelse som HUL 1: en LOKAL kopi tages VED RENDER
  //         (`sessionVedRender` i `visFeedback`) og sendes med -
  //         modulvariablen `sessionId` laeses aldrig igen ved klik.
  // ⛔⛔ RETTET 01/09/2026 (RØD HAT RUNDE 2, G5) — RETURNERER NU ET LØFTE OM
  //   UDFALDET I STEDET FOR AT VÆRE ET RENT FIRE-AND-FORGET-KALD.
  //   `vaelg()` satte FØR knappens `aria-pressed` UBETINGET, allerede før
  //   dette kald overhovedet var startet — og `.catch` gjorde intet ud over
  //   at sluge fejlen. Tre veje endte dermed i «intet gemt», mens tommelen
  //   stod trykket: en rate-limit-afvisning, `gem_feedback` der ikke fandt
  //   raekken, eller en databasefejl. En medarbejder, der senere åbner
  //   dashboardet, læser fraværet af en stemme som "ingen mening" — ikke
  //   som "stemmen gik tabt undervejs".
  //   ⇒ Løftet resolver `true` KUN ved et 2xx-svar; ellers (non-2xx,
  //     netværksfejl, en synkron kastning) `false`. `vaelg()` bruger det til
  //     at sætte `aria-pressed` EFTER et bekræftet svar, aldrig før.
  function sendFeedbackHook(vaerdi, tur, sessionVedRender) {
    // ⛔⛔ RETTET 01/09 (Spor 5, HUL 2) — HER STOD "Et fortrudt valg (vaerdi
    //   === null, se vaelg()) sender INTET". Det var husets andet hul: klik
    //   kunden den ALLEREDE valgte knap igen (fortryder), stod den forrige
    //   stemme uroert i basen, mens kunden troede, hun havde trukket den
    //   tilbage - serveren og kunden var uenige, og INGEN af dem vidste det.
    //   `vaelg()` sender nu "ingen" i stedet for at udeblive helt ved en
    //   fortrydelse - en TREDJE, EKSPLICIT hvidlistet vaerdi, ikke et fravaer
    //   af kald. `gem_feedback()` (logg.py) genkender den og skriver AEGTE
    //   NULL/NULL, praecis skemaets egen dokumentation for "ingen feedback".
    // ⛔ HVIDLISTEN FEJLER STADIG LUKKET: kun disse tre strenge sendes -
    //   enhver anden vaerdi (en fremtidig tastefejl, en anden knap) afvises
    //   HER, foer et eneste byte naar netvaerket.
    if (vaerdi !== "op" && vaerdi !== "ned" && vaerdi !== "ingen") return Promise.resolve(false);
    // RETTELSE X, R1 (01/09): `sessionVedRender`, IKKE modulvariablen
    // `sessionId` - se den store note ovenfor og noten ved `visFeedback`.
    if (!apiEndpoint || !sessionVedRender) return Promise.resolve(false);
    try {
      return fetch(apiSti(""), {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session: sessionVedRender, feedback: { vaerdi: vaerdi, tur: tur } })
      }).then(function (r) { return !!(r && r.ok); })
        .catch(function () { return false; }); // netvaerksfejl - se G5: ingen lyv, ingen skraek
    } catch (e) { return Promise.resolve(false); }
  }

  function visFeedback(boble, tur, gemtFeedback) {
    if (!boble) return;
    var opLabel = tv("feedback-op");
    var nedLabel = tv("feedback-ned");
    // ⚠ Findes KUN én af de to noegler, er affordancen halv - se den store
    //   note ovenfor. Begge SKAL vaere sat, ellers udebliver hele raekken.
    if (!opLabel || !nedLabel) return;

    // ⛔⛔ RETTELSE X, R1 (01/09) — SESSIONEN FRYSES HER, VED RENDER, PRAECIS
    //   SOM `tur`-PARAMETRET ALLEREDE GOER (HUL 1). `visFeedback` kaldes ÉN
    //   gang, lige efter boblen er bygget i `spoergBotten`, hvor `sessionId`
    //   endnu er DENNE tuns session. Klikkes knappen SENERE - efter endnu en
    //   besked har rullet `sessionId` videre til en ny (evt. roteret)
    //   session - skal stemmen STADIG bære den session, boblen faktisk
    //   hørte til. Læses `sessionId` i stedet ved KLIK (som funktionen gjorde
    //   før), rejser stemmen med den session, der er aktiv NU - ikke den,
    //   der var aktiv, da svaret blev vist. Se den store note ved
    //   `sendFeedbackHook` for hele fejlklassen (samme mønster som HUL 1,
    //   én lag længere ude).
    var sessionVedRender = sessionId;

    var wrap = document.createElement("div");
    wrap.className = "gmchat-feedback";
    wrap.setAttribute("role", "group");
    var ariaGruppe = tv("feedback-aria");
    if (ariaGruppe) wrap.setAttribute("aria-label", ariaGruppe);

    function knap(erNed, label) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "gmchat-feedback-knap" + (erNed ? " gmchat-feedback-knap--ned" : "");
      b.setAttribute("aria-label", label);
      b.setAttribute("aria-pressed", "false");
      b.appendChild(tommelIkon());
      return b;
    }
    var btnOp = knap(false, opLabel);
    var btnNed = knap(true, nedLabel);

    // ⛔ ÉN STEMME AD GANGEN, OG ET KLIK KAN FORTRYDES (briefens krav,
    //   ordret). Klik paa den knap, der ALLEREDE er valgt, nulstiller
    //   stemmen. Klik paa den ANDEN skifter stemmen og slukker den forrige.
    //   `aria-pressed` alene baerer tilstanden - ingen anden node i DOM'et
    //   aendrer størrelse eller position ved et klik, saa der er intet at
    //   "skubbe" i layoutet (briefens andet krav).
    var afsendt = (gemtFeedback === "op" || gemtFeedback === "ned") ? gemtFeedback : null;
    btnOp.setAttribute("aria-pressed", afsendt === "op" ? "true" : "false");
    btnNed.setAttribute("aria-pressed", afsendt === "ned" ? "true" : "false");
    // ⛔⛔ RETTET 01/09/2026 (RØD HAT RUNDE 2, G5) — `aria-pressed` FLYTTET
    //   FRA "FØR fetch" TIL "EFTER et bekræftet 2xx-svar". Se
    //   `sendFeedbackHook`s egen note for hele fejlklassen. Knappen viser nu
    //   først "trykket", når stemmen FAKTISK er gemt. Fejler kaldet
    //   (rate-limit, en tur der ikke findes, en databasefejl, netværk),
    //   forbliver knappen i sin FORRIGE, sande tilstand — INGEN fejltekst,
    //   intet rødt banner, det ville skræmme for én tabt stemme, som kunden
    //   uden videre kan forsøge igen med ét nyt klik. Men den lyver heller
    //   ikke: en knap, der ikke lyser op, ER den sande, umiddelbare
    //   tilbagemelding - hverken skræmmende eller falsk.
    function vaelg(vaerdi) {
      var ny = (afsendt === vaerdi) ? null : vaerdi;
      // ⭐ 01/09 (Spor 5, HUL 2): `ny === null` betyder "fortrudt", ikke
      //   "intet at sende" - traadens egen kontrakt kender ingen `null`
      //   (kun "op"/"ned"/"ingen", se `sendFeedbackHook`), saa oversaettelsen
      //   sker HER, ved graensen mod netvaerket.
      sendFeedbackHook(ny === null ? "ingen" : ny, tur, sessionVedRender).then(function (lykkedes) {
        if (!lykkedes) return; // G5: intet gemt - knappen rører sig ikke, se noten ovenfor
        afsendt = ny;
        btnOp.setAttribute("aria-pressed", afsendt === "op" ? "true" : "false");
        btnNed.setAttribute("aria-pressed", afsendt === "ned" ? "true" : "false");
      });
    }
    btnOp.addEventListener("click", function () { vaelg("op"); });
    btnNed.addEventListener("click", function () { vaelg("ned"); });

    wrap.appendChild(btnOp);
    wrap.appendChild(btnNed);
    // ⭐ Sat lige EFTER boblen, som dens naeste søskende i loggen - ikke
    //   nederst efter fakta/produkter/naeste-skridt, som hører til SVARET
    //   som helhed. Feedbacken hører til TEKSTEN.
    if (boble.parentNode) boble.parentNode.insertBefore(wrap, boble.nextSibling);
  }

  function spoergBotten(besked) {
    try { frigivLager(); } catch (e) {}
    addUserMsg(besked);
    saetVenter(true);
    var krop = { besked: besked };
    if (sessionId) krop.session = sessionId;
    // ⭐⭐ 10/09 — TRE NYE FELTER PÅ KROPPEN. Alle tre er REFERENCER eller
    //   FACIT, aldrig indhold, og alle tre kan udelades uden at noget brækker
    //   (`api.py` læser kun navngivne nøgler og ignorerer ukendte tavst).
    //
    // (c) `billede` — REFERENCEN til en vedhæftning, ALDRIG bytes. `/chat`s
    //     16 KiB-loft er urørt; billedet er allerede uploadet gennem sin egen
    //     dør med sit eget 8 MiB-loft. Se `sendBillede`.
    // ⛔ REFERENCEN SENDES ÉN GANG. Efter turen nulstilles den, ellers ville
    //   samme billede hænge på hver eneste følgende besked, og serveren ville
    //   svare `udloebet` på en vedhæftning, kunden ikke sendte.
    var sendteBillede = "";
    if (vedhaeftId) {
      krop.billede = vedhaeftId;
      sendteBillede = vedhaeftId;
    }
    // (d) ⛔ HER LÅ `kurv_resultat`, OG DET ER FJERNET 10/09 — IKKE GLEMT.
    //     Facit efter en udført kurvplan rejste med kundens NÆSTE besked,
    //     fordi `doem`-ruten manglede. Den findes nu, og dommen hentes
    //     UMIDDELBART efter handlingen (`kurvDom`). Blev feltet stående her,
    //     ville samme facit blive dømt to gange — og den anden dom ville
    //     ramme en kurv, kunden imens kan have ændret.
    // (e) `forrige_session` / `efter_opbrugt` — ARVEN efter «Start ny samtale».
    //     ⛔ Uden dem er tokenloftet pr. session ophævet med ét klik. Se den
    //       store note ved `startNySamtale`: det er DETTE greb, der binder,
    //       og det kan kun håndhæves af serveren. Feltet sendes; Spor B tager
    //       imod. Indtil da er det en FORBEREDT kontrakt, ikke en virkende
    //       spærre — sig det højt, når nogen spørger om budgettet er sikret.
    if (!sessionId && forrigeSession) {
      krop.forrige_session = forrigeSession;
      krop.efter_opbrugt = !!forrigeVarOpbrugt;
    }
    var mitMaerke = turMaerke;
    // ⭐ 27/08 v2.2 — KONTEKSTEN, I TO LAG, OG DET ENE VIRKER I DAG.
    //
    // (a) `krop.produkt` er den EKSISTERENDE, allerede forbrugte kontrakt.
    //     MÅLT i `gm_chat/api.py:406` + `_produkt_fra_krop` (linje 176-199):
    //     feltet plukkes ud, typesikres og bliver til en kontekstlinje modellen
    //     ser. Kun `titel` bruges; `url` kasseres bevidst af bagenden.
    //     ⇒ Frem til i dag blev feltet ALDRIG sendt, fordi `currentProductTitle`
    //       altid var `null` (snippet'en er ikke i produktskabelonen - målt,
    //       se noten ved `laesAktivSide`). Ved at læse den aktive side selv
    //       fylder vi et felt, bagenden allerede forstår: CEO's punkt 5 får
    //       virkning UDEN en eneste ændring på den anden side.
    //
    // (b) `krop.kontekst` er den NYE, låste kontrakt (aktiv + historik).
    //     ⚠ Forgængeren afviste med rette at sende et ukendt felt uden at have
    //       målt, om bagenden tåler det. Det er nu målt, ikke formodet:
    //       `api.py` læser udelukkende navngivne nøgler med `krop.get(...)` og
    //       har INGEN skema-afvisning af ukendte felter. Et ældre API ignorerer
    //       derfor `kontekst` tavst - det kan ikke brække noget.
    //     ⚠ Kroppen er kappet ved 16 KB serverside (`api.py`: `n > 16 * 1024`
    //       → HTTP 413). Konteksten er højst 5 korte poster og ligger langt
    //       under; beskeden selv kappes ved 4.000 tegn.
    var aktivSide = laesAktivSide();
    // ⛔ 10/09: `krop.produkt` ER OG BLIVER ET PRODUKT. Bagendens
    //   `_produkt_fra_krop` gør feltet til kontekstlinjen «kunden ser på
    //   varen …»; en kollektionstitel dér ville påstå, at kunden står på en
    //   vare, der ikke findes. Kollektionen rejser i stedet med i den nye
    //   `kontekst`-kontrakt, hvor den bærer sin egen `type`.
    if (aktivSide && aktivSide.titel && aktivSide.type === "produkt") {
      krop.produkt = { titel: aktivSide.titel, url: aktivSide.url || "" };
    }
    var kontekst = byggKontekst();
    if (kontekst) krop.kontekst = kontekst;
    // ⛔⛔⛔ (f) `kurv` — KUNDENS EGEN KURV, OG DEN SKAL MED PÅ HVER TUR.
    //   RETTET 10/09/2026 EFTER ET MÅLT, TAVST BRUD PÅ HELE KØBSKÆDEN.
    //
    //   Her stod INTET. Kroppen bar `besked, session, billede,
    //   forrige_session, efter_opbrugt, produkt, kontekst` — og serveren
    //   læser `klientens_kurv=_kurv_fra_krop(krop.get("kurv"))`
    //   (`api.py:3841`). Uden feltet blev den `None`, og `_Planlaegger.laes()`
    //   (`kurv.py:1293`) KASTER på `None`:
    //       raise KurvFejl("klienten rapporterede ingen kurv")
    //   ⇒ MÅLT over HTTP, samme tur to gange:
    //       uden feltet : kurv_instrukser = []   ·   kurv.udfald =
    //                     "ukendt_tilstand" («Jeg kunne ikke læse kurven …»)
    //       MED feltet  : kurv_instrukser = [{handling:"tilfoej", …}]
    //   ⇒ LUKKET SLØJFE: ingen kurv → ingen plan → ingen instruks → og
    //     `hentKurv()` blev derfor ALDRIG kaldt, fordi dens eneste kalder er
    //     `kurvUdfoerInstrukser`, som kun kører på en ikke-tom liste. Hver
    //     eneste kunde, der bad om stof i kurven, fik «Prøv igen om lidt» —
    //     for altid. Krav 3.3, 3.4 og 3.5 kunne ikke virke.
    //   ⛔ Og den gamle «målt ende-til-ende over HTTP» var taget med en krop,
    //     INGEN klient sendte. Derfor er `bevis_galleri`s DEL 10 nu bygget af
    //     FELTNAVNENE I DENNE FUNKTION, læst ud af kildeteksten.
    //
    // ⛔⛔ UKENDT ≠ TOM, OG FORSKELLEN ER HELE BESKEDEN TIL KUNDEN.
    //   `hentKurv()` giver `null`, når `/cart.js` ikke kunne læses, og feltet
    //   UDELADES da HELT. Sendte vi `{}`, ville `_kurv_fra_krop` læse det som
    //   en ægte TOM kurv (den kræver nøglen `linjer` eksplicit) — altså en
    //   netværksfejl forvandlet til påstanden «din kurv er tom».
    //
    // ⚠ KURVLÆSNINGEN MÅ ALDRIG KUNNE DRÆBE TUREN. `hentKurv` fanger selv
    //   alt og svarer `null` — men den garanti skal ikke hvile på en ANDEN
    //   funktions indmad, når kundens spørgsmål står på spil. Derfor det
    //   eksplicitte `.catch` her: kan kurven ikke læses, sendes beskeden
    //   alligevel, uden `kurv`-feltet, og serveren svarer «ukendt tilstand»
    //   på kurvdelen i stedet for at tie om hele turen.
    // ⚠ ÉT EKSTRA GET PR. BESKED, sagt højt. `/cart.js` er butikkens egen,
    //   cookie-bårne AJAX-rute; den koster ikke et modelkald og sker parallelt
    //   med at kundens besked allerede står i loggen (`addUserMsg` ovenfor).
    //   Alternativet — kun at hente kurven «når der er brug for den» — kan
    //   ikke bygges: det er SERVEREN, der afgør, om turen er en kurvhandling,
    //   og den afgørelse kræver netop kurven.
    // ⛔ OG EN SYNKRON KASTNING TÆLLER MED. MÅLT 10/09 i husets egen
    //   `test_hul1_tur_nr_sideskift.js`: dens `fetch`-stub kaster SYNKRONT på
    //   en rute, den ikke kender, og så findes der intet løfte at hænge
    //   `.catch` på — kundens besked forsvandt, før den var sendt. Det er ikke
    //   kun en teststub: et tredjeparts-script, der indpakker `window.fetch`,
    //   kan gøre præcis det samme i en rigtig browser. Derfor `try`, ikke kun
    //   `.catch`.
    kurvLoefteSikkert()
      .then(function (svar) {
        var kurv = svar && svar.kurv;
        if (kurv) krop.kurv = kurv;
        else {
          var _kf = kurvfejlTilKrop(svar && svar.fejl);
          if (_kf) krop.kurv_fejl = _kf;
        }
        return fetch(apiSti(""), {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(krop)
        });
      })
      .then(function (r) {
        if (!r.ok) {
          var testAdgangFejl = new Error("HTTP " + r.status);
          testAdgangFejl.gmchatHttpStatus = r.status;
          throw testAdgangFejl;
        }
        return r.json();
      })
      .then(function (svar) {
        // ⛔⛔ 10/09: ER SAMTALEN SKIFTET, MENS SVARET VAR PÅ VEJ, KASSERES DET.
        //   «Start ny samtale» midt i et ventende svar er en af de tilstande,
        //   fladen udtrykkeligt skal kunne. Uden mærket ville det gamle svar
        //   lande under kundens friske log — som et svar på noget, hun ikke
        //   har spurgt om — OG sætte det gamle session-id tilbage i lageret,
        //   så «ny samtale» slet ikke blev ny.
        //   ⚠ Et `AbortController` ville standse KALDET, men ikke et svar, der
        //     allerede er på vej hjem. Mærket dømmer ved MODTAGELSEN og dækker
        //     derfor begge tilfælde.
        if (mitMaerke !== turMaerke) return;
        saetVenter(false);
        // Referencen er brugt. Se noten ved `krop.billede`.
        // ⛔⛔ RETTET 10/09 (W2): REFERENCEN SLIPPES KUN, NÅR SERVEREN HAR
        //   GJORT REDE FOR DEN. Her stod det ubetinget: sendte fladen et
        //   `billede`-felt, blev referencen fjernet, uanset hvad serveren
        //   svarede. MÅLT, med en model der kaster `ModelFejl("HTTP 429 efter
        //   3 forsoeg")`: turen svarer HTTP 200 med husets nedgraderede tekst,
        //   og billedet nåede ALDRIG en model — men fladen fjernede
        //   referencen, så kunden skulle vælge filen igen, og hvert genforsøg
        //   brændte én af de fire tilladte genbrug.
        //   ⇒ `vedhaeftning` er nu kontraktens eneste sandhed om billedet:
        //     feltet ER til stede (`brugt`/`udloebet`), når serveren har
        //     forbrugt referencen, og UDELADT, når den står urørt. Er den
        //     urørt, bliver den siddende på fladen — så kundens næste forsøg
        //     bærer den med, uden at hun skal finde filen frem igen.
        //   ⚠ Og det er derfor kontrakten har TRE tilstande og ikke to: et
        //     FRAVÆR og en TOM værdi betyder forskellige ting. Læste fladen
        //     et fravær som «brugt», var vi tilbage i fejlen.
        //   ⚠ Chippen bliver stående synlig, og ×-knappen virker — kunden kan
        //     altid selv fjerne billedet. Vi beholder det aldrig mod hendes
        //     vilje; vi smider det bare ikke væk på hendes regning.
        var _vedhSvar = (svar && svar.vedhaeftning
                         && typeof svar.vedhaeftning === "object")
          ? String(svar.vedhaeftning.status || "") : "";
        if (sendteBillede && vedhaeftId === sendteBillede
            && (_vedhSvar === "brugt" || _vedhSvar === "udloebet")) {
          fjernVedhaeftning();
        }
        // Serveren udsteder id'et. Kommer der et nyt, er det en NY samtale —
        // vi retter os efter serveren, vi forhandler ikke.
        // ⭐ 27/08 v2.2: id'et gemmes nu, så samtalen overlever, at kunden
        //   klikker et produktlink (CEO's punkt 4). Er id'et NYT, nulstilles
        //   uret - ellers ville en lang samtale arve den første tidsstempling
        //   og blive smidt væk midt i sig selv.
        if (svar && svar.session) {
          var t0 = gemtTilstand();
          var uaendret = t0.session && t0.session.id === svar.session;
          sessionId = svar.session;
          // ⭐ SERVEREN HAR NU EN SAMTALE. Se `kontaktProblem`: fra dette
          //   oejeblik baerer sessionens `historik` samtalen, og den bliver
          //   sagens `conversation_snapshot`. Kontaktindsendelsen skal derfor
          //   IKKE laegge transskriptet i spoergsmaalsfeltet ogsaa - ét sted
          //   eller det andet, aldrig begge og aldrig ingen af dem.
          harServerSamtale = true;
          var nySession = {
            id: svar.session,
            oprettet: uaendret ? t0.session.oprettet : Date.now()
          };
          // ⭐ 10/09: TREDJE ARGUMENT `true` — DETTE ER EN KUNDEBESKED.
          //   Det er det ENESTE sted, `kundeRoert` sættes, og dermed det eneste
          //   sted, samtalens 24 timer forlænges. Et sideskift eller en
          //   kurvkvittering gør det ikke. Se den store note ved
          //   `GEMT_LEVETID_MS`.
          gemTilstand(nySession, t0.historik, true);
          // ⭐ Arven er brugt: en ny samtale er nu ægte ny på serveren.
          //   ⛔ OG DEN SLETTES OGSÅ I LAGERET — ellers ville et sideskift
          //     hente den frem igen og kæde en tredje samtale til den samme
          //     forgænger. En arv bruges én gang.
          forrigeSession = "";
          forrigeVarOpbrugt = false;
          skrivArv("", false);
        }
        // ⭐⭐ 10/09 — VEDHÆFTNINGENS TRE TILSTANDE, OG DE STÅR FØR SVARET.
        //   `vedhaeftning` er «brugt» | «udloebet» | feltet UDELADT, og
        //   KUNDENS TEKST BESVARES I ALLE TRE TILFÆLDE. Derfor er linjen her
        //   en oplysning om BILLEDET, aldrig en erstatning for svaret — og den
        //   står FØR bot-boblen, fordi den handler om det, kunden sendte.
        // ⛔ «udloebet» VISES SOM UDLØBET, IKKE SOM EN FEJL. Se
        //   `visVedhaeftningsSvar`: en rød advarsel ville få kunden til at tro,
        //   at hendes spørgsmål ikke blev besvaret — og det blev det.
        if (svar && svar.vedhaeftning) visVedhaeftningsSvar(svar.vedhaeftning);

        // ⭐ ER BUDGETTET OPBRUGT, ER «START NY SAMTALE» KUNDENS UDVEJ.
        //   ⛔ Flaget kommer fra SERVEREN. Det gættes aldrig ud af svarteksten
        //     — husets canned-svar er dansk prosa, og en tekstprøve på den
        //     ville være den samme fejlklasse som de 291 «danske» SE-handles,
        //     der reelt var 43.
        if (svar && svar.opbrugt) {
          forrigeVarOpbrugt = true;
          visNySamtaleKnap(true);
        }

        // ⭐ KURVEN, FASE 2: fladen UDFØRER den plan, serveren har lagt.
        //   ⛔ Fladen bygger aldrig selv en plan — se den store note ved
        //     `kurvUdfoerInstrukser`. Og den kvitterer aldrig selv.
        // ⛔⛔ FELTERNE LIGGER I `svar.svar`, IKKE PÅ SVARETS ROD.
        //   Målt i `api.py:4130`: `_svar_ud` ER `svar["svar"]`, og det er DER
        //   `kurv`/`kurv_instrukser` sættes med `setdefault`. Læst på roden er
        //   de altid `undefined`, og hele kurvkæden ligger død uden en eneste
        //   fejl — den tavse form er hele grunden til, at bruddet stod uset.
        var _svarkrop = (svar && svar.svar) ? svar.svar : null;
        if (_svarkrop &&
            Object.prototype.toString.call(_svarkrop.kurv_instrukser) === "[object Array]" &&
            _svarkrop.kurv_instrukser.length) {
          kurvUdfoerInstrukser(_svarkrop.kurv_instrukser);
        }
        // Husets EGEN kurvkvittering (`_kurvkvittering_ud`). ⚠ Den er
        // deterministisk tekst uden om modellen, fordi en kurvtotal ingen
        // enhed har og derfor går RØD i `port_beloebsform` i enhver form,
        // modellen kunne skrive den i. Det er værnet, der virker.
        // ⚠ `null` er den normale tilstand (ingen kurvhandling i denne tur) —
        //   feltet er ALTID til stede, så et fravær betyder intet her.
        if (_svarkrop && _svarkrop.kurv) visKurvkvittering(_svarkrop.kurv);

        var tekst = (svar && svar.svar && svar.svar.tekst) || "";
        if (!tekst) { showNoResult(); return; }
        var botBoble = addBotMsg(tekst);
        // ⭐ 01/09 (Spor 2, opgave A) - se `visFeedback` for hele
        //   begrundelsen. ⚠ IKKE paa en degraderet besked: `stoppet`/
        //   `opbrugt` er husets EGNE canned-svar (noedstop/sessionsloft,
        //   `api.py` linje ~439/573), ikke et AI-svar - der er intet at
        //   bedømme, og en afstemning paa en fejlmeddelelse ville maale
        //   forkert ting.
        // ⛔⛔ 01/09 (Spor 5, HUL 1) — TUR'EN KOMMER FRA SVARET, IKKE FRA EN
        //   SIDEVISNINGS-TAELLER. Se den fjernede `botSvarTaeller` ovenfor.
        //   `svar.tur_nr` er serverens sekvensnummer FOR DENNE SAMTALE
        //   (`Session.beskeder`), som overlever et sideskift, fordi selve
        //   sessionen goer det. Den gemmes PAA BOBLEN (`dataset`), saa en
        //   stemme altid peger paa den tur, teksten faktisk hoerer til -
        //   ikke bare paa en variabel, der tilfaeldigvis havde den rigtige
        //   vaerdi i DETTE kald.
        // ⚠ MANGLER `tur_nr`, eller er det ikke et positivt heltal (aeldre
        //   bagende der endnu ikke sender feltet, eller et fremtidigt
        //   fejlsvar) - VIS INGEN feedback-knapper. Bedre ingen knap end
        //   en stemme, der bliver skrevet paa den forkerte tur.
        if (!(svar && (svar.stoppet || svar.opbrugt))) {
          var turNr = (svar && typeof svar.tur_nr === "number" &&
                       isFinite(svar.tur_nr) &&
                       svar.tur_nr === Math.floor(svar.tur_nr) &&
                       svar.tur_nr > 0) ? svar.tur_nr : null;
          if (turNr !== null) {
            botBoble.dataset.gmchatTurNr = String(turNr);
            visFeedback(botBoble, turNr);
          }
        }
        // Fakta-maerker, hvis bagenden en dag sender dem struktureret. Uden
        // feltet sker der intet - se noten ved `visFakta`.
        if (svar.svar && svar.svar.fakta) visFakta(svar.svar.fakta);
        // ⭐ 27/08 v2.2 — PRODUKTKORTENE (CEO's punkt 2 og 3).
        var antalVarer = (svar.svar && svar.svar.produkter)
          ? visProdukter(svar.svar.produkter) : 0;
        // Samme princip for ordreopslaget: beder bagenden struktureret om de to
        // felter, aabner widget'en formularen i stedet for at lade kunden gaette
        // formatet i fri tekst. Uden flaget er chippen den eneste indgang, og
        // begge veje ender samme sted.
        if (svar.svar && svar.svar.ordre_felter && tv("ordre-send")) {
          visOrdreFelter(null);
        }
        // ⛔ NAESTE SKRIDT UNDER SVARET (CEO 24/08).
        // Forslagsknapper fandtes allerede - men KUN i `renderIntro()`, altsaa
        // foer foerste besked. De forsvandt i samme oejeblik kunden skrev noget,
        // og derefter endte hver samtale blindt. Det er dér, en kunde gaar til
        // telefonen. Teksterne kommer fra SERVEREN (`svar.NAESTE_SKRIDT`), er
        // husets egne og formuleres aldrig af modellen.
        // ⛔⛔ 27/08 v2.2 — DEN TVETYDIGE FÆLLESKNAP FJERNES. CEO's punkt 3 og
        //   konverteringssporets fund 6, som er ÉN fejl set fra to sider:
        //     · punkt 3: tre varer omtalt, én «Se varen»-knap → den peger på den ene;
        //     · fund 6 (målt): «Se varen» stod **9 gange af 39 ture** under et svar,
        //       der sagde, at vi ikke har varen.
        //   Begge er den samme mekanik: `svar.naeste_skridt()` vælger knappen ud fra
        //   hvad turen TILFÆLDIGVIS slog op, ikke ud fra hvad svaret handler om.
        //
        // ⇒ Afgørelsen træffes på et felt, bagenden EJER - aldrig på en gætning
        //   over svarteksten. Forgængeren målte hvorfor en tekstprøve ikke duer:
        //   handles er ASCII (`moerklaegningsstof`), svaret skriver dansk
        //   («mørklægningsstof»), og en handle-mod-tekst-sammenligning ville
        //   fjerne en BERETTIGET knap (samme fejlklasse som de 291 «danske»
        //   SE-handles, der reelt var 43).
        //
        //   Tre tilstande, og den tredje er hele sikkerheden:
        //     (1) `produkter` har varer  → kortene ER de per-vare-knapper, CEO
        //         beder om. En generisk produktknap ovenpå er nu både overflødig
        //         OG tvetydig → den ryger.
        //     (2) `produkter` er et TOMT array → bagenden siger udtrykkeligt
        //         «denne tur har ingen relevant vare». Så må der ikke stå en
        //         «Se varen»-knap. Det lukker fund 6 deterministisk.
        //     (3) `produkter` MANGLER helt (dagens bagende) → vi ved intet, og
        //         fladen opfører sig NØJAGTIG som i går. Ingen regression, og
        //         nødstoppet degraderer nedad, aldrig sidelæns.
        // ⚠ Kun PRODUKT-links filtreres. En `tel:`-knap, en «Skriv til os» og en
        //   almindelig forslagsknap er ikke tvetydige og røres ikke.
        var forslag = (svar.svar && svar.svar.forslag) ? svar.svar.forslag : null;
        if (forslag && forslag.length) {
          var harListe = !!(svar.svar && Array.isArray(svar.svar.produkter));
          // ⚠ DEGENERERET TILFÆLDE, SAGT HØJT: sendte bagenden varer, men kunne
          //   INGEN af dem renderes (ugyldig eller fremmed URL, tom titel), er
          //   det en fejl hos OS. At fjerne den sidste knap oveni ville gøre
          //   fladen ringere end før - «degradér nedad, aldrig sidelæns». Så
          //   beholder vi den generiske knap som eneste vej til varen.
          if (harListe && svar.svar.produkter.length > 0 && antalVarer === 0) {
            harListe = false;
          }
          if (harListe) {
            forslag = forslag.filter(function (f) {
              if (!f || f.slags !== "link") return true;
              return String(f.url || "").indexOf("/products/") === -1;
            });
          }
          forslag = relevanteProeveForslag(forslag, antalVarer > 0);
          if (forslag.length) visNaesteSkridt(forslag);
        }
        // ⭐ AENDRET 25/08. Her stod `showContact(null)`, som aabner SHOPIFYS
        // egen kontaktformular. Den gaar sin egen vej til kundeservice og
        // roerer ikke vores sag - derfor stod der «Kunde: (ikke oplyst)» i
        // hver eneste eskaleringsmail, og CEO kunne ikke svare kunden.
        // ⇒ Vores egne to felter, som beriger sagen, botten lige har skrevet.
        //
        // ⛔⛔ AENDRET TILBAGE 28/08 - ROED HAT R1. Rettelsen fra 25/08 var
        // rigtig, SAA LAENGE nogen toemte spoolen. CEO stoppede relaeet 28/08
        // (raa mailvej uden om `tom_email.py`, §5/§30), og saa blev vej B en
        // blindgyde. Maalt samme dag:
        //   * `eskaler: true` saettes UAFHAENGIGT af relaeet (api.py, svar.py,
        //     samtale.py) - flaget siger «der er en sag», ikke «nogen henter».
        //   * vej B byggede praecis TO felter: navn og mail - intet
        //     beskedfelt. (Fjernet 29/08 paa CEO's ord.)
        //   * Husets egen nedgraderingstekst siger ordret «Skriv din besked i
        //     formularen her, saa naar den frem til kundeservice» - og
        //     `porte.py`s egen kommentar ved teksten siger, at den peger paa
        //     «widget'ens kontaktformular (SHOPIFYS egen)». Koden gjorde noget
        //     andet end sin egen dokumentation.
        //   ⇒ Kunden blev bedt om at skrive sin besked et sted, der hverken
        //     kunne modtage en besked eller levere den.
        //
        // Vej A er den BEVISTE vej: 799 mails modtaget i husets egne
        // postkasser via `{% form 'contact' %}` -> info@g-m.dk, senest
        // 17/08/2026. Den har navn, mail OG et beskedfelt, og `showContact()`
        // forudfylder det med produktkontekst + hele transskriptet - saa
        // kundeservice faar MERE end vej B's to felter kunne give.
        //
        // ⚠ VEJ B ER IKKE SLETTET, og den skal tilbage - men BETINGET.
        //   Den dag relaeet taendes igen (CEO's alene), er den rigtige linje:
        //       (vej B er fjernet 29/08 - shoppens formular er eneste vej)
        //   hvor `kan_hente` kommer fra bagendens `porte._nogen_henter_sagen`
        //   - samme kendsgerning, ikke en ny kopi af den. Flaget er ikke bygget
        //   endnu, og det staar her, saa ingen tror det er.
        // B3 30/09 (afg. 204): formular-banneret er fjernet; teksten peger paa telefon/chat.
      })
      .catch(function (fejl) {
        saetVenter(false);
        var status = fejl && fejl.gmchatHttpStatus;
        if (testflade &&
            (status === 401 || status === 403 || status === 404)) {
          hideContact();
          addBotMsg("Testlänken saknas eller har gått ut. Öppna den privata testlänken igen för att fortsätta.");
          return;
        }
        // ⛔ VI LYVER ALDRIG OM EN FEJL - heller ikke om HVILKEN fejl.
        // Her stod `svar-intet` ("det kunne jeg ikke finde et klart svar på i
        // vores hjælpesider"). Den sætning er sand, når søgningen ikke fandt
        // noget - og USAND, når vores eget system ikke svarede. Kunden ville
        // tro, at spørgsmålet var for svært, mens fejlen var vores.
        addBotMsg(t("fejl-svar") || t("svar-intet"));
        // B3 30/09 (afg. 204): formular-banneret er fjernet; teksten peger paa telefon/chat.
      });
  }

  if (searchForm && searchInput) {
    searchForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = searchInput.value;
      if (!q.trim() || venter) return;
      searchInput.value = "";
      if (apiEndpoint) { spoergBotten(q); return; }
      // DEGRADERING: ingen bagende → FAQ-søgning, præcis som før.
      // ⛔⛔ RØD HAT RUNDE 4, A1 — EN TREDJE BÆRER AF SAMME SVAR, MED EN ANDEN
      //   ADFÆRD. Her stod `addBotMsg(hits[0].svar || …)` direkte, og DENNE vej
      //   læste hverken `eskalerer_altid` eller `opslag_paakraevet`. Altså:
      //     knappen   → `answerFromFaq` → åbner kontaktformularen og sætter
      //                 prøveprisen på
      //     fritekst  → samme tekst, INGEN formular, INGEN pris
      //   MÅLT 10/09 med widget'ens egen `searchFaq`: «hel rulle», «20 ruller»,
      //   «engros mængde», «pakkestørrelse» rammer alle K-06, og «retur» /
      //   «fortrydelsesret» rammer K-21. K-06 og K-11 bærer
      //   `eskalerer_altid: true` og siger ORDRET «skriv … i formularen her» —
      //   og formularen står `hidden` i Liquid'en, indtil `showContact` kaldes.
      //   Kunden blev altså bedt om at skrive i et felt, der ikke var på
      //   skærmen: husets 07/08-fejlklasse ordret (udført fra systemets side,
      //   brudt fra kundens), og præcis det CEO's krav R1 forbyder.
      // ⇒ ÉN vej ind i et FAQ-svar. `answerFromFaq` gør `addUserMsg` selv, og
      //   `loadFaq` er idempotent (`if (faqLoaded …) return Promise.resolve()`),
      //   så genbruget koster intet. To kopier af «sådan besvares et FAQ-emne»
      //   drev fra hinanden — det er husets mest gentagne fejl i dag.
      loadFaq().then(function () {
        var hits = searchFaq(q);
        if (hits.length) {
          answerFromFaq(hits[0].id, q);
        } else {
          addUserMsg(q);
          showNoResult();
        }
      });
    });
  }

  // ⛔ Knappen er fjernet 21/08 (CEO). Lytteren maa taale, at elementet ikke
  // findes - uden vagten kastede `humanLink.addEventListener` paa null og
  // stoppede HELE widget-opstarten, saa chatten slet ikke virkede.
  // B3 30/09 (afg. 204): formular-banneret er fjernet; teksten peger paa telefon/chat.
  //   Lytteren paa menneske-linket er fjernet (knappen er vaek siden 21/08).

  // ---------- Kontaktomraadets tilstand — ÉT sted, aldrig to ----------
  // ⛔⛔ ROED HAT R1+R3, 04/09/2026. TO switches modsagde hinanden, og kunden
  //   betalte:
  //     if (statusOk) statusOk.hidden = false;   // "vis kvitteringen"
  //     openPanel(null);                          // → renderIntro() → hideStatus()
  //     contactSection.hidden = true;             // → display:none paa FORAELDEREN
  //   Begge de to sidste linjer slog den foerste ihjel, hver for sig og
  //   uafhaengigt af hinanden. MAALT paa skaermen med Chrome:
  //   «KVITTERING=USYNLIG (0 client rects)». Kunden trykkede Send, siden
  //   genindlaeste, chatten aabnede med den generiske velkomsttekst - intet
  //   spor af hendes besked, ingen kvittering. Samme mekanik ramte fejlgrenen.
  // ⚠ RODEN ER IKKE RAEKKEFOELGEN, den er at tilstanden blev sat FLERE steder.
  //   En raekkefoelge-rettelse holder til naeste gang nogen tilfoejer en linje.
  //   Derfor: én overgang, sat ét sted. `.gmchat-status--ok`/`--fejl` er BOERN
  //   af `.gmchat-contact` (se .liquid), saa i kvitteringstilstanden skjules
  //   FELTERNE - aldrig sektionen, for saa forsvinder kvitteringen med den.
  // ⚠ `felt.hidden` virker kun, fordi CSS'en fik `.gmchat-field[hidden]` og
  //   `.gmchat-submit[hidden]` samme dag: begge saetter selv `display`, og
  //   browserens egen `[hidden]`-regel taber paa specificitet. Uden dem er
  //   linjen herunder en tavs no-op.
  var KONTAKT_SKJULT = "skjult";
  var KONTAKT_FELTER = "felter";
  var KONTAKT_KVITTERING = "kvittering";
  //: ⛔⛔ SAGSKVITTERINGEN ER IKKE MAILKVITTERINGEN (12/09/2026).
  //:   `.gmchat-status--ok` er Shopifys LEGACY-succesboks. Liquid'en renderer
  //:   den paa `form.posted_successfully?` (widget-liquid linje 1019) og dens
  //:   tekst er `gmchat.kvittering` - «din besked er naaet frem til os paa
  //:   mail». Den er SAND paa den native vej, som `showServerState()` viser.
  //:   Paa vores API-201-vej er der IKKE sendt nogen mail: serverens
  //:   mailtransport er fysisk deaktiveret, sagen ligger i sagslageret.
  //:   ⇒ MAALT paa en rigtig browserprove (sag NWBU567C): kunden fik BEGGE
  //:     statusser, og den ene loej om, at der var sendt mail.
  //: ⭐ Derfor en EGEN tilstand: felterne skjules praecis som ved en
  //:   kvittering, men legacy-boksen forbliver skjult, fordi `statusOk`
  //:   fortsat kun vises ved `KONTAKT_KVITTERING` - den native vej.
  //: ⛔ Den native vej er UROERT: `showServerState()` kalder stadig
  //:   `KONTAKT_KVITTERING`, og dér ER mailen faktisk afsendt.
  var KONTAKT_KVITTERING_SAG = "kvittering-sag";
  var KONTAKT_FEJL = "fejl";

  // ⛔⛔ TILSTANDEN BAERES I EN VARIABEL, IKKE I DOM'ET (rettet 04/09, R6).
  //   MAALT: kunden faar en fejl, lukker chatten et sekund og aabner igen -
  //   fejltekst OG formular er vaek. `openPanel()` kalder ubetinget
  //   `hideContact()`, og kun `showServerState()`s kaldeorden reddede den
  //   FOERSTE visning; alt derefter var tabt.
  //   Min egen note fra i morges sagde «RODEN ER IKKE RAEKKEFOELGEN» - og saa
  //   lod jeg roden staa: den eneste hukommelse om tilstanden var DOM'ets
  //   `hidden`-attributter, som `openPanel` selv nulstiller. En tilstand, der
  //   kun bor dér, hvor den bliver slettet, er ingen tilstand.
  //   ⇒ Ét sted HUSKER (denne variabel), ét sted SAETTER
  //     (`saetKontaktTilstand`), og `openPanel` GENSKABER.
  var kontaktTilstand = KONTAKT_SKJULT;

  // ⛔ MARKOEREN, DER GOER WIDGET'ENS EGET INDSTIK I BESKEDFELTET GENFINDELIGT.
  //   Se den lange note i `showContact`: hukommelsen om «hvad skrev vi sidst»
  //   laa i en DOM-egenskab, som doer ved sidegenindlaesning - og fra 04/09
  //   fylder Liquid feltet igen efter en fejlet afsendelse. Resultatet var to
  //   (og saa tre, og fire) transskripter i samme felt. En markoer i selve
  //   teksten kan ikke doe.
  // ⚠ BEVIDST SPROGNEUTRAL. Feltet ses ogsaa af svenske og norske kunder;
  //   `--- SAMTALE I WIDGET'EN ---` er dansk paa alle tre flader i forvejen,
  //   og den gaeld skal ikke vokse. Dette er et maskinmaerke, ikke en saetning.
  // ⚠ VAERDIEN MAA ALDRIG AENDRES UDEN SAMME DAG AT RYDDE FELTET: en gammel
  //   markoer i et felt, koden ikke laengere kender, bliver til kundens tekst.
  var KONTAKT_BLOK_START = "--- [gm-chat] ---";
  // ⛔⛔ SLUTMARKOEREN — TILFOEJET 05/09 (R1). Se den lange note ved
  //   `fjernVoresBlok`: med kun en STARTmarkoer kunne koden ikke se, hvor
  //   vores blok holdt op, og «fjern vores blok» var i praksis «afkort ved
  //   vores blok». Alt kunden skrev UNDER blokken blev slettet tavst.
  // ⚠ Den indeholder BEVIDST ikke startmarkoeren som delstreng («[/gm-chat]»
  //   mod «[gm-chat]»), saa en soegning efter den ene aldrig rammer den anden.
  var KONTAKT_BLOK_SLUT = "--- [/gm-chat] ---";
  // ⛔ ÉN EJER af transskriptets hovedlinje. Den skrives af `buildTransskript`
  //   og LAESES af `erVoresBlokLinje` (bagudkompatibiliteten for gamle blokke
  //   uden slutmarkoer). To kopier af samme streng ville drive fra hinanden.
  var TRANSSKRIPT_HOVED = "--- SAMTALE I WIDGET'EN ---";

  // ⚠ FELTERNE SKJULES KUN I KVITTERINGSTILSTANDEN — ogsaa naar hele omraadet
  //   er kollapset, staar de som "ikke skjulte". Det er bevidst og maalt:
  //   `bevis_design.sh` (og enhver anden maaler af den slags) aabner formularen
  //   ved at saette `.gmchat-contact.hidden = false` DIREKTE, uden at gaa
  //   gennem denne funktion — praecis som fladen selv gjorde, foer der fandtes
  //   en tilstandsmaskine. Efterlod `KONTAKT_SKJULT` et `hidden` paa hvert
  //   felt, ville den aabning vise en TOM sektion, og kontrastmaalingen paa
  //   `#gmchat-contact-name` ville maale et `display:none`-element.
  //   MAALT 04/09 i Chrome, ad praecis den vej (klik launcher → panelet
  //   aabner → `hideContact()` koerer → `c.hidden = false`):
  //     som koden staar nu ......... navn/epost SYNLIG 384x44, send 92x44,
  //                                  sektionen 416x315
  //     hvis SKJULT ogsaa satte
  //     `hidden` paa felterne ...... ALLE USYNLIGE, sektionen 416x29 — en
  //                                  tom kasse, og kontrastmaalingen maaler
  //                                  et `display:none`-element
  //   Tilstanden er stadig TOTAL — hver af de fire tilstande saetter alle
  //   fire ting — saa der efterlades ingen rest fra en tidligere tilstand.
  function saetKontaktTilstand(tilstand) {
    kontaktTilstand = tilstand;
    if (!contactSection) return;
    // ⚠ Felterne skjules ved BEGGE kvitteringstilstande; legacy-boksen
    //   nedenfor vises kun ved den native (`KONTAKT_KVITTERING`).
    var skjulFelter = tilstand === KONTAKT_KVITTERING
      || tilstand === KONTAKT_KVITTERING_SAG;
    contactSection.hidden = tilstand === KONTAKT_SKJULT;
    if (statusOk) statusOk.hidden = tilstand !== KONTAKT_KVITTERING;
    if (statusFejl) statusFejl.hidden = tilstand !== KONTAKT_FEJL;
    var felter = contactSection.querySelectorAll(".gmchat-field, .gmchat-submit");
    for (var i = 0; i < felter.length; i++) felter[i].hidden = skjulFelter;
    // ⛔ R2 (greb c), 05/09: staar formularen fremme, SKAL dens knap kunne
    //   trykkes. Vej 3 i maalingen var netop «luk panelet, aabn igen»:
    //   `openPanel()` gaar gennem `hideContact()` og lander her, saa
    //   genaabningen frigiver knappen uden at vente paa tidsrummet.
    // ⚠ Ikke i kvitteringstilstanden: dér er felterne skjult, og der er intet
    //   at sende. At tegne en frisk «Send»-knap oven paa en kvittering ville
    //   invitere til en dublet af en sag, der ER afsendt.
    // ⛔⛔ G1, 05/09/2026 — DETTE GREB GJORDE TRE PROEVER BLINDE.
    //   Greb (c) er saa bredt, at det frigiver knappen FOER tidsrummet (a) og
    //   `pageshow` (b) naar at betyde noget. MAALT: med `SEND_GENDAN_MS=0`,
    //   med `=1e9`, og med `pageshow`-lytteren FJERNET overlevede scenarie
    //   11a og 11c alle tre — exit 0. De to ben havde altsaa nul vagt, og
    //   `SEND_GENDAN_MS` — konstanten, der afgraenser den accepterede
    //   dobbeltafsendelse — kunne saettes til hvad som helst uden at noget
    //   blev roedt.
    // ⇒ Maaleskriptet kan neutralisere PRAECIS dette greb, saa (a) og (b) kan
    //   maales hver for sig. Greb (a) og (b) er uroerte af flaget.
    // ⚠ FLAGET MAA ALDRIG UDRULLES. Det staar ikke i .liquid'en, og
    //   `test_formular_blindgyde.js` maaler at det ikke goer — sattes det paa
    //   fladen, mistede kunden vej 3 ud af den doede knap.
    if (!skjulFelter && !root.dataset.gmchatIngenTilstandsfrigivelse) {
      frigivSendKnap();
    }
  }

  function showContact(prefill) {
    if (!contactSection) return;
    saetKontaktTilstand(KONTAKT_FELTER);
    // Kundens felt indeholder kun kundens egne ord. Samtalen følger ticketen
    // separat fra serveren; gamle automatisk indsatte blokke fjernes nænsomt.
    if (contactMessageField) {
      contactMessageField.value = fjernVoresBlok(contactMessageField.value || "").trim();
    }
    var firstField = contactSection.querySelector("input, textarea");
    if (firstField) firstField.focus();
  }

  // Kollapser HELE kontaktomraadet: felter, kvittering og fejltekst. Den hed
  // engang kun "hideContact", og ved siden af den laa `hideStatus()`, som
  // skjulte de to statusbokse. To funktioner, samme omraade - og det var netop
  // den todeling, R1/R3 udnyttede. `hideStatus` er fjernet 04/09; der findes
  // én overgang.
  function hideContact() {
    saetKontaktTilstand(KONTAKT_SKJULT);
  }

  // ⛔⛔ G4, 04/09/2026 — MARKOEREN KUNNE SKRIVES AF KUNDEN.
  //   MAALT: soegningen «hej --- [gm-chat] --- har I 12 meter?» giver TO
  //   markoerer i beskedfeltet (R7 lover praecis én), fordi kundens egen
  //   tekst gaar i loggen og derfra ordret ind i transskriptet.
  //   Skaden ligger i NAESTE eskalering: `haves.split(KONTAKT_BLOK_START)[0]`
  //   klipper ved den FOERSTE markoer. Er den kundens egen, bliver `kundens`
  //   = "" (den staar foerst i hendes saetning), og HELE feltet - navn paa
  //   varen, hendes spoergsmaal, hele samtalen - kastes vaek uden varsel.
  //   Det er praecis den skade, hele 29/08-rettelsen var skrevet imod, blot
  //   udloest af kunden i stedet for af os.
  // ⇒ Markoeren strippes af ALT, der kommer udefra og ind i vores blok:
  //   hver besked i loggen, kundens prefill-tekst og produkttitlen.
  // ⚠ SIG HOEJT HVAD DET KOSTER: skriver kunden ordret «--- [gm-chat] ---»,
  //   ser hun det ikke igen i feltet. Det er en maskinstreng, ikke en
  //   saetning, og at bevare den ville koste hende hele resten af feltet.
  // ⚠ DEN ANDEN VEJ ER IKKE LUKKET, og det skal siges: taster kunden
  //   markoeren direkte i BESKEDFELTET, klipper `split()` stadig ved den.
  //   Den vej kraever, at hun selv skriver vores maskinstreng ordret ned i
  //   et felt, hun kan se - maalt usandsynlig, men ikke umulig. Fanget her
  //   er den vej, hun kan falde i uden at vide det.
  // ⛔ 05/09 (R1): BEGGE markoerer strippes nu.
  // ⛔⛔ G3, 06/09/2026 — NOTEN HER LOEJ OM SIN EGEN MEKANIK, OG DEN ER RETTET
  //   TIL DEN MAALTE BEGRUNDELSE.
  //   Her stod: «ville `fjernVoresBlok` finde den INDE i vores egen blok og
  //   klippe blokken over paa midten - halvdelen ville blive staaende som
  //   kundens tekst og vokse for hver runde.» MAALT 05/09: mutanten «fjern
  //   SLUT-stripningen» OVERLEVEDE hele suiten. Under den daværende parring
  //   aendrede stripningen ingenting; noten beskrev en mekanik, der ikke
  //   fandtes. En note, der paastaar mere daekning end der findes, er husets
  //   dyreste form.
  //   MAALT IGEN 06/09, EFTER INVARIANTEN — og nu er stripningen levende, men
  //   af en ANDEN grund end den gamle note paastod:
  //     Slipper kundens slutmarkoer med ind i transskriptet, ligger der en
  //     slutmarkoer MELLEM vores to ender. Led 1 af invarianten («ingen
  //     slutmarkoer imellem») afviser da VORES EGET par, og den indre markoer
  //     staar efter «KUNDE: » — altsaa ikke foerst paa sin linje — saa led 3
  //     afviser ogsaa den. Der findes intet velformet par, teksten roeres
  //     ikke, vores blok bliver staaende, og naeste eskalering laegger én til.
  //   ⇒ Skaden er ikke «blokken klippes over», men «blokken kan ikke fjernes»
  //     — R7's dubletblok. `test_formular_blindgyde.js` scenarie 9g er porten
  //     for netop det, med to eskaleringer.
  function renseMarkoer(s) {
    return String(s == null ? "" : s)
      .split(KONTAKT_BLOK_START).join(" ")
      .split(KONTAKT_BLOK_SLUT).join(" ");
  }

  // ── Fjern PRAECIS vores egen blok, og intet andet ─────────────────────────
  // Syr to stumper af kundens tekst sammen med én tom linje imellem, saa
  // fjernelsen ikke efterlader det hul, den selv har lavet.
  function syKundensTekst(foer, efter) {
    var a = String(foer).replace(/\s+$/, "");
    var b = String(efter).replace(/^\s+/, "");
    if (!a) return b;
    if (!b) return a;
    return a + "\n\n" + b;
  }

  // ⛔ BAGUDKOMPATIBILITET, SAGT HOEJT (R1, 05/09).
  //   Feltet kan allerede baere en GAMMEL blok UDEN slutmarkoer: Liquid fylder
  //   `{{ form.body }}` tilbage efter en fejlet afsendelse, og den tekst kan
  //   vaere skrevet af den JS, kunden havde i browseren FOER denne rettelse.
  //   Der findes altsaa to formater i omloeb, og de skal begge kunne fjernes.
  //     NY blok  → begge ender er kendte ⇒ intervallet fjernes eksakt.
  //     GAMMEL   → kun starten er kendt. Vi laeser da FREMAD linje for linje og
  //                spiser praecis de linjer, VI selv kan have skrevet
  //                (`PRODUKT:`, prefill-praefikset, transskriptets hoved og
  //                dets `KUNDE:`/`FLADE:`-linjer, samt blanke linjer imellem).
  //                Den FOERSTE linje, vi ikke kan have skrevet, er kundens -
  //                og dér stopper vi. Hendes «PS: det HASTER» overlever.
  // ⚠ SIG HOEJT HVAD DEN GRAMMATIK IKKE KAN — MAALT 05/09 paa 13 sager, 3 tabte:
  //   1. Skriver kunden selv en linje, der begynder med «KUNDE: » eller
  //      «FLADE: » LIGE under en gammel blok, spises den med. Det kraever, at
  //      hun rammer vores maskinpraefiks ordret paa foerste linje efter
  //      transskriptet.
  //   1b. SAMME GAELDER «PRODUKT: » (produktkonteksten, linje ~2605). Den var
  //      ikke naevnt her, men `erVoresBlokLinje` spiser den ordret ligesom de
  //      to andre.
  //   1c. OG PREFILL-PRAEFIKSET, temaets eget `gmchat.prefill_praefiks` — i dag
  //      «Angaaende:». Det er ikke et maskinpraefiks: det er en fuldstaendig
  //      naturlig dansk aabningslinje, og det er derfor den DYRESTE af de tre.
  //      Skriver hun «Angaaende: min ordre 4711» som foerste linje under en
  //      GAMMEL blok, er den linje vaek.
  //   ⇒ Prisen er ikke «et maskinpraefiks ordret»; den er ogsaa ét almindeligt
  //      dansk ord. Heuristikken beholdes alligevel: den koerer KUN paa gammelt
  //      format (ingen slutmarkoer), og alternativet — at bevare hele den gamle
  //      blok som «kundens tekst» — giver to transskripter i mailen hver gang.
  //   2. Indeholder en botbesked et linjeskift, braekker transskriptet i to,
  //      og vi stopper for tidligt. Resten af den gamle blok bliver da staaende
  //      som «kundens tekst». Det er den rigtige retning at fejle i: vi
  //      efterlader for meget frem for at slette for lidt-for-meget. Skaden er
  //      bundet - den nye blok baerer slutmarkoer, saa den gamle rest kan kun
  //      staa dér ÉN gang og kan ikke vokse.
  //
  // ⛔⛔⛔ R1 ANDEN HALVDEL, 05/09/2026 — HER STOD EN NOTE, DER LOEJ.
  //   Den sagde: «`lastIndexOf` og ikke `indexOf`: vores blok laegges ALTID
  //   nederst. Taster kunden selv startmarkoeren OVER vores blok, finder
  //   `lastIndexOf` stadig VORES - ikke hendes.» Det er sandt KUN i den ene
  //   retning. Taster eller INDSAETTER hun markoeren UNDER blokken — dér
  //   markoeren lander, fordi `showContact` fokuserer navnefeltet og hendes
  //   caret staar i bunden af beskedfeltet — er HENDES den sidste.
  //   MAALT paa de aegte bytes:
  //     ind : "…--- [gm-chat] ---…--- [/gm-chat] ---\nHvad betyder
  //            --- [gm-chat] --- i feltet? Ring paa 12345678."
  //     ud  : "…--- [/gm-chat] ---\nHvad betyder"
  //   Mekanikken: `lastIndexOf(START)` pegede paa HENDES markoer;
  //   `indexOf(SLUT, efterStart)` gav −1, fordi vores slutmarkoer stod FOER
  //   hende; gammel-format-grenen koerte, og `slice(0, iStart)` bevarede saa
  //   HELE vores blok som «hendes tekst» ⇒ hendes sidste ord slettet OG to
  //   blokke/to transskripter ved naeste eskalering. Begge de skader, R1 og R7
  //   var skrevet imod, paa én gang.
  // ⇒ VI PARREDE FRA SLUTNINGEN: den SIDSTE slutmarkoer, og den naermeste
  //   startmarkoer FOER den. Det lukkede START-retningen — og aabnede
  //   SLUT-retningen. Se den naeste note; opslaget er nu erstattet af en
  //   invariant.
  //
  // ⛔⛔⛔⛔ R6-D, 06/09/2026 — TRE RUNDER MED TRE OPSLAG, TRE HULLER.
  //   Runde 4: `split(START)[0]` slettede alt EFTER vores blok.
  //   Runde 5: intervalfjernelse — men kundens markoer OVER blokken brod den.
  //   Runde 6: `lastIndexOf(SLUT)` — og saa var SPEJLRETNINGEN aaben.
  //   MAALT paa de aegte bytes, med runde 6's kode:
  //     ind : "…--- [/gm-chat] ---\nPS: ring 12345678. Hvad betyder
  //            --- [/gm-chat] --- i feltet?"
  //     ud  : "i feltet?"            ⇒ 51 tegn vaek, telefonnummeret med
  //   Mekanikken: `lastIndexOf(SLUT)` pegede paa HENDES slutmarkoer, og den
  //   blev parret med VORES startmarkoer. Hver rettelse har lukket én retning
  //   og aabnet den anden, fordi hver rettelse var ET OPSLAG: «find den
  //   markoer, der plejer at vaere vores».
  //
  // ⇒ HERFRA ER DET IKKE ET OPSLAG, MEN EN INVARIANT. Sagt som én saetning:
  //
  //     ⭐ ET MARKOERPAR ER VORES — OG MAA FJERNES — HVIS OG KUN HVIS DE TO
  //       MARKOERER ER HINANDENS NAERMESTE OG BEGGE STAAR, HVOR VI SELV
  //       SAETTER DEM: FOERST PAA EN LINJE. LIGGER DER EN MARKOER MELLEM DEM,
  //       ELLER STAAR ÉN AF DEM MIDT I EN LINJE, ER DER NOGET MELLEM DEM, VI
  //       IKKE SELV SKREV — OG SAA ER DET IKKE VORES PAR.
  //
  //   Tre led, og hvert led er en ting, koden KAN afgoere:
  //     1. INGEN SLUTMARKOER IMELLEM — `indexOf(SLUT, efterStart) === iSlut`.
  //        Den naermeste slutmarkoer efter starten SKAL vaere netop denne.
  //     2. INGEN STARTMARKOER IMELLEM — gratis: `iStart` er pr. konstruktion
  //        `lastIndexOf(START, iSlut)`, altsaa den naermeste foer slutningen.
  //     3. BEGGE STAAR FOERST PAA EN LINJE — `nyt` bygges ét sted (linje ~2626)
  //        som `START + "\n" + … + "\n" + SLUT`, og laegges enten i et tomt felt
  //        (START paa plads 0) eller efter `kundens + "\n\n"`. Vores to
  //        markoerer staar derfor ALTID foerst paa en linje. Kundens gor det
  //        typisk ikke.
  //   Findes intet gyldigt par, men findes DER en slutmarkoer, roerer vi ikke
  //   teksten. En slutmarkoer, vi ikke kan parre, er hendes ord.
  //
  // ⛔ H1 ER BUNDET VED BEVIS, IKKE VED PROEVE — og den gamle vagt er derfor
  //   FJERNET. Her stod `if (iSlut >= efterStart)`, og modstanderen kunne ikke
  //   konstruere et input, hvor den aendrede noget. Grunden er, at den er
  //   LOGISK INDEHOLDT i led 1: `indexOf(SLUT, k)` returnerer pr. definition
  //   enten −1 eller en vaerdi >= k. Er `indexOf(SLUT, efterStart) === iSlut`
  //   sand, ER `iSlut >= efterStart` sand. En vagt, der ikke kan fyre, er ikke
  //   dybdeforsvar; den er en paastand om daekning, der ikke findes.
  //   (Overlappende markoerer KAN konstrueres — «--- [gm-chat] --- [/gm-chat]
  //   ---» har START paa 0 og SLUT paa 14, altsaa iSlut < efterStart. Ogsaa
  //   dét input afvises af led 1 alene, og af led 3 oveni.)
  //
  // ⚠ SIG HOEJT HVAD INVARIANTEN IKKE KAN — MAALT, ikke gaettet:
  //   a) Skriver kunden BEGGE vore markoerer, hver foerst paa sin linje, med
  //      sine egne ord imellem, er hendes par uskelneligt fra vores, og hendes
  //      ord imellem forsvinder. Det kraever, at hun taster to maskinstrenge
  //      ordret paa hver sin linje. Prisen er sagt hoejt, ikke skjult.
  //   b) INDHOLDET mellem markoererne kontrolleres IKKE linje for linje. Det
  //      var overvejet og fravalgt MED begrundelse: en botbesked eller en
  //      prefill med et linjeskift ville da falde uden for grammatikken, vores
  //      EGEN blok ville blive afvist som «ikke vores», og R7's dubletblok kom
  //      tilbage — den dyreste af de to fejl. Markoerplads er en ting vi
  //      kontrollerer 100 %; indholdet er det ikke.
  //   c) Skriver kunden noget FORAN vores startmarkoer paa samme linje
  //      («Hej --- [gm-chat] ---»), staar markoeren ikke laengere foerst paa
  //      linjen, og vi fjerner IKKE blokken. Hun mister intet; vi faar ét
  //      forældet transskript med i mailen. Skaden er BUNDET: den nye blok
  //      skrives med begge ender paa egne linjer og fjernes korrekt naeste
  //      gang, saa feltet stabiliserer sig paa én gammel + én aktuel blok.
  //      Det er den rigtige retning at fejle i (jf. note 2 ovenfor): efterlad
  //      hellere for meget end slet for meget.
  // ⚠ Findes INGEN slutmarkoer, er der intet par, og vi falder tilbage til
  //   gammel-format-grenen. Dér er den gamle notes svaghed uaendret sand, og
  //   det er accepteret: en gammel blok baerer pr. definition ikke den ende,
  //   der kunne afgoere sagen. Ogsaa dér kraeves markoerpladsen nu (led 3).

  // Led 3 af invarianten, ét sted: staar markoeren dér, hvor VI saetter vores —
  // foerst paa en linje? `nyt` skrives altid som `START + "\n" … "\n" + SLUT`
  // og indsaettes i et tomt felt eller efter `"\n\n"`, saa svaret er ja for
  // vores egne to markoerer og typisk nej for kundens.
  function erVoresMarkoerplads(tekst, i) {
    return i === 0 || tekst.charAt(i - 1) === "\n";
  }

  function fjernVoresBlok(haves) {
    var tekst = String(haves == null ? "" : haves);
    var iSlut = tekst.lastIndexOf(KONTAKT_BLOK_SLUT);
    var fandtesSlut = iSlut !== -1;
    // Gaa slutmarkoererne igennem BAGFRA. Den foerste, der indgaar i et
    // VELFORMET par, er vores; alt andet er kundens ord.
    while (iSlut !== -1) {
      var iStart = tekst.lastIndexOf(KONTAKT_BLOK_START, iSlut);
      if (iStart !== -1 &&
          erVoresMarkoerplads(tekst, iStart) &&
          erVoresMarkoerplads(tekst, iSlut) &&
          tekst.indexOf(KONTAKT_BLOK_SLUT,
                        iStart + KONTAKT_BLOK_START.length) === iSlut) {
        return syKundensTekst(tekst.slice(0, iStart),
                              tekst.slice(iSlut + KONTAKT_BLOK_SLUT.length));
      }
      // ⚠ `iSlut === 0` skal fanges FOER `iSlut - 1`: `lastIndexOf(x, -1)`
      //   klipper negative vaerdier til 0 og kan altsaa finde den SAMME
      //   forekomst igen — en evig loekke midt i kundens formular.
      iSlut = iSlut === 0
        ? -1
        : tekst.lastIndexOf(KONTAKT_BLOK_SLUT, iSlut - 1);
    }
    // Der ER en slutmarkoer, men intet velformet par: den er hendes. Roer intet.
    if (fandtesSlut) return tekst;
    var iStartGammel = tekst.lastIndexOf(KONTAKT_BLOK_START);
    if (iStartGammel === -1 ||
        !erVoresMarkoerplads(tekst, iStartGammel)) return tekst;
    var efterStart = iStartGammel + KONTAKT_BLOK_START.length;
    var linjer = tekst.slice(efterStart).split("\n");
    // linjer[0] er resten af selve markoerlinjen (normalt tom) og er altid vores.
    var sidsteVores = 0;
    for (var i = 1; i < linjer.length; i++) {
      if (erVoresBlokLinje(linjer[i])) { sidsteVores = i; continue; }
      if (!linjer[i].trim()) continue;   // blank linje: tael kun med, hvis vores fortsaetter
      break;                              // foerste linje, vi ikke kan have skrevet
    }
    return syKundensTekst(tekst.slice(0, iStartGammel),
                          linjer.slice(sidsteVores + 1).join("\n"));
  }

  function erVoresBlokLinje(linje) {
    var l = String(linje);
    if (l === TRANSSKRIPT_HOVED) return true;
    if (l.indexOf("PRODUKT: ") === 0) return true;
    if (l.indexOf("KUNDE: ") === 0) return true;
    if (l.indexOf("FLADE: ") === 0) return true;
    var praefiks = t("prefill-praefiks");
    // ⚠ Kun hvis noeglen findes. `t()` returnerer «[gmchat.prefill_praefiks]»
    //   naar den mangler, og den streng ville ellers vaere et gyldigt
    //   linjepraefiks at spise efter.
    if (praefiks && praefiks.indexOf("[gmchat.") !== 0 &&
        l.indexOf(praefiks) === 0) return true;
    return false;
  }

  function buildTransskript() {
    // Transskriptet lægges som REN TEKST i kontaktformularens body-felt — Shopifys native
    // kontaktformular har ikke et struktureret vedhæftningsfelt (kendt begrænsning, se
    // spor-a-design.md §2: "Vi kan ikke vedhæfte et langt transskript struktureret").
    var msgs = logEl.querySelectorAll(".gmchat-msg");
    if (!msgs.length) return "";
    var lines = [TRANSSKRIPT_HOVED];
    msgs.forEach(function (m) {
      var hvem = m.classList.contains("gmchat-msg--user") ? "KUNDE" : "FLADE";
      lines.push(hvem + ": " + renseMarkoer(m.textContent));
    });
    return lines.join("\n");
  }

  // ---------- Kvittering vises KUN når Shopify faktisk har kvitteret afsendelsen ----------
  // Mekanisme identisk med det tidligere målte og bekræftede A1-mønster (a1-tema-udrulning.md
  // §3b): ingen preventDefault på selve submit, native POST til Shopifys /contact, og svaret
  // læses fra data-posted/data-has-errors, som Liquid sætter ud fra form.posted_successfully?/
  // form.errors PÅ SIDENS NÆSTE RESPONS — aldrig ud fra et klik i denne fil.
  // ⛔ `hideStatus()` FJERNET 04/09 (roed hat R1/R3). Den var den anden af de to
  //   switches, der kunne modsige hinanden: `openPanel()` og `renderIntro()`
  //   kaldte den ALTID, ogsaa i det oejeblik kvitteringen netop var gjort
  //   synlig. Dens to kaldesteder kalder nu `hideContact()` alene, som gaar
  //   gennem `saetKontaktTilstand(KONTAKT_SKJULT)` og goer praecis det samme -
  //   plus felterne. Ét sted, én tilstand.

  function showServerState() {
    // ⛔⛔ ROED HAT R2, 04/09/2026 — RODEN, ikke symptomet.
    //   26/08 blev det MAALT paa kundefladen, at `data-posted` var "false"
    //   ogsaa efter en vellykket afsendelse (`?contact_posted=true` i URL'en,
    //   `data-posted="false"` i DOM'et). Aarsagen blev noteret rigtigt dengang:
    //   attributterne stod paa `#gmchat-root` (linje 554), men
    //   `{% form 'contact' %}` aabnede foerst 210 linjer senere (linje 764), og
    //   uden for den blok er Liquids `form`-objekt UDEFINERET.
    //   Men rettelsen dengang var en URL-parameter-RESERVE for `posted` alene.
    //   `hasErrors` fik aldrig samme reserve, saa fejlgrenen forblev en
    //   kodesti, kunden ALDRIG kunne naa - og enhver rettelse i den var uden
    //   virkning paa skaermen.
    //   ⇒ 04/09 er attributterne FLYTTET ind i `{% form %}`-blokken, paa
    //     `.gmchat-contact`, hvor `form` ER i scope. Roden er lukket for begge
    //     felter paa én gang; symptombehandlingen er ikke laengere baerende.
    // ⛔⛔⛔ R5, 04/09/2026 — DEN FLYTNING GJORDE EN SIDE-GLOBAL NOEGLE
    //   KUNDEVENDT. Maalt af roed hat paa den LEVENDE kundeflade (testtema
    //   203548721495), ikke udledt:
    //       /pages/kontakt                        → status--ok har `hidden`
    //       /pages/kontakt?contact_posted=true    → status--ok har INTET hidden
    //       /?contact_posted=true (forsiden)      → status--ok har INTET hidden
    //   Aarsag: `{% unless form.posted_successfully? %}hidden{% endunless %}`
    //   staar inde i VORES `{% form 'contact' %}`, og Shopify saetter
    //   `form.posted_successfully? = true` i ETHVERT contact-form-scope paa
    //   siden, alene fordi URL'en baerer `?contact_posted=true`. Efter min
    //   flytning rendrede `data-posted` derfor "true" i vores egen formular.
    //   ⚠ `/pages/kontakt` baerer TO `form_type=contact`-formularer: temaets
    //     egen og widget'ens. Temaets sender kunden tilbage til netop
    //     `/pages/kontakt?contact_posted=true`.
    //   HVAD KUNDEN OPLEVEDE: hun skriver i shoppens ALMINDELIGE
    //   kontaktformular. Siden vender tilbage, chatten aabner sig selv - maalt
    //   fuld skaerm 390x844 paa telefon - og siger «Tak, jeg har sendt din
    //   henvendelse videre til en af mine kolleger». Widget'en har ikke sendt
    //   noget. Det er CEO's FORBUDTE LOEFTE om et menneske (28/08) givet til en
    //   kunde, der aldrig skrev til botten.
    //   ⚠ Selv-aabningen var allerede udrullet (26/08-baeltet). Det NYE var
    //     kvitteringen. Min egen R1/R3-fejl maskerede konsekvensen indtil i
    //     dag: kvitteringen var usynlig, saa loegnen kunne ikke ses.
    //
    // ⇒ TO RETTELSER, OG DEN ENE ALENE ER IKKE NOK:
    //   1. URL-BAELTET ER SLETTET. Her stod
    //        `|| window.location.search.indexOf("contact_posted=true") !== -1`
    //      Det var netop dét, der aabnede panelet uden at kunden havde skrevet
    //      til os. Filens egen note sagde allerede, at baeltet ikke laengere
    //      var baerende efter at attributten kom i scope.
    //   2. VI GATER PAA EN NOEGLE, VI SELV EJER: fragmentet
    //      `#gm-chat-contact`. Shopifys `{% form %}` rendrer selv
    //      `action="/contact#<form-id>"`, og vores id er `gm-chat-contact`.
    //      Punkt 1 alene raekker IKKE, fordi Liquid ogsaa siger "true".
    //
    // ⛔ MAALT, IKKE ANTAGET (04/09, lokal HTTP-server + Chrome, ingen
    //   shop-adgang). Spoergsmaalet var, om fragmentet overlever
    //   POST → 302 → GET, naar serverens `Location` selv er uden fragment -
    //   praecis Shopifys form:
    //       action="/contact#gm-chat-contact" → hash="#gm-chat-contact"  ✅
    //       action="/contact#contact_form"    → hash="#contact_form"     (temaets)
    //       action="/contact"                 → hash=""                  (tema uden id)
    //   Fragmentet baeres altsaa med, og det SKELNER mellem de to formularer
    //   paa /pages/kontakt.
    // ⚠ HVAD DEN MAALING IKKE DAEKKER: andre browsere end Chrome, og det
    //   tilfaelde hvor Shopify en dag laegger sit EGET fragment i `Location`
    //   (det ville overskrive vores). Sker et af dem, falder vi ned i «INGEN
    //   kvittering» - ikke i «FALSK kvittering». Den retning er valgt med
    //   vilje: en manglende kvittering er en skuffelse, en falsk kvittering er
    //   et loefte, huset ikke har givet.
    // ⚠ Findes `.gmchat-contact` slet ikke, findes hverken formular,
    //   kvittering eller fejltekst - der er intet at vise, og intet at laese
    //   tilstanden fra. Vi laeser aldrig fra `root`: dér stod de to attributter
    //   FOER rettelsen, og en stille "false" derfra ville genskabe R2.
    if (!contactSection) return;
    var voresAfsendelse = window.location.hash === "#gm-chat-contact";
    // ⛔⛔ G3, 04/09/2026 — KVITTERINGENS ENESTE BEVIS VAR URL'EN.
    //   `location.hash` og `dataset.posted` er begge rene funktioner af den
    //   adresse, browseren staar paa. Der findes INGEN POST i kaeden herunder.
    //   ⇒ Bogmaerke, tilbage-knap og F5 gentog «jeg har sendt din henvendelse
    //     videre til en af mine kolleger» UDEN en afsendelse. Det er CEO's
    //     forbudte loefte om et menneske (28/08) - samme skade som R5, blot
    //     med kundens egen browser som afsender i stedet for shoppens
    //     kontaktformular.
    //   `performance.getEntriesByType("navigation")[0].type` er browserens
    //   EGET facit for hvordan siden kom frem:
    //       "navigate"     - et link, en formularafsendelse, et 302-redirect
    //       "reload"       - F5 / genindlaes                 ⇒ DRAEBT
    //       "back_forward" - tilbage- og frem-knappen        ⇒ DRAEBT
    //       "prerender"    - browserens forudindlaesning     ⇒ DRAEBT
    // ⚠ SIG HOEJT HVAD DEN IKKE KAN. En TASTET eller BOGMAERKET adresse med
    //   `#gm-chat-contact` og `?contact_posted=true` er ogsaa "navigate", og
    //   den slipper igennem. Denne rettelse lukker genindlaesning og
    //   historik-knapperne - ikke en adresse, kunden selv skriver ind.
    //   Restrisikoen er accepteret bevidst: den kraever at kunden aktivt
    //   taster to parametre, hun ikke har nogen grund til at kende.
    // ⚠ FEJLER LUKKET, samme retning som resten af funktionen: er API'et
    //   ikke til stede (aeldre browser, exotisk indlejring), er `navType`
    //   tom, og vi falder ned i «INGEN kvittering» - aldrig i «FALSK
    //   kvittering». En manglende kvittering er en skuffelse; en falsk er et
    //   loefte, huset ikke har givet.
    var navType = "";
    try {
      var navPost = window.performance &&
        typeof performance.getEntriesByType === "function"
        ? performance.getEntriesByType("navigation")[0] : null;
      if (navPost && navPost.type) navType = String(navPost.type);
    } catch (e) { navType = ""; }
    var friskAnkomst = navType === "navigate";
    var posted = contactSection.dataset.posted === "true" &&
      voresAfsendelse && friskAnkomst;
    // ⛔ FEJLGRENEN GATES PAA DET SAMME. `form.errors` er side-global paa
    //   noejagtig samme maade: fejler TEMAETS kontaktformular, ville vores
    //   chat ellers aabne sig selv og sige «Kunne ikke sende» om en besked,
    //   den aldrig har haft. Et forkert nej er ogsaa et forkert svar.
    // ⚠ FEJLGRENEN GATES BEVIDST **IKKE** PAA `friskAnkomst` (G3). Grunden er
    //   asymmetrien i skaden: gentages KVITTERINGEN paa en F5, har vi lovet et
    //   menneske, vi ikke har (forbudt, CEO 28/08). Gentages FEJLEN, faar
    //   kunden sin formular og sin egen tekst tilbage plus vejen ud (mail og
    //   telefon) - det er den rigtige skaerm at lande paa, ogsaa efter en F5.
    //   Og Shopify rendrer `form.errors` paa selve POST-svaret uden redirect,
    //   saa en F5 dér udloeser browserens egen «send igen?»-dialog, ikke en
    //   tavs gentagelse.
    var hasErrors = contactSection.dataset.hasErrors === "true" && voresAfsendelse;
    // ⛔ RAEKKEFOELGEN ER IKKE VILKAARLIG: `openPanel()` kalder `hideContact()`
    //   (direkte eller via `renderIntro()`), som kollapser hele omraadet. Sker
    //   det EFTER at tilstanden er sat, slaar det den ihjel - det var praecis
    //   R1/R3. Panelet aabnes derfor FOERST, og tilstanden saettes til sidst,
    //   i ét kald.
    if (posted && !hasErrors) {
      openPanel(null);
      saetKontaktTilstand(KONTAKT_KVITTERING);
    } else if (hasErrors) {
      // ⛔⛔ STRESS-TEST 04/09, B5 — BLINDGYDEN. Her stod KUN linjen, der
      //   goer fejlteksten synlig. Men baade `.gmchat-panel` OG
      //   `.gmchat-contact` starter `hidden`, saa beskeden laa i et LUKKET
      //   panel: kunden trykkede send, siden genindlaeste, og hun saa
      //   INTET. Ingen kvittering, ingen fejl, ingen formular - kun den
      //   lukkede chat, som om hun aldrig havde skrevet.
      //   CEO's krav 03/09, ordret: «Kunden maa aldrig efterlades i en
      //   blindgyde.» En usynlig fejlbesked er den reneste blindgyde der
      //   findes: systemet ved besked, kunden goer ikke.
      //   ⇒ Aabn panelet, VIS formularen igen (saa hun kan rette og sende
      //     paa ny), og lad fejlteksten staa synligt over den.
      // ⚠ Felterne er fyldt af Liquid (`{{ form.name }}` osv., tilfoejet
      //   04/09). Vi roerer dem IKKE her - `showContact()` ville flette sin
      //   egen kontekstblok ind oven i det, kunden allerede havde skrevet.
      openPanel(null);
      saetKontaktTilstand(KONTAKT_FEJL);
    }
  }

  if (contactForm && contactSubmit) {
    contactForm.addEventListener("submit", function () {
      contactSubmit.disabled = true;
      // ⛔⛔ G1, 05/09/2026 — «Sender…» VAR DEN ENESTE HAARDKODEDE STRENG I
      //   HELE JS'EN. Maalt: ét hit uden `t()`/`tv()`. Liquid'ens eget hoved
      //   laaser reglen: «Hver fast streng er nu en oversaettelsesnoegle.»
      //   Svenske og norske kunder fik et DANSK ord, som oveni koeb ERSTATTEDE
      //   den oversatte knaptekst - permanent, fordi der ikke fandtes nogen vej
      //   tilbage (R2).
      // ⚠ `tv()` og ikke `t()`, og det er en bevidst afvigelse fra husreglen
      //   «synligt slaar tavst»: noeglen `gmchat.sender` findes endnu ikke i
      //   temaets locales (maalt 05/09: DK-temaet har 38 gmchat-noegler, ingen
      //   `sender`), og `t()` ville derfor skrive «[gmchat.sender]» - eller,
      //   hvis Liquid'en fik lov at rendre den raat, «Translation missing:
      //   da.gmchat.sender» - paa knappen hos ENHVER kunde. Det er vaerre end
      //   det danske ord, vi er ved at fjerne.
      //   Mangler noeglen, roerer vi altsaa slet ikke etiketten: knappen
      //   beholder sin EGEN oversatte tekst (`gmchat.send`) og er blot
      //   deaktiveret. Det er en svagere, men SAND tilstandsmelding paa alle
      //   tre sprog. Findes noeglen, vises den oversatte tekst.
      // ⚠ ALDRIG en bekraeftelse - kun en tilstand, ikke et loefte (CEO 28/08).
      var sender = tv("sender");
      if (sender) contactSubmit.textContent = sender;
      // ⛔⛔ G2, 06/09/2026 — ETIKETTEN ER I PRAKSIS ALDRIG SKIFTET, OG
      //   FLADEN VAR BYTE-IDENTISK MED «ALDRIG-KLIKKET».
      //   MAALT paa temaet: 38 `gmchat`-noegler, og `sender` er IKKE en af
      //   dem. `tv("sender")` giver derfor en tom streng, linjen ovenfor
      //   springes over, og det ENESTE igangs-signal var
      //   `:disabled{opacity:.6;cursor:not-allowed}`. Paa en telefon findes
      //   ingen markoer, og 0,6 i opacitet paa en knap, kunden lige har
      //   trykket paa, er ikke en tilstandsmelding — det er en nuance.
      //   ⇒ Kunden trykker igen. Dobbeltafsendelse var altsaa FORVENTET
      //     adfaerd, ikke en kant.
      // ⇒ `aria-busy` er signalet: den kraever INGEN ny locale-noegle (og
      //   dermed ingen CEO-sag om temaets oversaettelser), den er sand paa
      //   alle tre sprog, den laeses af skaermlaesere, og CSS'en haenger en
      //   SYNLIG ring paa knappen gennem `[aria-busy="true"]`. Samme moenster
      //   som soegefeltet ovenfor (linje ~1492).
      // ⚠ ALDRIG en bekraeftelse — `aria-busy` siger «i gang», ikke «sendt»
      //   (CEO 28/08: lov aldrig et menneske, der ikke kommer).
      // ⚠ Ryddes i `frigivSendKnap()`, saa den doer sammen med laasen. Havde
      //   den sit eget liv, ville ringen kunne staa paa en knap, der forlaengst
      //   er fri — en tilstandsmelding, der lyver.
      contactSubmit.setAttribute("aria-busy", "true");
      // ⛔ R2 (greb a): tidsrummet. Fyrer den, skete navigationen ikke.
      // ⛔⛔ G1, 06/09/2026 — 11f BANDT INTET, OG DET VAR DETTE GREB, DER
      //   SKJULTE DET. MUTANT: `pageshow`-lytteren fjernet HELT ⇒ suiten
      //   exit 0, 109 groenne. Aarsagen er maaleren, ikke fladen: Chromes
      //   `--virtual-time-budget` spoler `setTimeout` frem, saa denne 8.000
      //   ms-timer naaede at fyre INDEN 11f's 400 ms-maaling. 11f maalte
      //   altsaa greb (a) i forklaedning.
      //   BEVIS: samme mutant + `SEND_GENDAN_MS=1e9` ⇒ 11f ROED.
      // ⇒ Greb (a) faar samme maaler-neutralisering som greb (c) allerede
      //   har (`gmchatIngenTilstandsfrigivelse`, linje ~2591). Alternativet
      //   «koer 11f i aegte tid» er proevet og virker ikke: uden virtuel tid
      //   dumper Chrome DOM'et foer maalingen.
      // ⛔ FLAGET MAA ALDRIG UDRULLES. Stod det i .liquid'en, mistede kunden
      //   greb (a) paa fladen. `test_formular_blindgyde.js` har en
      //   fravaers-vagt paa .liquid'en for netop det — samme vagt som greb
      //   (c)'s flag har.
      if (!root.dataset.gmchatIngenTidsgendan) {
        if (sendGendanTimer) clearTimeout(sendGendanTimer);
        sendGendanTimer = setTimeout(frigivSendKnap, SEND_GENDAN_MS);
      }
    });
    // ⛔ R2 (greb b): bfcache. Gaar kunden frem til /contact og trykker
    //   TILBAGE, genskaber browseren siden fra hukommelsen med knappen
    //   praecis saa doed, som hun forlod den. `load` fyrer ikke paa den vej -
    //   `pageshow` er den eneste haendelse, der goer.
    // ⚠ Den fyrer OGSAA ved en almindelig foerste indlaesning. Det er
    //   harmloest: `frigivSendKnap` er idempotent og saetter kun knappen til
    //   den tilstand, den allerede har.
    // ⚠ VAGTEN ER IKKE PYNT (fundet 05/09 ved slutkoerslen, selvrettet).
    //   `test_hul1_tur_nr_sideskift.js` koerer denne fil i en Node-`vm` med et
    //   STUBBET `window`, der ikke har `addEventListener`. Uvagtet kastede
    //   linjen `TypeError` og stoppede HELE widget-opstarten — praecis den
    //   fejlform, `humanLink`s og `contactSection`s egne vagter er skrevet
    //   imod. En stub i dag er en exotisk indlejring i morgen.
    //   Mangler API'et, mister vi KUN bfcache-grebet; tidsrummet og
    //   tilstandsovergangen frigiver stadig knappen.
    if (typeof window.addEventListener === "function") {
      window.addEventListener("pageshow", frigivSendKnap);
    }
  }
  // I P4 findes intet AI-backend endnu (spor B er ikke bygget, jf. a1-tema-udrulning.md/STATUS.md).
  // apiEndpoint er derfor TOM som standard, og fladen kører permanent i den tilstand, kravet
  // beskriver som "degraderet": FAQ-søgning + forslag + native kontaktformular, INGEN AI-samtale.
  // Når spor B en dag sætter data-api-endpoint, forsøger denne funktion ÉT healthcheck ved åbning
  // og falder PERMANENT (for resten af sidevisningen) tilbage til samme degraderede tilstand ved

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐⭐ SAMTALEN · «START NY SAMTALE» · VEDHÆFTNING · KURV      10/09/2026
  // ═══════════════════════════════════════════════════════════════════════════
  // Fire ting, der hænger sammen, og som derfor står samlet: samtalen skal
  // KUNNE genoptages, kunden skal kunne komme UD af den, hun skal kunne vise os
  // et billede undervejs, og en kurvhandling skal udføres HER og dømmes DÉR.
  //
  // ⛔ KONTRAKTERNE ER SPOR B'S OG SPOR C'S MÅLTE — IKKE NOGET, DENNE FIL FANDT
  //   PÅ. Bygger fladen mod en kontrakt, den selv har opfundet, er den grøn i
  //   fixturen og død i drift. Det er husets dyreste fejlklasse i denne pakke.

  //: Underdørene ligger under selve endepunktet. ⚠ En efterstillet skråstreg i
  //: temaindstillingen ville give `/apps/chat//genoptag`, som er en ANDEN sti.
  function apiSti(hale) {
    if (!apiEndpoint) return "";
    var sti = apiEndpoint.replace(/\/+$/, "") + hale;
    if (testAdgang) sti += "?gmchat_access=" + encodeURIComponent(testAdgang);
    return sti;
  }

  // ⛔ SKRIVEFELTET SKAL UD AF DEN RULLENDE BODY — OGSÅ NÅR `renderIntro`
  //   ALDRIG KØRER. Se den lange note i `renderIntro`: formularen ligger i
  //   Liquid'en INDE i `.gmchat-body`, som ruller. Genoptages en samtale, står
  //   der beskeder i loggen fra start, `harEksisterendeSamtale()` er sand, og
  //   `openPanel` springer `renderIntro` over — så ville feltet blive liggende
  //   inde i rullefeltet og forsvinde opad, så snart samtalen blev lang.
  //   ⚠ MÅLT SOM FEJLKLASSE 19/08: kunden havde forslagsknapper og intet sted
  //     at skrive, mens hvert markup-tjek stod grønt.
  //   ⇒ Flytningen står nu ét sted og kaldes begge steder fra.
  function flytSkrivefeltUdAfBody() {
    if (searchForm && body && body.parentNode &&
        searchForm.parentNode !== body.parentNode) {
      body.parentNode.insertBefore(searchForm, body.nextSibling);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // GENOPTAG — serveren er den eneste, der VED, om samtalen lever
  // ─────────────────────────────────────────────────────────────────────────
  // ⛔⛔ HVAD DER VAR GALT (målt i kilden 10/09): opstarten gendannede
  //   session-id'et, men IKKE de viste beskeder. Kunden klikkede et
  //   produktlink, kom tilbage og mødte en TOM log — mens serveren og
  //   dashboardet havde hele hendes samtale. Hun havde ingen måde at se, at
  //   botten stadig huskede hende.
  //
  // ⛔ OG DERFOR MÅTTE DET VÆRE ET SERVERFELT. Widget'ens egen kommentar sagde
  //   det allerede: *«Vi kan ikke fra klienten VIDE, om serveren stadig har
  //   sessionen … En sætning, der påstår kontinuitet, ville være et løfte uden
  //   dækning.»* Det felt findes nu — `POST <endpoint>/genoptag` — og derfor
  //   (og kun derfor) må kontinuitets-mærket vises.
  //
  // ⚠ `genoptag` FORLÆNGER IKKE samtalen. Den er ren aflæsning. Et sideskift
  //   må ikke kunne holde en samtale kunstigt i live — se `kundeRoert`.
  // ⚠ `kendt:false` er BIT-IDENTISK for ukendt, udløbet og forkert flade. Det
  //   er med vilje: kunne fladen skelne dem, var svaret et orakel, man kunne
  //   afhøre om fremmede session-id'er. ⇒ Vi bygger INTET, der forsøger at
  //   skelne. Alle tre betyder ét og det samme her: begynd forfra.
  var genoptagKoert = false;

  function genoptagSamtale(sid) {
    if (!sid || !apiEndpoint || genoptagKoert) return Promise.resolve(false);
    genoptagKoert = true;
    // ⛔⛔ T3D 05/10 (lead-fund TEST 05/10): «START NY SAMTALE» MÅ IKKE KUNNE OVERHALES AF ET GENOPTAG I LUFTEN.
    //   `genoptagSamtale` kører ved HVER indlæsning, når fanen har en samtale, og svaret kan nå frem efter at kunden har
    //   klikket «Start ny samtale» (App Proxy-kaldet tager sekunder). Svaret satte da `sessionId` tilbage til den
    //   GAMLE samtale og tegnede dens beskeder ind i den nye log: næste besked gik til den gamle serversession
    //   (samme art21-manuel-tekst, samme sagsnummer, samme kvote). `spoergBotten` har altid haft sit tur-mærke;
    //   dette kald manglede det. Mærket tages HER, FØR kaldet, og dømmer ved MODTAGELSEN, præcis som `spoergBotten`.
    //   ⚠ Et forældet svar kasseres HELT, også `kendt:false`-grenen: dens `lagerRyd()` ville ellers slette den NYE arv.
    var _genoptagMaerke = turMaerke;
    return fetch(apiSti("/genoptag"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session: sid })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (svar) {
        if (_genoptagMaerke !== turMaerke) return false;     // T3D: «Start ny samtale» blev klikket, mens kaldet var i luften
        if (!svar || svar.kendt !== true) {
          // ⛔ SERVEREN KENDER DEN IKKE ⇒ LOKALT ER DEN OGSÅ VÆK. Et id, der
          //   ikke findes, må ikke blive ved med at ligge i browseren og blive
          //   sendt ved hver besked — det ville give en 409 på hver tur.
          //   ⚠ `for_mange` (rate-limit) og `stoppet` (nødstop) kommer i samme
          //     form. Også de betyder «begynd forfra»; fladen forsøger ikke at
          //     forklare kunden, hvilken af dem det var, for det ville være at
          //     udstille husets egne spærrer.
          sessionId = "";
          lagerRyd();
          return false;
        }
        // ⭐⭐ VEDHÆFTNINGSREFERENCEN OVERLEVER NAVIGATIONEN (rettet 10/09).
        //   MÅLT: `api.py:3013` sender `"vedhaeftninger": _vedhaeftninger_
        //   for_session(s)` på HVER `/chat/genoptag` — og strengen
        //   `vedhaeftninger` fandtes **0 gange** i denne fil. Referencen
        //   overlevede altså på serveren og INTET andet sted. Klikkede kunden
        //   et produktlink efter at have sendt et foto, kunne hun ikke spørge
        //   om en detalje mere i DET billede; hun skulle uploade det igen og
        //   betale for et nyt modelkald med de samme bytes.
        //   ⛔ Kaldes FØR `beskeder.length`-porten nedenfor: en session kan
        //     have en levende vedhæftning uden en eneste besked (kunden
        //     vedhæftede og skiftede side, før hun skrev). Lå kaldet efter,
        //     ville netop den kunde miste sit billede.
        genskabVedhaeftning(svar.vedhaeftninger);
        var beskeder = (Object.prototype.toString.call(svar.beskeder) === "[object Array]")
          ? svar.beskeder : [];
        if (!beskeder.length) { sessionId = svar.session || sid; return false; }
        sessionId = svar.session || sid;
        // ⭐ SERVEREN HUSKER SAMTALEN (den sendte den selv tilbage). Samme
        //   kendsgerning som i `spoergBotten` - se `kontaktProblem`.
        harServerSamtale = true;

        // Loggen tegnes FØR mærket, så mærket står øverst i samtalen.
        logEl.innerHTML = "";
        for (var i = 0; i < beskeder.length; i++) {
          var b = beskeder[i];
          if (!b || typeof b !== "object") continue;
          var tekst = String(b.tekst || "");
          if (!tekst) continue;
          // Restore only display data. Never replay cart instructions or ticket writes.
          // Feedback is bound to the original server turn number.
          if (b.rolle === "kunde") addUserMsg(tekst);
          else if (b.rolle === "bot") {
            var boble = addBotMsg(tekst);
            var visning = b.visning;
            if (visning && typeof visning === "object") {
              var tur = visning.tur_nr;
              if (Number.isInteger(tur) && tur > 0) {
                boble.dataset.gmchatTurNr = String(tur);
                visFeedback(boble, tur, visning.kunde_feedback);
              }
              if (visning.fakta) visFakta(visning.fakta);
              var antal = visProdukter(visning.produkter);
              var forslag = Array.isArray(visning.forslag) ? visning.forslag : [];
              if (Array.isArray(visning.produkter) && (!visning.produkter.length || antal > 0)) {
                forslag = forslag.filter(function (f) {
                  return !f || f.slags !== "link" || String(f.url || "").indexOf("/products/") === -1;
                });
              }
              forslag = relevanteProeveForslag(forslag, antal > 0);
              if (forslag.length) visNaesteSkridt(forslag);
              if (i === beskeder.length - 1 && visning.ordre_felter && tv("ordre-send")) visOrdreFelter(null);
            }
          }
        }
        visKontinuitetsmaerke();
        flytSkrivefeltUdAfBody();

        // ⭐ ER BUDGETTET BRUGT OP, ER UDGANGEN «START NY SAMTALE». Uden den
        //   sidder kunden fast: en opbrugt session venter nu 24 timer i stedet
        //   for 1, før den kan mintes på ny.
        if (svar.opbrugt === true) visNySamtaleKnap(true);
        return true;
      })
      .catch(function () {
        // ⚠ FEJLER LUKKET, MEN IKKE DESTRUKTIVT. Et netværksudfald er ikke et
        //   bevis for, at sessionen er væk — vi rydder derfor INTET her.
        //   Kunden ser blot en tom log, præcis som i går, og næste besked
        //   fortsætter samtalen med det id, vi stadig har.
        return false;
      });
  }

  // ⛔ MÆRKET VISES KUN, NÅR SERVEREN HAR BEKRÆFTET. Se noten ovenfor: uden
  //   `kendt:true` er «vi fortsætter, hvor du slap» et løfte uden dækning.
  // ⚠ `tv()` og ikke `t()`: mangler teksten på en ikke-dansk flade, udebliver
  //   mærket helt frem for at vise et nøglenavn (R8's regel).
  function visKontinuitetsmaerke() {
    var tekst = tv("genoptaget");
    if (!tekst) return;
    if (logEl.querySelector(".gmchat-genoptaget")) return;
    var el = document.createElement("p");
    el.className = "gmchat-genoptaget";
    el.setAttribute("role", "status");
    el.textContent = tekst;
    logEl.insertBefore(el, logEl.firstChild);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // «START NY SAMTALE» — OG SPÆRREN, DER GØR DEN TIL ANDET END ET GRATIS KORT
  // ─────────────────────────────────────────────────────────────────────────
  // ⛔⛔ FÆLDEN, SPOR B HAR NAVNGIVET, OG SOM DENNE KNAP LUKKER — OG ÅBNER.
  //   En OPBRUGT session venter nu 24 timer i stedet for 1, før den kan mintes
  //   på ny. Uden en udgang sidder kunden altså fast et helt døgn. Udgangen er
  //   netop denne knap.
  //   ⚠ MEN: giver knappen frisk, fuldt budget ved hvert klik, er tokenloftet
  //     pr. session ophævet med ét klik. Så er spærren ikke en spærre.
  //
  // ⇒ TRE GREB, OG DET ER VIGTIGT AT VIDE, HVILKET AF DEM DER BINDER:
  //   (a) KARANTÆNE. Efter en ny samtale er knappen død i 60 sekunder. Den
  //       gør gentagne klik til en langsom vej, ikke en hurtig.
  //   (b) LOFT PR. SIDEVISNING. Højst to nye samtaler pr. indlæsning af siden.
  //   (c) ⭐ ARVEN. Den nye samtales FØRSTE besked bærer `forrige_session` og
  //       `efter_opbrugt`, så serveren kan kæde de to sammen og give den nye
  //       samtale et REDUCERET budget i stedet for et frisk.
  //
  // ⛔⛔ SIG HØJT HVAD DER BINDER, OG HVAD DER IKKE GØR:
  //   (a) og (b) er FRIKTION, ikke en spærre. De lever i kundens egen browser
  //   og forsvinder ved en genindlæsning eller i en ny fane. En klient kan
  //   ALDRIG håndhæve et budget mod sig selv — den kan kun gøre misbrug
  //   besværligt. **Den bindende spærre er (c), og den skal håndhæves af
  //   serveren.** Feltet sendes allerede; `api.py` læser kun navngivne nøgler
  //   og ignorerer ukendte tavst, så det kan ikke brække noget — men indtil
  //   Spor B har taget imod feltet, er (c) en FORBEREDT kontrakt, ikke en
  //   virkende spærre. Diffen er afleveret. Ingen må læse denne knap som om
  //   budgettet er sikret, før den er inde.
  var NY_SAMTALE_KARANTAENE_MS = 60 * 1000;
  var NY_SAMTALE_MAKS_PR_VISNING = 2;
  var nySamtaleBrugt = 0;
  var nySamtaleSpaerretTil = 0;
  var nySamtaleKnap = null;
  //: Arven fra den samtale, kunden forlod. ⚠ Kun serverens EGET id og et
  //: boolsk flag - aldrig noget af samtalens indhold.
  var forrigeSession = "";
  var forrigeVarOpbrugt = false;

  //: ⭐ TUR-MÆRKET. «Start ny samtale» midt i et ventende svar må ikke lade det
  //: gamle svar lande bagefter og skrive sig ind i den NYE samtale. Et
  //: `AbortController` ville standse kaldet, men ikke et svar, der allerede er
  //: på vej hjem; mærket dømmer ved MODTAGELSEN og dækker begge.
  var turMaerke = 0;

  function nySamtaleMulig() {
    if (!apiEndpoint) return false;
    if (nySamtaleBrugt >= NY_SAMTALE_MAKS_PR_VISNING) return false;
    return Date.now() >= nySamtaleSpaerretTil;
  }

  function opdaterNySamtaleKnap() {
    if (!nySamtaleKnap) return;
    var mulig = nySamtaleMulig();
    nySamtaleKnap.disabled = !mulig;
    var vent = tv("ny-samtale-vent");
    // ⚠ Knappen forsvinder IKKE, når den er spærret. En knap, der forsvinder,
    //   ligner en fejl; en knap, der er tydeligt død med en forklaring, er en
    //   oplysning. Mangler forklaringen i temaet, står den bare død.
    nySamtaleKnap.title = mulig ? "" : (vent || "");
    nySamtaleKnap.setAttribute("aria-disabled", mulig ? "false" : "true");
  }

  //: `fremhaev` = sessionen er opbrugt, og knappen er kundens eneste vej ud.
  function visNySamtaleKnap(fremhaev) {
    var etiket = tv("ny-samtale");
    if (!etiket || !apiEndpoint) return;
    if (nySamtaleKnap) {
      if (fremhaev) nySamtaleKnap.className = "gmchat-ny-samtale gmchat-ny-samtale--frem";
      // ⚠ HÆNGER DEN LØS, SÆTTES DEN IND IGEN. En `body.innerHTML = ""` et
      //   andet sted i filen kan have revet den ud; en udvej, der forsvinder,
      //   fordi noget andet blev tegnet om, er ingen udvej.
      if (!nySamtaleKnap.parentNode && searchForm && searchForm.parentNode) {
        searchForm.parentNode.insertBefore(nySamtaleKnap, searchForm.nextSibling);
      }
      opdaterNySamtaleKnap();
      return;
    }
    var b = document.createElement("button");
    b.type = "button";
    b.className = "gmchat-ny-samtale" + (fremhaev ? " gmchat-ny-samtale--frem" : "");
    b.textContent = etiket;
    b.addEventListener("click", startNySamtale);
    nySamtaleKnap = b;
    // ⚠ Under skrivefeltet, ikke i den rullende log: den er en udvej, og en
    //   udvej skal stå samme sted hver gang, ikke rulle væk med samtalen.
    if (searchForm && searchForm.parentNode) {
      searchForm.parentNode.insertBefore(b, searchForm.nextSibling);
    } else {
      panel.appendChild(b);
    }
    opdaterNySamtaleKnap();
  }

  function startNySamtale() {
    if (!nySamtaleMulig()) { opdaterNySamtaleKnap(); return; }
    nySamtaleBrugt += 1;
    nySamtaleSpaerretTil = Date.now() + NY_SAMTALE_KARANTAENE_MS;

    // ⭐ ARVEN SÆTTES FØR RYDNINGEN — bagefter er id'et væk.
    forrigeSession = sessionId || "";
    // ⚠ `forrigeVarOpbrugt` sættes af `genoptag`/`spoergBotten`, når serveren
    //   har sagt `opbrugt`. Den gættes ikke ud af en tekst.
    var _arvOpbrugt = !!forrigeVarOpbrugt;

    // ⛔ ET VENTENDE SVAR SKAL IKKE LANDE I DEN NYE SAMTALE. Uden mærket ville
    //   det gamle svar dukke op under kundens friske log og se ud som et svar
    //   på noget, hun ikke har spurgt om — og det ville sætte det GAMLE
    //   session-id tilbage i lageret, så «ny samtale» slet ikke blev ny.
    turMaerke += 1;
    saetVenter(false);

    sessionId = "";
    lagerRyd();
    // ⛔⛔ ARVEN SKRIVES EFTER RYDNINGEN, ALDRIG FØR. `lagerRyd()` fjerner HELE
    //   posten; en arv skrevet før ville blive slettet i samme åndedrag. Se
    //   `skrivArv`: uden dette greb lever spærren kun i hukommelsen, og et
    //   sideskift giver frisk, fuldt budget.
    skrivArv(forrigeSession, _arvOpbrugt);
    fjernVedhaeftning();
    sidsteVarer = [];
    // ⛔ HELE FLADEN RYDDES, IKKE KUN LOGGEN: ordrefelter og kontaktformular
    //   bar den forrige samtales kontekst (og i ordrefeltets tilfælde kundens
    //   ordrenummer og mail). En ny samtale, der starter med den forrige
    //   kundes felter udfyldt, er ikke en ny samtale.
    logEl.innerHTML = "";
    // En udtrykkeligt ny samtale starter uden den gamle sagsbesked.
    if (contactMessageField) contactMessageField.value = "";
    saetKontaktTilstand(KONTAKT_SKJULT);
    // ⛔ EN NY SAMTALE ER EN NY SAG. Beholdt vi indsendelsesnøglen, ville
    //   kundens første henvendelse i den NYE samtale ramme den forrige sags
    //   nøgle og blive afvist med 409 — en blindgyde, hun ikke kunne komme ud
    //   af uden at genindlæse siden.
    indsendelsesNoegle = "";
    skjulSidsteUdvej();
    kontaktBesked("", false);
    renderIntro(null);
    opdaterNySamtaleKnap();
    if (nySamtaleKnap) {
      nySamtaleKnap.className = "gmchat-ny-samtale";
      // `renderIntro` tømmer `body`, men knappen hænger uden for den; den
      // skal blot følge skrivefeltet, som netop er flyttet tilbage.
      if (searchForm && searchForm.parentNode &&
          nySamtaleKnap.previousSibling !== searchForm) {
        searchForm.parentNode.insertBefore(nySamtaleKnap, searchForm.nextSibling);
      }
    }
    if (searchInput) searchInput.focus();
  }

  // ─────────────────────────────────────────────────────────────────────────
  // VEDHÆFTNING — ét billede ad gangen, som REFERENCE, aldrig som bytes
  // ─────────────────────────────────────────────────────────────────────────
  // KONTRAKTEN (Spor B, målt — ikke opfundet her):
  //   POST <endpoint>/billede  {"session","type","data":"<base64>"}
  //     200 {"billede","type","bredde","hoejde","udloeber_om_s"}
  //     400 {"fejl","grund","tekst":"<kundevendt, KAN mangle>","billede":""}
  //     409 {"fejl":"ukendt session","billede":""}
  //     413 {"fejl":"for stor","graense"}
  //   POST <endpoint>          {...,"billede":"<id>"}   ← REFERENCEN
  //
  // ⛔ BYTES GÅR ALDRIG GENNEM `/chat`. Den rute har et 16 KiB-loft (`api.py`),
  //   og et telefonfoto er hundredvis af gange større. Billedet får sin egen
  //   dør med sit eget 8 MiB-loft, og samtalen bærer kun en kort reference.
  // ⛔⛔ KUNDENS TEKST MÅ ALDRIG GÅ TABT. Det er hele fejltilstandens formål:
  //   fejler billedet, bliver teksten stående i feltet, kunden får at vide at
  //   billedet ikke kunne bruges, og hun kan sende sin besked uden det.
  var VEDHAEFT_TYPER = ["image/jpeg", "image/png", "image/webp"];
  //: ⚠ Loftet er SERVERENS (8 MiB). Klientens kontrol er en høflighed, så
  //:   kunden ikke venter på en upload, der er dømt på forhånd — den er ikke
  //:   en sikkerhedsgrænse, og serveren svarer 413 uanset hvad.
  var VEDHAEFT_MAKS_BYTES = 8 * 1024 * 1024;
  var vedhaeftId = "";            // serverens reference, ikke bytes
  var vedhaeftBoks = null;
  var billedFelt = null;

  function fjernVedhaeftning() {
    vedhaeftId = "";
    if (vedhaeftBoks && vedhaeftBoks.parentNode) vedhaeftBoks.parentNode.removeChild(vedhaeftBoks);
    vedhaeftBoks = null;
    if (billedFelt) billedFelt.value = "";
  }

  function vedhaeftStatus(tekst, erFejl) {
    if (!vedhaeftBoks) return;
    var s = vedhaeftBoks.querySelector(".gmchat-vedhaeft-status");
    if (!s) return;
    s.textContent = tekst || "";
    s.className = "gmchat-vedhaeft-status" + (erFejl ? " gmchat-vedhaeft-status--fejl" : "");
    // ⚠ `role` skiftes med tilstanden: en fejl skal afbryde skærmlæseren
    //   (`alert`), en kvittering skal ikke (`status`).
    s.setAttribute("role", erFejl ? "alert" : "status");
  }

  //: Forhåndsvisningen bygges af den LOKALE fil, ikke af serverens svar.
  //: ⚠ `URL.createObjectURL` og ikke `FileReader` som datastreng: en 8 MiB
  //:   base64-streng i en `src` fylder ~11 MiB i DOM'et og fryser fladen på en
  //:   telefon. Objekt-URL'en frigives igen, når vedhæftningen fjernes.
  function visVedhaeftning(fil) {
    fjernVedhaeftning();
    var boks = document.createElement("div");
    boks.className = "gmchat-vedhaeft";
    var billede = document.createElement("img");
    billede.className = "gmchat-vedhaeft-billede";
    billede.alt = "";                 // ⛔ dekorativ: filnavnet må ALDRIG i alt (§1)
    var url = "";
    try { url = URL.createObjectURL(fil); } catch (e) { url = ""; }
    if (url) billede.src = url;
    boks.appendChild(billede);
    var status = document.createElement("span");
    status.className = "gmchat-vedhaeft-status";
    status.setAttribute("role", "status");
    boks.appendChild(status);
    var fjernTekst = tv("vedhaeft-fjern");
    if (fjernTekst) {
      var fjern = document.createElement("button");
      fjern.type = "button";
      fjern.className = "gmchat-vedhaeft-fjern";
      fjern.setAttribute("aria-label", fjernTekst);
      fjern.textContent = "×";
      fjern.addEventListener("click", function () {
        if (url) { try { URL.revokeObjectURL(url); } catch (e) {} }
        fjernVedhaeftning();
        if (searchInput) searchInput.focus();
      });
      boks.appendChild(fjern);
    }
    vedhaeftBoks = boks;
    if (searchForm && searchForm.parentNode) {
      searchForm.parentNode.insertBefore(boks, searchForm);
    }
  }

  //: ⭐⭐ GENSKAB VEDHÆFTNINGEN EFTER ET SIDESKIFT — REFERENCEN, IKKE BILLEDET.
  //: `POST <endpoint>/genoptag` svarer med `vedhaeftninger`: en liste af
  //: REFERENCER (`billede`, `type`, `bredde`, `hoejde`, `genbrug_tilbage`,
  //: `udloeber_om_s`) — ALDRIG bytes, se `api._vedhaeftninger_for_session`.
  //: ⛔ VI VISER DERFOR INGEN FORHÅNDSVISNING. Bytes findes ikke på klienten
  //:   efter et sideskift, og at hente dem tilbage ville være at sende et
  //:   kundefoto ud gennem en ny dør for at pynte på en chip. Chippen står
  //:   uden billede, med husets egen «følger med din næste besked»-tekst, og
  //:   ×-knappen virker som altid.
  //: ⛔ KUN EN REFERENCE MED GENBRUG TILBAGE. `genbrug_tilbage: 0` betyder, at
  //:   serveren vil svare «udloebet» på den — at hænge den på fladen ville
  //:   love kunden noget, kæden ikke kan levere.
  //: ⚠ DEN NYESTE VINDER. Serveren sorterer ældst først (`sorted(...,
  //:   key=oprettet)`), så den sidste post er den, kunden sendte senest — og
  //:   det er den, hun mener, når hun skriver «og hvad med den her plet?».
  //: ⚠ Rører INTET, hvis kunden allerede har en vedhæftning i gang på denne
  //:   sidevisning: hendes friske valg vinder over et gammelt svar fra nettet.
  function genskabVedhaeftning(liste) {
    if (vedhaeftId) return;
    if (Object.prototype.toString.call(liste) !== "[object Array]") return;
    var valgt = null;
    for (var i = 0; i < liste.length; i++) {
      var v = liste[i];
      if (!v || typeof v !== "object") continue;
      if (typeof v.billede !== "string" || !v.billede) continue;
      if (typeof v.genbrug_tilbage === "number" && v.genbrug_tilbage <= 0) continue;
      valgt = v;
    }
    if (!valgt) return;
    var tekst = tv("vedhaeft-klar");
    // ⚠ Uden temateksten vises INGEN chip — og så må referencen heller ikke
    //   sættes: et billede, der tavst hænger på næste besked uden at kunden
    //   kan se det, er værre end intet. R8's regel, samme retning.
    if (!tekst) return;
    fjernVedhaeftning();
    var boks = document.createElement("div");
    boks.className = "gmchat-vedhaeft gmchat-vedhaeft--uden-billede";
    var status = document.createElement("span");
    status.className = "gmchat-vedhaeft-status";
    status.setAttribute("role", "status");
    status.textContent = tekst;
    boks.appendChild(status);
    var fjernTekst = tv("vedhaeft-fjern");
    if (fjernTekst) {
      var fjern = document.createElement("button");
      fjern.type = "button";
      fjern.className = "gmchat-vedhaeft-fjern";
      fjern.setAttribute("aria-label", fjernTekst);
      fjern.textContent = "×";
      fjern.addEventListener("click", function () {
        fjernVedhaeftning();
        if (searchInput) searchInput.focus();
      });
      boks.appendChild(fjern);
    }
    vedhaeftBoks = boks;
    if (searchForm && searchForm.parentNode) {
      searchForm.parentNode.insertBefore(boks, searchForm);
    }
    vedhaeftId = String(valgt.billede);
  }

  //: base64 UDEN dataURL-præfikset: kontrakten vil have de rå base64-tegn.
  function filTilBase64(fil) {
    return new Promise(function (loes, afvis) {
      var l = new FileReader();
      l.onerror = function () { afvis(new Error("kunde inte läsas")); };
      l.onload = function () {
        var s = String(l.result || "");
        var i = s.indexOf(",");
        loes(i === -1 ? s : s.slice(i + 1));
      };
      try { l.readAsDataURL(fil); } catch (e) { afvis(e); }
    });
  }

  //: ⭐⭐ MODEL-FRI SESSIONSTART — HULLET, DER LUKKEDE FØRSTE BILLEDE UDE.
  //:   Uploaden kræver en KENDT session, og `genoptag` skaber ingen. Vedhæftede
  //:   kunden et foto FØR sin første besked, svarede serveren 409, og billedet
  //:   havde ingen vej ind.
  //: ⛔ FRISTELSEN VAR EN TOM KUNDEBESKED for at fremtvinge en session. Det er
  //:   udtrykkeligt forbudt: en tom tur er BETALT, tæller på sessionens budget
  //:   og står i logget som noget, kunden aldrig skrev.
  //: ⇒ Spor E har bygget `POST <endpoint>/session`, som mynter en session
  //:   UDEN et modelkald og uden at bruge et token (`api.py:3022`). Den er
  //:   vejen ind.
  //: ⚠ DEN KAN NÆGTE, OG DET ER IKKE EN FEJL: `myntet:false` ved nødstop,
  //:   opbrugt døgnloft eller for mange sessionsstarter. Da bliver `sessionId`
  //:   stående tom, uploaden får sin 409, og fladen siger sandheden: skriv
  //:   først. Vi forsøger ALDRIG igen af os selv.
  //: ⚠ Genstartskæden arves også her (`api.py:3031`) — ellers ville denne dør
  //:   være en nemmere gratis nulstilling af tokenloftet end «Start ny
  //:   samtale». En spærre, der kun dækker den ene af to døre ind til samme
  //:   rum, er ingen spærre.
  var sessionStartProevet = false;

  function sikrSession() {
    if (sessionId || !apiEndpoint || sessionStartProevet) {
      return Promise.resolve(sessionId);
    }
    sessionStartProevet = true;
    // ⛔ T3D 05/10: samme tur-mærke som `genoptagSamtale` og `spoergBotten`. Klikker kunden «Start ny samtale», mens
    //   mynt-kaldet er i luften, må den myntede session IKKE adopteres: den ville blive den nye samtales id, nulstille
    //   den nye arv (`skrivArv("")`) og lade det gamle fotos upload ende i den nye samtale. Svaret kasseres (en ubrugt
    //   serversession er harmløs); uploaden får da en tom `session` og en 409, som fladen allerede kender.
    var _mintMaerke = turMaerke;
    var krop = {};
    if (forrigeSession) {
      krop.forrige_session = forrigeSession;
      krop.efter_opbrugt = !!forrigeVarOpbrugt;
    }
    return fetch(apiSti("/session"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(krop)
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (svar) {
        if (_mintMaerke !== turMaerke) return sessionId;     // T3D: «Start ny samtale» blev klikket, mens kaldet var i luften
        if (!svar || svar.myntet !== true || !svar.session) return sessionId;
        sessionId = String(svar.session);
        try { frigivLager(); } catch (e) {}
        var t0 = gemtTilstand();
        var ny = { id: sessionId, oprettet: Date.now() };
        // ⛔⛔ RETTET 10/09: `true`, IKKE `false`. Her stod `false` med
        //   begrundelsen «en sessionsstart er ikke en kundebesked» — og den
        //   begrundelse målte det forkerte. Uden `kundeRoert` falder
        //   `gemtTilstand()` tilbage på `roert`, og `roert` skrives ved HVERT
        //   skriv, også `noterBesoegtVare` ved et rent sideskift. En kunde
        //   kunne altså holde en session, der ALDRIG havde fået en besked, i
        //   live i ubegrænset tid med ren navigation — den stik modsatte fejl
        //   af den, `kundeRoert` blev bygget for at lukke.
        //   ⛔ OG SERVEREN STEMPLER DEN ALLEREDE: `api.Session` har
        //     `sidste_kundebesked: float = field(default_factory=time.time)`,
        //     så den myntede session har sit 24-timersur i gang fra
        //     myntningen. Klienten skal spejle serveren, ikke være mildere end
        //     den — ellers holder browseren et id, serveren har glemt.
        //   ⚠ At vedhæfte et foto ER kundens handling. Den koster ingen
        //     tokens, men den er ikke passiv browsing, og den forlænger intet
        //     bagefter: `kundeRoert` sættes ÉN gang her og flyttes kun af en
        //     rigtig kundebesked.
        gemTilstand(ny, t0.historik, true);
        // ⭐ ARVEN ER LEVERET. Serveren har fået `forrige_session` og har
        //   kædet den nye session til den forrige; feltet må derfor ikke
        //   kunne bruges igen — hverken af denne sidevisning eller af en
        //   senere, gennem lageret.
        forrigeSession = "";
        forrigeVarOpbrugt = false;
        skrivArv("", false);
        return sessionId;
      })
      .catch(function () { return sessionId; });
  }

  function sendBillede(fil) {
    var fejlTekst = tv("vedhaeft-fejl");
    visVedhaeftning(fil);
    // ⛔ TO KONTROLLER FØR NETVÆRKET, begge en høflighed mod kunden — ikke en
    //   sikkerhedsgrænse. Serveren dømmer.
    if (VEDHAEFT_TYPER.indexOf(String(fil.type || "").toLowerCase()) === -1) {
      vedhaeftStatus(tv("vedhaeft-type") || fejlTekst, true);
      vedhaeftId = "";
      return;
    }
    if (fil.size > VEDHAEFT_MAKS_BYTES) {
      vedhaeftStatus(tv("vedhaeft-stor") || fejlTekst, true);
      vedhaeftId = "";
      return;
    }
    vedhaeftStatus(tv("vedhaeft-sender") || "", false);
    // ⭐ Har kunden endnu ingen session, mynter vi en MODEL-FRI. Se
    //   `sikrSession`. Lykkes det ikke, går uploaden videre med tom session,
    //   får sin 409, og fladen beder hende skrive først — ingen omvej.
    sikrSession()
      .then(function () { return filTilBase64(fil); })
      .then(function (data) {
        return fetch(apiSti("/billede"), {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          // ⚠ `session` kan være tom: kunden kan vedhæfte FØR sin første
          //   besked. Serveren svarer da 409 «ukendt session», og fladen
          //   beder hende skrive først. Vi opfinder aldrig et id.
          body: JSON.stringify({ session: sessionId || "",
                                 type: fil.type, data: data })
        });
      })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          return { status: r.status, krop: j };
        });
      })
      .then(function (svar) {
        // ⛔ 200 ER DEN ENESTE SUCCES. Alle andre koder er fejl, og fejlen må
        //   ikke efterlade et id: en reference til et billede, serveren ikke
        //   har, ville få NÆSTE besked til at fejle i stedet.
        if (svar.status === 200 && svar.krop && svar.krop.billede) {
          vedhaeftId = String(svar.krop.billede);
          vedhaeftStatus(tv("vedhaeft-klar") || "", false);
          return;
        }
        vedhaeftId = "";
        // ⛔⛔ 409 «ukendt session» ER EN KENDT, ÅBEN TILSTAND — IKKE EN FEJL,
        //   FLADEN SKAL KLARE MED EN OMVEJ.
        //   Målt i dag: uploaden kræver en KENDT session, og `genoptag` skaber
        //   ingen. Kundens FØRSTE billede har derfor ingen vej ind, hvis hun
        //   vedhæfter før sin første besked.
        //   ⇒ Fristelsen var at sende en tom besked for at fremtvinge en
        //     session. Det er udtrykkeligt forbudt: det ville være en skjult,
        //     BETALT kundetur, som kunden aldrig skrev. Spor E løser det på
        //     serversiden.
        //   ⇒ Indtil da siger fladen sandheden: skriv først, så tager jeg imod
        //     billedet. Kundens tekst er urørt, og billedet kan vælges igen.
        if (svar.status === 409) {
          vedhaeftStatus(tv("vedhaeft-skriv-foerst") || fejlTekst, true);
          return;
        }
        // ⛔ SERVERENS EGEN KUNDEVENDTE TEKST VINDER, NÅR DEN FINDES.
        //   Kontrakten siger udtrykkeligt, at `tekst` KAN mangle på en ukendt
        //   flade — så husets egen tekst er reserven, ikke omvendt. Og
        //   `fejl`/`grund` er MASKINFELTER: de vises aldrig for kunden.
        var kundetekst = (svar.krop && typeof svar.krop.tekst === "string")
          ? svar.krop.tekst.trim() : "";
        vedhaeftStatus(kundetekst || fejlTekst, true);
      })
      .catch(function () {
        vedhaeftId = "";
        vedhaeftStatus(fejlTekst, true);
      });
  }

  // ⛔ FELTET RENDERES AF JS'EN, IKKE AF LIQUID'EN — OG DET ER ET VALG.
  //   Uden en bagende (`apiEndpoint` tom, husets dokumenterede nødstop) findes
  //   der ingen `/billede`-dør. Stod knappen i markup'en, ville kunden kunne
  //   vælge et foto, som ingen kunne modtage. Et nødstop skal degradere nedad,
  //   aldrig sidelæns.
  // ⚠ Og uden temateksten udebliver knappen helt (R8: ingen dansk standard i
  //   JS'en, som ville slå igennem på SE/NO/B2B).
  function opsaetBilledfelt() {
    var etiket = tv("vedhaeft");
    if (!etiket || !apiEndpoint || !searchForm) return;
    if (searchForm.querySelector(".gmchat-vedhaeft-knap")) return;
    var felt = searchForm.querySelector(".gmchat-felt-samlet");
    if (!felt) return;

    var input = document.createElement("input");
    input.type = "file";
    input.className = "gmchat-vedhaeft-input";
    input.accept = VEDHAEFT_TYPER.join(",");
    // ⛔ ÉT BILLEDE AD GANGEN. Kontrakten bærer ét `billede`-felt pr. besked;
    //   `multiple` ville love kunden noget, kæden ikke kan levere.
    input.hidden = true;
    var id = "gmchat-vedhaeft-fil";
    input.id = id;

    var knap = document.createElement("button");
    knap.type = "button";
    knap.className = "gmchat-vedhaeft-knap";
    knap.setAttribute("aria-label", etiket);
    knap.appendChild(klipsIkon());
    knap.addEventListener("click", function () { input.click(); });

    input.addEventListener("change", function () {
      var fil = input.files && input.files[0];
      if (!fil) return;
      sendBillede(fil);
    });

    // Klipsen står FØR skrivefeltet, send-pilen efter — samme læseretning som
    // kundens egen handling: vedhæft, skriv, send.
    felt.insertBefore(knap, felt.firstChild);
    felt.appendChild(input);
    billedFelt = input;
  }

  function klipsIkon() {
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("class", "gmchat-klips");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    var p = document.createElementNS(ns, "path");
    p.setAttribute("d", "M17 8.5v7a5 5 0 0 1-10 0v-8a3.5 3.5 0 0 1 7 0v8a2 2 0 0 1-4 0V8");
    p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "1.8");
    p.setAttribute("stroke-linecap", "round");
    p.setAttribute("stroke-linejoin", "round");
    svg.appendChild(p);
    return svg;
  }

  //: ⛔ DE TRE TILSTANDE FRA KONTRAKTEN — OG «UDLØBET» ER IKKE EN FEJL.
  //:   `vedhaeftning.status` er «brugt» | «udloebet» | feltet UDELADT.
  //:   Kundens tekst er besvaret i ALLE TRE tilfælde, og fladen må derfor ikke
  //:   få nogen af dem til at ligne et mislykket svar. En udløbet vedhæftning
  //:   er en oplysning om billedet, ikke et problem med samtalen — den står
  //:   som en rolig linje, ikke som en advarsel.
  function visVedhaeftningsSvar(v) {
    if (!v || typeof v !== "object") return;      // feltet udeladt: intet at vise
    var el = document.createElement("p");
    if (v.status === "brugt") {
      var brugt = tv("vedhaeft-brugt");
      if (!brugt) return;
      el.className = "gmchat-vedhaeft-svar";
      el.textContent = brugt;
    } else if (v.status === "udloebet") {
      // ⚠ Serverens egen tekst vinder; husets er reserven.
      var tekst = (typeof v.tekst === "string" && v.tekst.trim())
        ? v.tekst.trim() : tv("vedhaeft-udloebet");
      if (!tekst) return;
      el.className = "gmchat-vedhaeft-svar gmchat-vedhaeft-svar--udloebet";
      el.textContent = tekst;
    } else {
      return;                                      // ukendt status: vis intet
    }
    el.setAttribute("role", "status");
    logEl.appendChild(el);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // KURVEN ER TOFASET — SERVEREN PLANLÆGGER, FLADEN UDFØRER, SERVEREN DØMMER
  // ─────────────────────────────────────────────────────────────────────────
  // ⛔ HVORFOR DET IKKE KAN VÆRE ANDERLEDES (Spor C, målt): Shopifys AJAX-kurv
  //   hænger på browserens `cart`-cookie. **Serveren kan ikke nå kundens kurv.**
  //   Derfor er widget'en den, der udfører — og netop derfor må den ikke også
  //   være den, der kvitterer.
  //
  //     server:  planlaeg(ønske, kurv_nu) → Instruks | Resultat
  //     klient:  DENNE fil udfører instruksen mod /cart/*.js
  //     server:  doem(handling_id, kurv)  → Resultat        ← DOMMEN
  //
  // ⛔⛔ FLADEN KVITTERER ALDRIG SELV. Planen er ordret: *«Teksten «tilføjet»
  //   er ikke bevis; den faktiske kurv skal stemme.»* Kurvreviewet 10/09 fandt
  //   præcis den fejl i den anden ende: et FEJLET køb blev meldt `udfoert` med
  //   «0 meter … 0,00 kr.». Fladen sender kurvens FAKTISKE tilstand tilbage —
  //   ikke en påstand om, at kaldet gik godt — og teksten kommer fra serverens
  //   dom i næste svar.
  // ⛔ EN UKENDT `handling_id` giver `doem() → None`. Det skal blive til «det
  //   ved jeg ikke», aldrig til en kvittering. Fladen sender derfor id'et
  //   ORDRET tilbage og opfinder det aldrig.
  //
  // ⛔⛔ PLANEN ER SERVERBUNDET. Fladen kan ikke INDSENDE en plan — den udfører
  //   kun instrukser, den har MODTAGET i et svar. Kundens knapper på
  //   produktkortet sender en almindelig kundebesked («Læg 3 meter … i
  //   kurven»); de bygger aldrig en `kurv_instrukser`-post. Kunne de det,
  //   ville en flade, en angriber kontrollerer, kunne bestemme, hvad der blev
  //   skrevet i kurven.
  //
  // ⭐⭐ AFSTEMT 10/09 MOD SPOR E'S FAKTISKE KODE — IKKE MOD EN BESKRIVELSE.
  //   Målt i `api.py`/`samtale.py`, ikke refereret:
  //     `samtale.py:962`  svar.kurv            = kvitteringen | null
  //     `samtale.py:968`  svar.kurv_instrukser = PLANERNE (altid en liste)
  //     `api.py:4131`     begge felter `setdefault`'es ⇒ ALTID til stede
  //     `api.py:2625`     `_kurvkvittering_ud` — kvitteringens kanoniske form
  //     `api.py:2684`     `_kurv_fra_krop`     — `linjer` kræves EKSPLICIT
  //     `api.py:3178`     `_kurvdom`           — POST <endpoint>/kurv
  //   ⛔ BEGGE FELTER LIGGER INDE I `svar.svar`, ikke på svarets rod. Læses de
  //     det forkerte sted, er de altid `undefined`, og hele kæden ligger død
  //     uden en eneste fejl — præcis den tavse form, bruddet nedenfor havde.
  //   ⚠ Afviger serveren fra dette igen, bygges der efter KODEN. En flade,
  //     der efterligner en rapport i stedet for det, serveren sender, måler
  //     et andet univers.
  //: ⛔ KVITTERINGEN ER SERVERENS TEKST, ORDRET — FLADEN OMSKRIVER DEN IKKE.
  //:   Kurvreviewet 10/09 fandt husets dyreste fejlklasse i netop dette led:
  //:   et FEJLET køb blev meldt `udfoert` med «0 meter … 0,00 kr.». Systemet
  //:   fortalte kunden, at noget lykkedes, mens det modsatte skete.
  //: ⚠ `udfald` bruges KUN til at vælge, hvor roligt eller tydeligt linjen
  //:   står — aldrig til at formulere noget. Ordene er serverens.
  //:   E's fem udfald: `udfoert` · `spoerg` · `afvist` · `afviger` ·
  //:   `ukendt_tilstand`. De tre sidste er alle AFVIGELSER fra det bestilte.
  //: ⚠ `spoergsmaal` er en AFKLARING (uklar vare, variant eller antal), ikke
  //:   en fejl. Planen: *«Spørg før handling, hvis vare, variant eller antal
  //:   er uklart.»* Den står derfor som en almindelig linje.
  function visKurvkvittering(kvit) {
    if (!kvit || typeof kvit !== "object") return;
    var el = document.createElement("p");
    var udfald = String(kvit.udfald || "");
    el.className = "gmchat-kurv-kvittering"
      + (udfald === "udfoert" ? " gmchat-kurv-kvittering--ok"
        : ((udfald === "afvist" || udfald === "afviger"
            || udfald === "ukendt_tilstand")
            ? " gmchat-kurv-kvittering--afvig" : ""));
    el.setAttribute("role", "status");
    el.textContent = String(kvit.tekst || "");
    if (el.textContent) logEl.appendChild(el);

    // ⛔⛔ RABATFORSLAGET SKAL BÆRE BEGGE TAL. `kurv.pruev_praesentation()`
    //   KASTER ved tavshed om en merpris — og grunden er målt af Spor C:
    //       4 m → 5 m giver meterpris 100,00 → 95,00,
    //       MEN total 400,00 → 475,00.
    //   Et «forslag», der kun viser den lavere METERpris, mens totalen
    //   stiger, er mersalg forklædt som hjælp. Serveren sender derfor ALTID
    //   `merpris_oere`, når `rabat` er sat.
    // ⛔ FLADEN KALDER DET ALDRIG EN BESPARELSE OG TIER ALDRIG OM MERPRISEN.
    //   Teksten er serverens; her sættes kun tallet ved siden af, og kun med
    //   husets egen etiket fra temaet. Mangler etiketten, vises tallet slet
    //   ikke — hellere intet end et bart beløb uden hvad det betyder.
    // ⛔⛔ EN SÆTNING SIGES ÉN GANG — RETTET 10/09 EFTER EN MÅLING.
    //   På DOMMENS vej (`POST <endpoint>/kurv`) bygger `kurv.py` selv
    //   kvitteringsteksten som «<kvittering> <forslag.tekst()>»
    //   (`Kurvtjeneste._doem`: `tekst = f"{tekst} {forslag.tekst()}"`), OG
    //   svaret bærer `rabat.tekst` med PRÆCIS samme sætning ved siden af.
    //   Fladen skrev derfor rabatsætningen TO gange, og fordi sætningen selv
    //   bærer merprisen ordret («… men du betaler 75,00 kr. mere i alt …»),
    //   stod merprisen TRE gange med etiketten nedenfor.
    //   ⇒ Er sætningen allerede sagt i hovedteksten, siges den ikke igen.
    // ⛔⛔ LINJERNE ER SVARET PAA DET SPOERGSMAAL, KUNDEN STILLEDE.
    //   `rabat` handler om NAESTE trin; `linjer` om de maengder, kunden selv
    //   naevnte. Renderer vi kun `rabat`, svarer vi paa et ANDET spoergsmaal
    //   - eller paa ingenting, for `rabat` ER null, naar naeste trin ligger
    //   uden for raekkevidde. Derfor staar blokken her, uafhaengigt af den.
    // ⛔ KLIENTEN FORMATERER ALDRIG ET BELOEB. `total_tekst` og
    //   `meterpris_tekst` er serverens faerdige strenge og bruges ORDRET.
    //   Mangler `total_tekst`, springes linjen over - vi regner os ikke frem.
    // ⛔⛔ TOMME `linjer[]` SKAL STADIG VISE GRUNDPRISEN. Ved `rabatkilde`
    //   `ukendt`/`ugyldig` sender serveren `linjer: []`, og et ydre krav om
    //   `length > 0` ville lade den verificerede meterpris forsvinde HELT.
    //   Hellere kun grundprisen end ingenting.
    var _erListe = Object.prototype.toString.call(kvit.linjer) === "[object Array]";
    var _mp = String(kvit.meterpris_tekst || "");
    var _visMp = !!_mp && kvit.grundpris_verificeret === true;
    if ((_erListe && kvit.linjer.length) || _visMp) {
      // ⛔ POSITIV TILLADELSESLISTE. Totaler vises KUN ved `"laest"`.
      //   `"ukendt"`, `"ugyldig"` og enhver vaerdi vi ikke kender giver INGEN
      //   totaler. En fejlet kilde, der viser «0 %», paastaar at der ingen
      //   rabat er - det er noget andet end «vi ved det ikke».
      var _maaVise = String(kvit.rabatkilde || "") === "laest";
      var _boks = document.createElement("div");
      _boks.className = "gmchat-prislinjer";
      _boks.setAttribute("role", "status");
      if (_visMp) {
        var _mpEl = document.createElement("p");
        _mpEl.className = "gmchat-prislinjer-meterpris";
        _mpEl.textContent = _mp;
        _boks.appendChild(_mpEl);
      }
      if (_maaVise && _erListe) {
        var _liste = document.createElement("ul");
        _liste.className = "gmchat-prislinjer-liste";
        for (var _i = 0; _i < kvit.linjer.length; _i++) {
          var _p = kvit.linjer[_i];
          if (!_p || typeof _p !== "object") continue;
          var _tt = String(_p.total_tekst || "");
          if (!_tt) continue;
          // ⛔ SEPARATOREN ER TEKST, IKKE CSS. Deltaet roerer kun JS'en, og
          //   en styling, der ikke foelger med, ville give «4 m359,80 kr.».
          //   Tegnene staar ens paa dansk, svensk og norsk.
          var _dele = [String(_p.meter) + " m"];
          if (typeof _p.pct === "number" && _p.pct > 0) _dele.push("−" + _p.pct + " %");
          _dele.push(_tt);
          var _pkt = document.createElement("li");
          _pkt.className = "gmchat-prislinje";
          _pkt.textContent = _dele.join(" · ");
          _liste.appendChild(_pkt);
        }
        if (_liste.childNodes.length) _boks.appendChild(_liste);
      }
      if (_boks.childNodes.length) logEl.appendChild(_boks);
    }

    if (kvit.rabat && typeof kvit.rabat === "object") {
      var rTekst = String(kvit.rabat.tekst || "");
      var hoved = String(kvit.tekst || "");
      var alleredeSagt = !!rTekst && hoved.indexOf(rTekst) !== -1;
      if (!alleredeSagt) {
        var r = document.createElement("p");
        r.className = "gmchat-kurv-forslag";
        r.setAttribute("role", "status");
        r.textContent = rTekst;
        var merEtiket = tv("kurv-merpris");
        var mer = kvit.rabat.merpris_oere;
        // ⛔ MERPRISEN SÆTTES KUN VED SIDEN AF, NÅR SÆTNINGEN IKKE SELV BÆRER
        //   DEN — og fladen TIER ALDRIG om den. `kurv.pruev_praesentation()`
        //   KASTER, hvis en forslagstekst med `merpris_oere > 0` ikke bærer
        //   beløbet ordret; en ikke-tom `rabat.tekst` har det altså med pr.
        //   konstruktion. Er teksten TOM (en producent, der kun sender tal),
        //   er etiketten det eneste sted, beløbet kan stå — og så skal den med.
        if (!rTekst && merEtiket && typeof mer === "number" && mer > 0) {
          var m = document.createElement("span");
          m.className = "gmchat-kurv-merpris";
          m.textContent = " " + merEtiket.replace(
            /\{beloeb\}/g, beloebTekst(mer, kvit.rabat.valuta));
          r.appendChild(m);
        }
        if (r.textContent) logEl.appendChild(r);
      }
    }

    if (kvit.spoergsmaal && kvit.spoergsmaal.tekst) {
      var s = document.createElement("p");
      s.className = "gmchat-kurv-spoergsmaal";
      s.setAttribute("role", "status");
      s.textContent = String(kvit.spoergsmaal.tekst);
      logEl.appendChild(s);
    }
    body.scrollTop = body.scrollHeight;
  }

  //: ⛔ ØRE ER HELTAL, OG DE BLIVER DET HELE VEJEN. `kurv.Kurvlinje`s egen
  //:   regel: float-kroner giver 0,01-fejl på en total, kunden betaler.
  //:   Formateringen sker HER, på klienten, som E's kontrakt foreskriver.
  //: ⚠ Dansk form med komma. Valutaen sættes efter tallet, som husets øvrige
  //:   pristekster gør; er den ukendt, skrives den ikke.
  function beloebTekst(oere, valuta) {
    var n = Math.round(Number(oere) || 0);
    var kr = Math.floor(Math.abs(n) / 100);
    var re = Math.abs(n) % 100;
    var t = (n < 0 ? "-" : "") + String(kr) + "," + (re < 10 ? "0" : "") + String(re);
    return valuta ? t + " " + String(valuta) : t;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // KURVEN ER TOFASET — SERVEREN PLANLÆGGER, FLADEN UDFØRER, SERVEREN DØMMER
  // ─────────────────────────────────────────────────────────────────────────
  // ⛔ HVORFOR DET IKKE KAN VÆRE ANDERLEDES (Spor C, målt): Shopifys AJAX-kurv
  //   hænger på browserens `cart`-cookie. **Serveren kan ikke nå kundens kurv.**
  //   Derfor er widget'en den, der udfører — og netop derfor må den ikke også
  //   være den, der kvitterer.
  //
  //     server:  planlaeg(ønske, kurv_nu) → Instruks | Resultat
  //     klient:  DENNE fil udfører instruksen mod /cart/*.js
  //     server:  POST <endpoint>/kurv     → {kendt, kvittering}   ← DOMMEN
  //
  // ⛔⛔ RETTET 10/09 EFTER ET MÅLT KONTRAKTBRUD — OG DET VAR TAVST.
  //   Her stod `instruks.slags` og `instruks.krop`. De felter findes IKKE.
  //   Serveren sender (`samtale.py:968`, målt i koden, ikke i en rapport):
  //       {noegle, handling, variant_id, antal, linje_noegle, egenskaber}
  //   Konsekvensen var, at `rute` ALTID blev "" og funktionen returnerede
  //   `null` — **serverens kurvplaner blev aldrig udført**, uden en fejl,
  //   uden en log, uden noget som helst. Reglen «en ukendt handling udføres
  //   ALDRIG» var rigtig; den ramte bare hver eneste instruks, fordi feltet
  //   aldrig havde eksisteret. Begge ender var grønne mod hver sin form.
  //   ⇒ Fire handlinger, ikke to. `tilfoej` · `ret` · `fjern` · `proeve`.
  //
  // ⛔⛔ OG DOMMEN VENTER IKKE LÆNGERE PÅ KUNDENS NÆSTE BESKED.
  //   Her lå `ventendeKurvResultat`, fordi `doem`-ruten manglede. Den findes
  //   nu (`POST <endpoint>/kurv`), og den kaldes UMIDDELBART efter handlingen.
  //   Ellers fik kunden først at vide, om kurven stemte, når hun tilfældigvis
  //   stillede næste spørgsmål — og skrev hun ikke mere, aldrig.
  //
  // ⛔⛔ PLANEN ER SERVERBUNDET. Fladen kan ikke INDSENDE en plan — den udfører
  //   kun instrukser, den har MODTAGET i et svar, og sender netop den `noegle`
  //   tilbage, den fik. Nøglen er allerede serverbundet
  //   (`sha256(sagsnoegle|handling_id)[:32]`), så én kundes handlings-id kan
  //   pr. konstruktion ikke dømmes mod en andens bestilling.
  //   Kundens knapper på produktkortet sender en almindelig KUNDEBESKED; de
  //   bygger aldrig en instruks.

  //: Shopifys AJAX-kurv → E's `_kurv_fra_krop`-form.
  //:
  //: ⛔⛔ `null` OG `{"linjer": []}` ER TO FORSKELLIGE SVAR, OG FORSKELLEN ER
  //:   HELE BESKEDEN TIL KUNDEN. E's `_kurv_fra_krop` kræver nøglen `linjer`
  //:   EKSPLICIT: en krop uden den er en UKENDT kurv, en krop med `[]` er en
  //:   ægte TOM kurv.
  //:   ⇒ Kunne `/cart.js` ikke læses, returneres `null`, og feltet udelades
  //:     helt i kaldet. Sendte vi `{}`, ville en netværksfejl blive til
  //:     påstanden «din kurv er tom» — en fejl forvandlet til en oplysning om
  //:     kundens kurv. Det er samme regel som `Kurvtjeneste._laes()`: fejl til
  //:     UKENDT, aldrig til TOM.
  //: ⛔⛔ FIRE FEJLVEJE, ÉT SVAR - OG INDTIL NU INTET SPOR.
  //:   `hentKurv()` kollapsede alle fejl til `null`. Det er RIGTIGT som
  //:   adfaerd (ukendt er ikke tom), men det gjorde en fejl udiagnosticerbar:
  //:   serveren kan se, at klientkurven mangler, og ingen kan se HVORFOR.
  //:   Maalt 13/09 paa Q12-tur 11: `klientens_kurv` var `None`, og der fandtes
  //:   ikke ét spor i nogen ende til at skille de fire veje ad.
  //: ⚠ DEN VEJ, DER I DAG ER UMULIG AT SKELNE: en SYNKRON kastning fra et
  //:   tredjeparts-script, der har pakket `window.fetch` ind. Se filens egen
  //:   note ved `spoergBotten` (linje ~3139-3145) - og maalt paa den levende
  //:   side roerer mindst tre fremmede scripts `fetch`/XHR.
  //: ⛔ INGEN ADFAERDSAENDRING. Alle fire veje returnerer fortsat `null`, og
  //:   en gyldig kurv giver nøjagtig samme objekt som før.
  //: ⛔ INGEN KUNDEDATA. Kun vejens navn og en HTTP-status - aldrig kurvens
  //:   indhold, aldrig et beloeb, aldrig en linje.
  //: ⛔⛔ FEJLEN FOELGER RESULTATET - IKKE MODULET. RED TEAM 13/09 maalte det:
  //:   `sidsteKurvfejl` var en modulvariabel, og to OVERLAPPENDE kald
  //:   (chatturen og kurvdommen) med hver sin fejl - 503 og 404 - gav 404 paa
  //:   BEGGE kroppe. Den ene turs fejl blev meldt som den andens.
  //:   ⚠ En nulstilling pr. laesning loeser det ikke: naar kaldene overlapper,
  //:     skriver de i den samme variabel, og den sidste vinder.
  //:   ⇒ `hentKurv()` svarer derfor med `{kurv, fejl}`, og hver kalder baerer
  //:     sin egen. Der er ingen delt tilstand at forurene.
  //: ⛔ KONTRAKTEN ER SERVERENS, ORDRET:
  //:     "kurv_fejl": { "vej": <en af FEM hvidlistede koder>, "status": <heltal 0-599> }
  //:   · paa SAMME niveau som `kurv`, og KUN naar `kurv` udelades
  //:   · `status` er VALGFRI - udelades den, laeser serveren -1.
  //: ⭐ `kastet-synkront` er sin EGEN kode paa ledningen, og den skal med ad
  //:   BEGGE veje - red teams roede 2 var, at kun chatvejen bar den.
  //: ⛔ KUN VEJ OG STATUS. Aldrig kurvindhold, aldrig et beloeb, aldrig en
  //:   linje, aldrig kundetekst.
  var KURVFEJL_PAA_LEDNING = {
    "svar-ikke-ok": "svar-ikke-ok",
    "ikke-json": "ikke-json",
    "items-ikke-liste": "items-ikke-liste",
    "kastet": "kastet",
    "kastet-synkront": "kastet-synkront"
  };

  //: Ét svar fra kurvlaesningen: `kurv` er sat ELLER `fejl` er sat.
  function _kurvsvar(kurv, vej, status) {
    if (vej) {
      try {
        console.warn("[gmchat] kurvlaesning fejlede: " + vej
          + (status === undefined ? "" : " (status " + status + ")"));
      } catch (e) { /* konsollen maa aldrig vaelte turen */ }
    }
    return {
      kurv: kurv || null,
      fejl: vej ? { vej: vej, status: (status === undefined ? null : status) }
                : null
    };
  }

  function kurvfejlTilKrop(f) {
    // ⛔⛔ `hasOwnProperty`, IKKE et opslag. Maalt af husets injektionsproeve:
    //   `vej: "constructor"` ramte `Object.prototype.constructor`, slap forbi
    //   et `if (!vej)` (en funktion er truthy) og gav en krop UDEN `vej`.
    //   Et arvet navn er ikke et medlem af hvidlisten.
    if (!f || !Object.prototype.hasOwnProperty.call(
          KURVFEJL_PAA_LEDNING, f.vej)) {
      return null;
    }
    var vej = KURVFEJL_PAA_LEDNING[f.vej];
    if (typeof vej !== "string" || !vej) return null;
    var ud = { vej: vej };
    if (typeof f.status === "number" && isFinite(f.status)
        && Math.floor(f.status) === f.status
        && f.status >= 0 && f.status <= 599) {
      ud.status = f.status;
    }
    return ud;
  }

  //: ⛔ ÉN EJER AF DEN SYNKRONE KASTNING, saa begge kaldere faar den.
  function kurvLoefteSikkert() {
    try {
      return Promise.resolve(hentKurv())
        .catch(function () { return _kurvsvar(null, "kastet"); });
    } catch (e) {
      return Promise.resolve(_kurvsvar(null, "kastet-synkront"));
    }
  }

  function hentKurv() {
    return fetch("/cart.js", { credentials: "same-origin",
                               headers: { "Accept": "application/json" } })
      .then(function (r) {
        if (!r.ok) return _kurvsvar(null, "svar-ikke-ok", r.status);
        return r.json().then(function (c) { return { _c: c }; },
                             function () {
                               return _kurvsvar(null, "ikke-json", r.status);
                             });
      })
      .then(function (pakke) {
        if (!pakke || !("_c" in pakke)) return pakke;   // fejl allerede formet
        var c = pakke._c;
        if (!c || Object.prototype.toString.call(c.items) !== "[object Array]") {
          return _kurvsvar(null, "items-ikke-liste");   // ⛔ UKENDT, ikke tom
        }
        return _kurvsvar({
          // ⛔ ØRE, HELTAL. Shopify leverer allerede minor units.
          total_oere: Math.round(Number(c.total_price) || 0),
          valuta: String(c.currency || ""),
          linjer: c.items.map(function (i) {
            return {
              // `key` er Shopifys egen linjenøgle — den samme, `linje_noegle`
              // peger på. ⚠ Vi opfinder den aldrig.
              noegle: String(i.key || ""),
              variant_id: String(i.variant_id || i.id || ""),
              titel: String(i.product_title || i.title || ""),
              antal: Math.round(Number(i.quantity) || 0),
              linjepris_oere: Math.round(Number(i.line_price) || 0),
              linjepris_foer_rabat_oere: Math.round(
                Number(i.original_line_price !== undefined
                       ? i.original_line_price : i.line_price) || 0),
              egenskaber: (i.properties && typeof i.properties === "object")
                ? i.properties : {}
            };
          })
        }, null);
      })
      .catch(function () { return _kurvsvar(null, "kastet"); });
  }

  //: ⛔ FIRE HANDLINGER — SERVEREN UDSENDER ALLE FIRE.
  //:   `tilfoej` og `proeve` er begge en tilføjelse; forskellen ligger i
  //:   varianten og i `egenskaber`, som serveren har valgt. Fladen behandler
  //:   dem ens, fordi Shopifys kurv gør det — den skelner ikke mellem en
  //:   stofprøve og en meterlængde.
  //: ⛔ `fjern` er `/cart/change.js` med antal 0. Der findes ingen
  //:   `/cart/remove.js`.
  //: ⛔ EN UKENDT `handling` UDFØRES ALDRIG. Vi gætter aldrig, hvad serveren
  //:   mente — men listen herunder er nu opregnet mod SERVERENS EGEN
  //:   `Handling`-enum, ikke mod en formodning. Det var netop en uopregnet
  //:   liste, der lod hele kæden ligge død.
  var KURV_TILFOEJ = ["tilfoej", "proeve"];
  var KURV_RET = ["ret", "fjern"];

  function kurvUdfoer(instruks) {
    var h = String(instruks && instruks.handling || "");
    var rute = "";
    var krop = null;
    if (KURV_TILFOEJ.indexOf(h) !== -1) {
      rute = "/cart/add.js";
      krop = { id: String(instruks.variant_id || ""),
               quantity: Math.round(Number(instruks.antal) || 0) };
      // ⚠ `properties` er Shopifys navn for det, kontrakten kalder
      //   `egenskaber`. Tom ⇒ udelades: en tom `properties` skriver en tom
      //   linjeegenskab på varen.
      if (instruks.egenskaber && typeof instruks.egenskaber === "object"
          && Object.keys(instruks.egenskaber).length) {
        krop.properties = instruks.egenskaber;
      }
    } else if (KURV_RET.indexOf(h) !== -1) {
      rute = "/cart/change.js";
      // ⛔⛔ EN EKSPLICIT LINJENØGLE FALDER ALDRIG TAVST TILBAGE PÅ VARIANTEN.
      //   Kurvreviewets fejl 4, ordret: «Forældet eksplicit linjenøgle faldt
      //   tilbage på varianten» ⇒ **en ANDEN linje blev slettet** — og meldt
      //   `udfoert`. Sendte serveren en `linje_noegle`, er DEN målet; er den
      //   `null`, har serveren udtrykkeligt valgt varianten.
      var maal = (instruks.linje_noegle !== null
                  && instruks.linje_noegle !== undefined
                  && instruks.linje_noegle !== "")
        ? String(instruks.linje_noegle) : String(instruks.variant_id || "");
      if (!maal) return Promise.resolve(null);
      krop = { id: maal,
               quantity: h === "fjern" ? 0
                 : Math.round(Number(instruks.antal) || 0) };
    }
    if (!rute || !krop || !krop.id) return Promise.resolve(null);
    return fetch(rute, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(krop)
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .catch(function () { return null; });
  }

  //: Udfør 0-n instrukser i RÆKKEFØLGE og hent dommen med det samme.
  //: ⚠ Serielt, ikke parallelt: to samtidige skrivninger til samme kurv giver
  //:   en efterkontrol, der læser en tilstand, ingen af dem havde til hensigt.
  //: Beder temaet gentegne sin kurvvisning. Muterer intet, laeser intet.
  function opdaterTemaetsKurvvisning() {
    try {
      document.dispatchEvent(new CustomEvent("cart:build"));
    } catch (e) { /* ingen drawer eller ingen CustomEvent: uaendret tilstand */ }
  }

  function kurvUdfoerInstrukser(instrukser) {
    if (!instrukser || !instrukser.length || !apiEndpoint) return;
    var i = 0;
    function naeste() {
      if (i >= instrukser.length) {
        // ⛔ VISNINGEN HALTER EFTER MUTATIONEN. Maalt 12/09: efter en
        //   chat-mutation viste temaets drawer kun de gamle linjer. En kunde,
        //   der faar «jeg har lagt den i kurven» og ser en drawer UDEN varen,
        //   tror det mislykkedes og laegger den i IGEN.
        // ⛔ INGEN NY MUTATION - temaet gentegner fra sin EGEN friske laesning.
        // ⭐ Eventnavnet er MAALT i temaets egen assets/theme.js:1701
        //   («Dev-friendly way to build the cart»); `buildCart()` kalder
        //   `theme.cart.getCartProductMarkup()`, som henter kurven selv.
        opdaterTemaetsKurvvisning();
        // ⛔ FACIT HENTES FRISKT — ikke fra svaret på den sidste mutation.
        //   Kurvreviewets fejl 3: efterkontrollen summerede en ANDEN linje med
        //   samme variant. Vi sender hele kurven og lader serveren dømme.
        var sidste = instrukser[instrukser.length - 1] || {};
        // ⛔ SAMME SIKRE VEJ SOM CHATTUREN. Her stod `hentKurv().then(...)`
        //   uden `try`, saa en SYNKRON kastning aldrig blev til
        //   `kastet-synkront` paa kurvvejen - red teams roede 2.
        return kurvLoefteSikkert().then(function (svar) {
          return kurvDom(String(sidste.noegle || ""), svar);
        });
      }
      var instruks = instrukser[i++];
      return kurvUdfoer(instruks).then(naeste);
    }
    naeste();
  }

  //: ⛔ DOMMEN. `kendt:false` er BIT-IDENTISK for en ukendt nøgle og en fremmed
  //:   session — med vilje, ellers ville endepunktet være et orakel over
  //:   andres handlings-id'er. Fladen forsøger derfor ikke at skelne dem:
  //:   begge betyder «det ved jeg ikke», og der vises INGEN kvittering.
  //: ⛔ ET `kendt:false` MÅ ALDRIG BLIVE TIL «din kurv er tom». Vi ved intet
  //:   om kurven i den tilstand.
  function kurvDom(noegle, svar) {
    if (!noegle) return Promise.resolve(null);
    var krop = { session: sessionId || "", handlings_noegle: noegle };
    // ⛔ FELTET UDELADES HELT VED EN UKENDT KURV. Se `hentKurv`: `{}` ville
    //   blive læst som en ægte TOM kurv af `_kurv_fra_krop`.
    // ⚠ `svar` er `{kurv, fejl}` - fejlen foelger DETTE kalds resultat, ikke
    //   en delt variabel.
    var kurv = svar && svar.kurv;
    if (kurv) krop.kurv = kurv;
    else {
      var _kf2 = kurvfejlTilKrop(svar && svar.fejl);
      if (_kf2) krop.kurv_fejl = _kf2;
    }
    return fetch(apiSti("/kurv"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(krop)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (svar) {
        if (!svar || svar.kendt !== true || !svar.kvittering) return null;
        visKurvkvittering(svar.kvittering);
        return svar.kvittering;
      })
      .catch(function () { return null; });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // ⭐⭐ KONTAKTINDSENDELSEN — SAGEN FØRST, MAILEN SOM SIDSTE UDVEJ  10/09/2026
  // ═══════════════════════════════════════════════════════════════════════════
  // ⛔⛔ HULLET, DER LUKKES HER (målt af Spor G, hash-stemplet):
  //   `apiSti("/kontakt")` fandtes **0 gange** i widget'en. En kunde, der bad
  //   om et menneske, endte i butikkens mailboks UDEN at der blev oprettet en
  //   sag. Hele ticketkontrakten — sagsnummer, status, ansvarlig,
  //   Hermes-udkast — blev sprunget over, og ingen opdagede det, fordi mailen
  //   jo kom frem. Husets egen fejlklasse, ordret: «udført fra systemets side,
  //   brudt fra kundens».
  //
  // ⛔⛔ MEN SHOPIFY-FORMULAREN ER IKKE EN FORGLEMMELSE, OG DEN RIVES IKKE UD.
  //   `bevis_formular.py` siger det udtrykkeligt: den er Shopifys egen
  //   `{% form 'contact' %}` → info@g-m.dk, **bevist med 799 modtagne mails,
  //   senest 17/08**, og den virker uafhængigt af eskaleringsrelæet, som CEO
  //   slukkede 26/08 og som forbliver slukket.
  //   Det var det rigtige valg dengang — der fandtes intet sagslager. Nu gør
  //   der. Men **en bevist vej erstattes ikke af en ubevist**: en henvendelse,
  //   der går tabt fordi vores NYE vej fejlede, er værre end en henvendelse
  //   uden sagsnummer.
  //
  // ⇒ PRIMÆR + SIDSTE UDVEJ:
  //     1. `POST <endpoint>/kontakt` er den primære vej. 201 ⇒ kunden får sit
  //        sagsnummer, og sagen findes i medarbejderfladen.
  //     2. 400/409 ⇒ kunden retter eller sender igen. Teksten bliver stående.
  //     3. 503 (eller intet svar) ⇒ teksten bliver stående, OG Shopifys egen
  //        formular tilbydes synligt som sidste udvej.
  //
  // ⛔⛔ OG SANDHEDEN I BEGGE TILFÆLDE. En henvendelse gennem Shopify-
  //   formularen får **INGEN sag** i medarbejderfladen. Fladen lover derfor
  //   hverken et sagsnummer eller en opfølgning, der forudsætter en sag — den
  //   siger ligeud, at det er en almindelig mail til os.
  //
  // ⛔ 201 ER DEN ENESTE KVITTERING. 409, 400 og 503 bærer ALDRIG et
  //   sagsnummer, fordi serveren først svarer 201 EFTER commit
  //   (`api.py:_kontakt`: «Denne metode må derfor ALDRIG svare 201, før
  //   funktionen er returneret»). En «venlig» kvittering på en sag, der ikke
  //   blev gemt, er husets dyreste fejlklasse.

  //: ⚠ STABIL NØGLE PR. FORMULAR, IKKE PR. FORSØG. Serveren hasher den sammen
  //:   med sit EGET sessions-id (`samtale._kontaktnoegle`), så den behøver
  //:   ikke være unik på tværs af kunder — kun stabil for DENNE indsendelse.
  //:   Er den stabil, rammer et genforsøg efter et mistet svar SAMME sag i
  //:   stedet for at lave en dublet. Det er hele grunden til, at 503 er sikker
  //:   at prøve igen på.
  var indsendelsesNoegle = "";

  //: ⛔ Sand mens ÉN indsendelse er undervejs. Løftes ÉT sted
  //:   (`frigivSendKnap`), så den ikke kan komme ud af trit med knappens lås.
  //:   Se den lange note ved `if (indsendelseIGang) return;`.
  var indsendelseIGang = false;

  function nyIndsendelsesNoegle() {
    indsendelsesNoegle = "i" + Date.now().toString(36) +
      Math.random().toString(36).slice(2, 10);
    return indsendelsesNoegle;
  }

  function kontaktNoegle() {
    return indsendelsesNoegle || nyIndsendelsesNoegle();
  }

  //: Husets besked i kontaktområdet. ⚠ Aldrig serverens maskinfelter
  //: (`fejl`, `felt`, `genindsend`) — de er til koden, ikke til kunden.
  function kontaktBesked(tekst, erFejl) {
    // ⛔ HUSETS VAGTFORM, OG DEN ER IKKE PYNT. `bevis_formular` K6 kræver
    //   `if (!contactSection) return;` som EGEN, FØRSTE sætning — ikke
    //   `return null;` og ikke gemt bag et `||`. Vagten findes, fordi en
    //   uvogtet aflæsning kaster en TypeError inde i `.then()`, som
    //   `.catch()` besvarer med endnu et `showContact` — der kaster igen, og
    //   kunden ender med en tom boble.
    // ⚠ `undefined` i stedet for `null` er uden betydning her: kaldsstederne
    //   spørger kun, om der KOM noget tilbage.
    if (!contactSection) return;
    var gl = contactSection.querySelector(".gmchat-kontakt-svar");
    if (gl) gl.remove();
    if (!tekst) return null;
    var el = document.createElement("p");
    el.className = "gmchat-kontakt-svar"
      + (erFejl ? " gmchat-kontakt-svar--fejl" : "");
    el.setAttribute("role", erFejl ? "alert" : "status");
    el.textContent = tekst;
    contactSection.insertBefore(el, contactSection.firstChild);
    return el;
  }

  //: ⛔⛔ ÉN EJER AF «SEND AD SHOPIFYS EGEN VEJ».
  //:   `HTMLFormElement.submit()` fyrer INGEN submit-lyttere og går derfor
  //:   uden om vores egen — det er netop dét, der gør den brugbar som udvej.
  //: ⚠ `nativIndsendt` findes, fordi kaldet kan komme ad to veje (kundens klik
  //:   på udvejen, og den ordløse nødvej i `kontaktFejl`). To indsendelser af
  //:   samme formular ville give huset to mails om samme henvendelse, og
  //:   medarbejderen kan ikke se, at det er én kunde.
  var nativIndsendt = false;

  //: ⛔⛔ TESTFLADEN SENDER IKKE MAIL UD AF HUSET (12/09).
  //:   Serverens mail-transport er fysisk lukket - men DENNE vej gaar ikke
  //:   gennem serveren. `contactForm.submit()` er Shopifys EGEN formular, og
  //:   den sender til butikkens kontaktadresse UDEN OM vores transport. «Ingen
  //:   mail i test» var derfor sandt om vores vej og usandt om huset.
  //: ⭐ ÉT sted lukker begge veje: baade kundens klik paa sidste udvej og den
  //:   ordloese noedvej i `kontaktFejl` gaar gennem denne ene funktion.
  //: ⛔ LIVE ER UROERT. Vagten kraever et test-maerke; uden begge maerker er
  //:   adfaerden bit-for-bit som foer.
  //: ⚠ BREDT MED VILJE (`||`, ikke `&&`). Den godkendte testvej gates paa
  //:   `testflade && harPrivacy && testNoegle`, men en SPAERRE skal fange mere
  //:   end den gate, ikke mindre: er ét af maerkerne sat, er vi taet nok paa
  //:   test til, at en mail ud af huset er forkert.
  //: ⭐ DEN SYNLIGE FEJL BEVARES. `kontaktFejl` kalder kun herned, naar der
  //:   hverken er tekst eller udvej paa skaermen - saa en tavs blokering ville
  //:   genindfoere praecis den blindgyde, noten ovenfor blev skrevet imod.
  //:   Derfor skrives der ALTID noget synligt, naar vagten spaerrer.
  //: ⚠ Den faste streng er ikke et dansk tilbagefald (R8): den kan kun naa en
  //:   skaerm, hvor et test-maerke er sat, og staar aldrig paa en kundeflade.
  //: ⛔ Ticket-POST'en (`apiSti("/kontakt")`) er UROERT - den normale vej ind
  //:   til sagslageret virker uaendret.
  function testmaerke() {
    return testflade || testNoegle;
  }

  function nativIndsendelse() {
    if (!contactForm || nativIndsendt) return false;
    if (testmaerke()) {
      kontaktBesked(tv("kontakt-fejl-igen")
        || "[gmchat-test] Mail er spaerret i testfladen - beskeden blev IKKE "
           + "sendt. Sagen er ikke oprettet ad denne vej.", true);
      try {
        console.warn("[gmchat] native Shopify-mail BLOKERET (testflade)");
      } catch (e) { /* konsollen maa aldrig vaelte kontaktvejen */ }
      return false;
    }
    nativIndsendt = true;
    try { contactForm.submit(); return true; } catch (e) { return false; }
  }

  //: ⛔⛔ INGEN BLINDGYDE — OGSÅ NÅR TEMAET IKKE HAR ORDENE (11/09).
  //:   `tv()` giver TOM streng, når nøglen mangler, og `.liquid`ens nødspor
  //:   fylder KUN danske standarder på en dansk shop (`gmchat_dansk`); på
  //:   SE/NO/B2B er `kontakt-fejl-igen` og udvejens to tekster tomme, indtil
  //:   nogen oversætter dem. MÅLT som fejlform, ikke gættet: uden ord viser
  //:   `kontaktBesked("")` ingenting, `visSidsteUdvej()` returnerer tidligt —
  //:   og kundens klik på «Send» gjorde da BOGSTAVELIGT ingenting. Hendes
  //:   besked bliver liggende i et felt, ingen henter, og intet på skærmen
  //:   siger hvorfor.
  //: ⇒ Kan vi hverken sige noget eller tegne en synlig udvej, indsendes
  //:   Shopifys egen formular med det samme. Den er den BEVISTE vej (799
  //:   mails), og den tegner sin egen kvittering på næste sidevisning —
  //:   altså den eneste udgang, der ikke kræver en tekst, vi ikke har.
  //: ⚠ ARGUMENTET IMOD, og hvorfor det taber: en tavs omdirigering er ikke
  //:   noget, kunden har bedt om. Men hun HAR bedt om at sende, og det
  //:   alternativ, reglen vejes imod, er ikke «ingen overraskelse» — det er
  //:   «ingenting sker». Husets låste regel er «kunden må aldrig efterlades i
  //:   en blindgyde» (CEO 03/09), ikke «kunden må aldrig overraskes».
  //: ⛔ DEN GØR DET **KUN** ORDLØST. Har vi ord, får kunden valget: teksten
  //:   bliver stående, og udvejen er en knap, hun selv trykker på — for en
  //:   kvittering uden sagsnummer skal være hendes valg, ikke vores.
  function kontaktFejl(tekst, tilbydUdvej) {
    var vist = tekst ? kontaktBesked(tekst, true) : null;
    if (tilbydUdvej) visSidsteUdvej();
    // ⚠ SPOERG DOM'EN, IKKE FUNKTIONEN. Det, der afgoer om kunden HAR en
    //   udvej, er om boksen staar der - ikke om vi kaldte funktionen, der
    //   plejer at tegne den.
    // ⛔ Og opslaget ligger i `sidsteUdvejStaar`, ikke her: husets vagtform
    //   `if (!contactSection) return;` er LAAST af `bevis_formular` K6 (den maa
    //   hverken baere en returvaerdi eller gemme sig i et udtryk), og K6 maaler
    //   HVER funktion, der aflaeser `.gmchat-contact`. Ét vogtet opslag, som
    //   alle tre kaldere deler, er baade kortere og maalbart.
    var udvej = sidsteUdvejStaar();
    if (!vist && !udvej) return nativIndsendelse();
    return true;
  }

  //: Boksen, hvis den staar paa skaermen. ⚠ Husets vagtform FOERST og ALENE.
  function sidsteUdvejStaar() {
    if (!contactSection) return;
    return contactSection.querySelector(".gmchat-sidste-udvej");
  }

  //: ⛔ SIDSTE UDVEJ — OG DEN SIGER HVAD DEN ER.
  //:   Knappen sender den NATIVE Shopify-formular gennem `nativIndsendelse`.
  //:   Noten ved siden af siger, at det bliver en almindelig mail UDEN en sag.
  //: ⚠ Mangler en af de to tekster i temaet, vises udvejen slet ikke — så
  //:   ville kunden få en knap uden at vide, hvad den koster hende. Den
  //:   tilstand er ikke en blindgyde længere: `kontaktFejl` fanger den.
  //: ⚠ DEN SVARER IKKE, OM DEN LYKKEDES — og det er med vilje. Husets
  //:   vagtform (`if (!contactSection) return;`) er låst af `bevis_formular`
  //:   K6 og må ikke bære en returværdi. `kontaktFejl` spørger i stedet DOM'en
  //:   gennem `sidsteUdvejStaar()`, hvilket også er det rigtigere mål: om
  //:   kunden HAR en udvej, ikke om vi mente at give hende en.
  function visSidsteUdvej() {
    // ⛔ VAGTEN STÅR FØRST OG ALENE. Den lå før sammen med opslaget i ét
    //   `||`-udtryk. JavaScript kortslutter, så det VAR sikkert — men en
    //   vagt, der kun holder på grund af evalueringsrækkefølgen, kan ingen
    //   kontrol efterprøve, og den næste, der bytter om på de to led, får
    //   ingen advarsel. Sikkerhed, der afhænger af en detalje, er ikke
    //   sikkerhed; den er held med en god forklaring.
    if (!contactSection) return;
    if (sidsteUdvejStaar()) return;
    var etiket = tv("kontakt-sidste-udvej");
    var note = tv("kontakt-sidste-udvej-note");
    if (!etiket || !note) return;
    var boks = document.createElement("div");
    boks.className = "gmchat-sidste-udvej";
    var p = document.createElement("p");
    p.className = "gmchat-sidste-udvej-note";
    p.textContent = note;
    var b = document.createElement("button");
    b.type = "button";
    b.className = "gmchat-sidste-udvej-knap";
    b.textContent = etiket;
    b.addEventListener("click", function () {
      // ⛔ `.submit()` OG IKKE `.requestSubmit()`: den første springer
      //   submit-lytterne over (netop dét vi vil her), den anden fyrer dem og
      //   ville løbe ind i vores egen `preventDefault` igen. Ét sted ejer det
      //   kald — se `nativIndsendelse`.
      nativIndsendelse();
    });
    boks.appendChild(p);
    boks.appendChild(b);
    contactSection.appendChild(boks);
  }

  function skjulSidsteUdvej() {
    // ⚠ ÉT opslag, delt med `visSidsteUdvej` og `kontaktFejl` - se
    //   `sidsteUdvejStaar`. To kopier af «hvor bor udvejen» driver fra
    //   hinanden, og den ene ville da rydde noget, den anden ikke kan se.
    var b = sidsteUdvejStaar();
    if (b) b.remove();
  }

  function kontaktFelt(navn) {
    if (!contactSection) return;      // husets vagtform, se `kontaktBesked`
    return contactSection.querySelector("[name='contact[" + navn + "]']");
  }

  //: ⭐ SANDT, NÅR SERVEREN SELV HAR SAMTALEN. Sættes ÉT sted pr. kendsgerning:
  //:   i `spoergBotten`s svar (en tur er gennemført) og i `genoptagSamtale`
  //:   (serveren sendte beskederne tilbage). Læses kun af `kontaktProblem`.
  //: ⚠ Den må ALDRIG gættes af klientens eget lager: `gemtTilstand()` kan bære
  //:   beskeder fra en session, serveren har glemt, og så ville transskriptet
  //:   blive udeladt af BÅDE sagen og spørgsmålet.
  var harServerSamtale = false;

  //: Kundens SENESTE egne ord i loggen — hendes spørgsmål, når hun ikke selv
  //: har skrevet i formularen. ⚠ `renseMarkoer`: hendes tekst kan indeholde
  //: vores egen blokmarkør (målt 04/09, G4), og den må ikke følge med ind i et
  //: felt, hvor den senere læses som vores.
  function sidsteKundetekst() {
    if (!logEl) return "";
    var b = logEl.querySelectorAll(".gmchat-msg--user");
    for (var i = b.length - 1; i >= 0; i--) {
      var t2 = String(b[i].textContent || "").trim();
      if (t2) return renseMarkoer(t2);
    }
    return "";
  }

  //: ⛔⛔ KUNDENS SPØRGSMÅL — IKKE VORES EGET INDSTIK.
  //:   `showContact()` fylder beskedfeltet med VORES blok: produktlinje,
  //:   «Spørgsmål: …» og hele transskriptet. Sendte vi feltet råt som
  //:   `problem`, blev sagens `question` = transskriptet — ordret den fejl,
  //:   `samtale.modtag_kontaktindsendelse` selv advarer imod («transskriptet
  //:   var byte-identisk med bottens begrundelse», rød hat runde 2). Sagen
  //:   ville have et spørgsmålsfelt, ingen kan svare på, og
  //:   medarbejderfladens første kolonne ville vise en markørlinje.
  //: ⇒ Vores blok fjernes med `fjernVoresBlok` — SAMME funktion, formularen
  //:   selv bruger, så de to aldrig kan drive fra hinanden — og `problem` er
  //:   dermed DET, KUNDEN SKREV. Skrev hun intet selv, bruges hendes seneste
  //:   egne ord i loggen; det er spørgsmålet, hun kom med.
  //: ⚠ OG TRANSSKRIPTET ER IKKE TABT, men det bæres ÉT sted ad gangen:
  //:     · har serveren selv haft en tur, ligger samtalen i sessionens
  //:       `historik` og bliver sagens `conversation_snapshot` (api.py sender
  //:       `historik=list(s.historik)`),
  //:     · har den IKKE (FAQ-svar og fejlveje sker HELT i klienten, og en
  //:       nymyntet session har tom historik), findes der ingen anden bærer —
  //:       da lægges transskriptet UNDER hendes egne ord, så spørgsmålet står
  //:       først og konteksten alligevel når medarbejderen.
  //:   Aldrig begge, aldrig ingen af dem.
  //: ⚠ Serveren klipper selv ved `MAKS_SPOERGSMAAL_TEGN` (8000) — den
  //:   afviser ikke en lang tekst, så rækkefølgen afgør, hvad der overlever
  //:   klippet. Hendes ord står derfor først, ikke vores.
  function normaliserKontaktTelefon(nummer, kode) {
    var n = String(nummer || "").trim();
    if (!n) return "";
    n = n.replace(/[\s().-]/g, "");
    if (n.indexOf("00") === 0) n = "+" + n.slice(2);
    if (n.charAt(0) !== "+") {
      var k = String(kode || "").replace(/\s/g, "");
      if (!/^\+[1-9]\d{0,3}$/.test(k)) return null;
      // Nationale trunkpræfikser i de to lande, der bruger dem.
      if ((k === "+46" || k === "+49") && n.charAt(0) === "0") n = n.slice(1);
      n = k + n;
    }
    return /^\+[1-9]\d{6,14}$/.test(n) ? n : null;
  }

  var telefonFelt = root.querySelector("#gmchat-contact-phone");
  var landekodeFelt = root.querySelector("#gmchat-contact-country");
  var andenLandekode = root.querySelector("#gmchat-contact-country-custom");
  function kontaktTelefon() {
    return normaliserKontaktTelefon(telefonFelt ? telefonFelt.value : "",
      landekodeFelt && landekodeFelt.value === "other"
        ? (andenLandekode ? andenLandekode.value : "")
        : (landekodeFelt ? landekodeFelt.value : "+45"));
  }
  function opdaterTelefon() {
    if (andenLandekode && landekodeFelt) {
      var anden = landekodeFelt.value === "other";
      andenLandekode.disabled = !anden;
      var felt = andenLandekode.closest(".gmchat-phone-custom");
      if (felt) felt.hidden = !anden;
    }
    if (telefonFelt) telefonFelt.setCustomValidity(kontaktTelefon() === null
      ? "Ange ett giltigt telefonnummer och en landskod, eller lämna telefonfältet tomt." : "");
  }
  [telefonFelt, landekodeFelt, andenLandekode].forEach(function (el) {
    if (el) { el.addEventListener("input", opdaterTelefon); el.addEventListener("change", opdaterTelefon); }
  });
  opdaterTelefon();

  function kontaktProblem(feltet) {
    var kundens = fjernVoresBlok(String(feltet.value || "")).trim();
    if (!kundens) kundens = sidsteKundetekst();
    if (harServerSamtale) return kundens;
    var tr = buildTransskript();
    if (!tr) return kundens;
    return kundens ? kundens + "\n\n" + tr : tr;
  }

  // ⛔ KUN NÅR DER ER EN BAGENDE. Er `apiEndpoint` tom — husets dokumenterede
  //   nødstop — rører vi ikke formularen, og den opfører sig NØJAGTIG som i
  //   går: Shopifys egen vej, som er bevist at nå frem. Et nødstop skal
  //   degradere nedad, aldrig sidelæns.
  // ⛔⛔ TESTFLADENS MAILSPAERRE. To dele, og ingen af dem roerer ticket-vejen.
  // ⭐ DEL 1 - FORUDSAETNINGEN FJERNES. `/challenge?form_type=contact` er
  //   Shopifys SERVERSVAR paa en native POST til `/contact`. MAALT 12/09 med
  //   `addEventListener` instrumenteret FOER sidens scripts: paa
  //   `#gm-chat-contact` binder KUN vores egen widget (to lyttere, bobbel) og
  //   Ahrefs' analytics sig - der er INGEN captcha-lytter at komme foerst i.
  //   Spam-beskyttelsen arbejder paa serveren og kender formularen paa det
  //   skjulte `form_type=contact`. Vi gaetter derfor ikke laengere paa HVEM
  //   der kunne sende; vi fjerner det, der goer en POST til en henvendelse.
  // ⛔ DEL 2 - `preventDefault` i capture-fasen, saa ingen navigation sker.
  //   ⛔⛔ INGEN `stopPropagation`. Den ville draebe vores EGEN bubble-lytter
  //     nedenfor - altsaa praecis den ticket-vej, spaerren skal beskytte.
  //   ⛔ OG INGEN BESKED VED NORMAL SUCCES: findes den normale vej, siger vi
  //     intet her og lader den arbejde. Kun naar den IKKE findes (tomt
  //     `apiEndpoint`), ville kunden ellers staa i en blindgyde - og saa,
  //     og kun saa, skriver vi noget synligt.
  // ⛔ LIVE ER UAENDRET: hele blokken koerer kun med et testmaerke.
  if (contactForm && testmaerke()) {
    var _ft = contactForm.querySelector("[name='form_type']");
    if (_ft) {
      _ft.setAttribute("data-gmchat-testspaerret", _ft.getAttribute("name"));
      _ft.removeAttribute("name");
    }
    contactForm.setAttribute("data-gmchat-foer-action",
      contactForm.getAttribute("action") || "");
    contactForm.setAttribute("action", "#gmchat-test-spaerret");
    var _normalVej = !!(contactSection && apiEndpoint);
    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!_normalVej) {
        kontaktBesked(tv("kontakt-fejl-igen")
          || "[gmchat-test] Mail er spaerret i testfladen - beskeden blev "
             + "IKKE sendt.", true);
        try {
          console.warn("[gmchat] native submit spaerret (testflade, "
            + "ingen normal vej)");
        } catch (e2) { /* konsollen maa aldrig vaelte kontaktvejen */ }
      }
    }, true);
  }

  if (contactForm && contactSection && apiEndpoint) {
    contactForm.addEventListener("submit", function (e) {
      var navnFelt = kontaktFelt("name");
      var mailFelt = kontaktFelt("email");
      var problemFelt = kontaktFelt("body");
      // ⚠ Mangler et af felterne, er markup'en en anden end den, vi kender.
      //   Da lader vi Shopifys egen vej passere urørt frem for at gætte.
      // ⛔⛔ MEN IKKE I TESTFLADEN. Denne retur ligger FOER `preventDefault`,
      //   saa den native Shopify-formular sender af sted - UDEN nogensinde at
      //   kalde `nativIndsendelse`. Vagten dér daekker altsaa ikke denne gren;
      //   uden det her ville «ingen mail i test» se lukket ud og staa aabent.
      // ⭐ Den normale kontakt-POST er uroert: vi naar kun hertil, naar
      //   markup'en mangler et felt, og da har den vej alligevel ikke koert.
      // ⛔ LIVE ER BIT-FOR-BIT UAENDRET - uden testmaerke er det samme `return`.
      if (!navnFelt || !mailFelt || !problemFelt) {
        if (testmaerke()) {
          e.preventDefault();
          kontaktBesked(tv("kontakt-fejl-igen")
            || "[gmchat-test] Mail er spaerret i testfladen - beskeden blev "
               + "IKKE sendt, og formularen mangler et felt.", true);
          try {
            console.warn("[gmchat] native Shopify-mail BLOKERET "
              + "(testflade, manglende felt i formularen)");
          } catch (e2) { /* konsollen maa aldrig vaelte kontaktvejen */ }
        }
        return;
      }
      e.preventDefault();
      // ⛔⛔ ÉN INDSENDELSE AD GANGEN — MÅLT, IKKE FORMODET (11/09).
      //   MÅLT med to klik i samme øjeblik: første klik mynter sessionen og
      //   får 201; andet klik løber forbi den endnu uafsluttede myntning med
      //   `sessionId` STADIG tom (`sikrSession` forsøger kun én gang) og får
      //   **409**. Lander det svar sidst, bliver kundens kvittering — med et
      //   sagsnummer, der findes — overskrevet af «det lykkedes ikke», og hun
      //   sender igen. Så har huset to sager om samme sag, og hun har fået to
      //   modstridende beskeder om den samme handling.
      //   ⚠ Og klikket ER muligt: knappen låses, men `SEND_GENDAN_MS` (8 s)
      //     frigiver den igen, netop så en afbrudt afsendelse ikke bliver en
      //     død knap. Filens egen note ovenfor siger det ligeud: «gendannes
      //     knappen mens en langsom POST stadig er undervejs, kan kunden
      //     trykke igen».
      //   ⇒ Spærren varer PRÆCIS så længe låsen (`frigivSendKnap` løfter
      //     begge). Når knappen igen er i live, er et genforsøg tilladt — og
      //     dér er den stabile `indsendelse`-nøgle bagstopperen: serveren
      //     svarer på SAMME sag.
      //   ⛔ EFTER `preventDefault`, aldrig før: en tidlig retur uden den
      //     ville sende den native formular af sted midt i vores egen
      //     indsendelse — både en sag og en mail for ét klik.
      if (indsendelseIGang) return;
      indsendelseIGang = true;
      skjulSidsteUdvej();
      kontaktBesked("", false);

      // ⚠ FELTERNE LÆSES NU, IKKE EFTER MYNTNINGEN. Værdierne er kundens, og
      //   de skal være dem, hun trykkede «Send» på.
      var _navn = String(navnFelt.value || "");
      var _mail = String(mailFelt.value || "");
      var _problem = kontaktProblem(problemFelt);
      var _sendtBeskedfelt = String(problemFelt.value || "");
      var _kontaktTurMaerke = turMaerke;
      var _telefon = kontaktTelefon();
      if (_telefon === null) {
        frigivSendKnap();
        if (telefonFelt) telefonFelt.reportValidity();
        return;
      }
      // ⚠ Ordrefeltet bygges af `visOrdreFelter` og lever i LOGGEN,
      //   ikke i kontaktområdet. Har kunden udfyldt det, følger
      //   nummeret med sagen — ellers udelades feltet helt.
      var ordreFelt = logEl.querySelector("[name='ordrenummer']");
      var _ordre = (ordreFelt && ordreFelt.value) ? String(ordreFelt.value) : "";

      // ⭐⭐ EN SAG KRÆVER EN SESSION — OGSÅ NÅR BOTTEN SVIGTEDE (11/09).
      //   `api.py:_kontakt` svarer **409** på en session, serveren ikke
      //   kender, og fladens HYPPIGSTE vej til formularen er netop
      //   `spoergBotten`s `.catch()`: kaldet fejlede, fejlteksten vises,
      //   `showContact(besked)` åbner kontaktvejen — og DA findes der ingen
      //   session, fordi det er serveren, der udsteder id'et i sit svar.
      //   Uden en myntning her ville PRÆCIS den kunde, systemet lige svigtede,
      //   være den eneste, der ikke kunne få en sag. Det samme gælder enhver
      //   FAQ-vej (`answerFromFaq` / `showNoResult` / `answerWithEscalation`),
      //   som åbner formularen uden at have rørt serveren.
      //   ⛔ Og det er ikke et gæt på, at det er tilladt: `POST
      //     <endpoint>/session` er husets egen MODEL-FRIE dør (`api.py:
      //     _sessionstart`), den koster intet modelkald og intet token, den
      //     arver genstartskæden, og den NÆGTER selv ved nødstop eller loft
      //     (`myntet:false`). Nægter den, står `sessionId` tom, vi får vores
      //     409 — og kunden får besked og den beviste vej. Vi forsøger aldrig
      //     igen af os selv (`sessionStartProevet`).
      // ⛔ TRY OM HELE KÆDEN, fordi vi allerede har taget `preventDefault`.
      //   Kaster noget herinde (et manglende `fetch` i en exotisk indlejring,
      //   et `Promise`, der ikke findes), er formularens egen vej væk OG vores
      //   er død: kundens klik ville gøre bogstaveligt ingenting. Det er
      //   samme fejlform som `showContact`s egen vagt er skrevet imod.
      // ⚠ Kroppen er BEVIDST ikke rykket ind et niveau mere: den er uændret
      //   fra før myntningen kom til, og en ren indrykningsændring ville
      //   skjule den egentlige rettelse i enhver diff.
      try {
      sikrSession().then(function () {
      var krop = {
        session: sessionId || "",
        indsendelse: kontaktNoegle(),
        navn: _navn,
        mail: _mail,
        problem: _problem
      };
      if (_ordre) krop.ordrenummer = _ordre;
      if (_telefon) krop.telefon = _telefon;

      return fetch(apiSti("/kontakt"), {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(krop)
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; })
            .then(function (j) { return { status: r.status, krop: j }; });
        })
        .then(function (svar) {
          frigivSendKnap();
          // ⭐ 201 — OG KUN 201 — ER EN KVITTERING.
          if (svar.status === 201 && svar.krop && svar.krop.sagsnummer) {
            // Ryd kun den bekraeftede besked; bevar nyere tekst og ny samtale.
            if (turMaerke === _kontaktTurMaerke
                && String(problemFelt.value || "") === _sendtBeskedfelt) {
              problemFelt.value = "";
            }
            // ⛔ SERVERENS EGEN TEKST FØRST. Husets sagsnummer-etiket lægges
            //   ved siden af, så kunden har noget at henvise til.
            // ⛔⛔ ÉN AUTORITATIV SAGSKVITTERING - IKKE TO.
            //   MAALT paa sag NWBU567C: serverens egen tekst sagde
            //   «Sagen er oprettet med nummer NWBU567C …», og husets
            //   nummer-etiket lagde «Dit sagsnummer er NWBU567C …» ved siden
            //   af. Kunden fik nummeret to gange i én kvittering.
            //   ⇒ Samme greb som rabatsaetningen i `visKurvkvittering`: er
            //     nummeret allerede sagt, siges det ikke igen. Serverens
            //     tekst vinder, fordi den er husets egen og deterministisk.
            var _sagsnr = String(svar.krop.sagsnummer);
            var _servertekst = svar.krop.tekst ? String(svar.krop.tekst) : "";
            var linjer = [];
            if (_servertekst) linjer.push(_servertekst);
            var nrTekst = tv("kontakt-sagsnummer");
            if (nrTekst && _servertekst.indexOf(_sagsnr) === -1) {
              linjer.push(nrTekst
                .replace(/\{sagsnummer\}/g, _sagsnr)
                .replace(/\{mail\}/g, String(svar.krop.kontaktmail || "")));
            }
            // ⚠ Siger serveren intet, SKAL etiketten med - ellers staar
            //   kunden uden et nummer at henvise til.
            if (!linjer.length && nrTekst) {
              linjer.push(nrTekst
                .replace(/\{sagsnummer\}/g, _sagsnr)
                .replace(/\{mail\}/g, String(svar.krop.kontaktmail || "")));
            }
            kontaktBesked(linjer.join(" "), false);
            // ⛔ SAGSTILSTAND, IKKE MAILTILSTAND. Se noten ved
            //   `KONTAKT_KVITTERING_SAG`: her er der ikke sendt nogen mail.
            saetKontaktTilstand(KONTAKT_KVITTERING_SAG);
            // ⚠ Næste indsendelse er en NY sag. Uden dette ville en kunde,
            //   der skriver igen om noget andet, ramme den forrige sags nøgle
            //   og få en 409.
            nyIndsendelsesNoegle();
            return;
          }
          // ⛔ ALT ANDET: INGEN KVITTERING, INGEN TILSTANDSSKIFT.
          //   Kundens tekst bliver stående i felterne — det er hele grunden
          //   til, at serveren ikke kvitterer før commit.
          if (svar.status === 400) {
            // ⚠ `felt: "mail"` ⇒ lad hende RETTE i stedet for at starte
            //   forfra. Vi flytter fokus derhen; vi rører ikke værdien.
            var f = svar.krop && svar.krop.felt;
            if (f === "mail") {
              kontaktFejl(tv("kontakt-fejl-mail") || tv("kontakt-fejl-igen"),
                          false);
              if (mailFelt) {
                mailFelt.focus();
                if (typeof mailFelt.select === "function") mailFelt.select();
              }
              return;
            }
            // ⛔⛔ ET 400 UDEN ET FELTNAVN ER IKKE «RET DIN MAIL» (11/09).
            //   Her stod mailteksten på ALLE 400'ere. Men ruten svarer også
            //   400 på «ugyldig krop» (kroppen over 32 KiB — og feltet bærer
            //   hele transskriptet), på «ukendt shop» og på enhver
            //   valideringsfejl fra `opret_ticket` (fx et tomt spørgsmål).
            //   At pege på mailen dér sender kunden ud i at rette noget, der
            //   ikke er galt, mens det, der ER galt, er usynligt for hende.
            //   Det er husets egen fejlklasse: en besked, der lyder præcis,
            //   og peger det forkerte sted hen.
            //   ⇒ Vi siger at det ikke lykkedes, og tilbyder den beviste vej:
            //     et nyt forsøg med samme indhold giver samme 400.
            kontaktFejl(tv("kontakt-fejl-igen"), true);
            return;
          }
          if (svar.status === 409) {
            // ⚠ NY NØGLE. 409 dækker BÅDE «indsendelsen er ændret» og
            //   «samtalen er udløbet», og de to er BEVIDST ens udadtil.
            //   Fladen forsøger derfor ikke at skelne dem — men i begge
            //   tilfælde er det næste forsøg en NY indsendelse, så nøglen
            //   skal fornys. Beholdt vi den, ville et ærligt genforsøg
            //   ramme den samme 409 igen og igen.
            nyIndsendelsesNoegle();
            // ⛔⛔ OG UDVEJEN SKAL FREM — MÅLT SOM BLINDGYDE, IKKE GÆTTET.
            //   Er 409'en «samtalen er udløbet», rammer et genforsøg den
            //   SAMME døde session: `sikrSession()` mynter kun ÉN gang pr.
            //   sidevisning (`sessionStartProevet`), så hvert nyt klik giver
            //   409 igen, i al evighed. En ny nøgle alene flytter intet.
            //   ⇒ Derfor står den beviste vej fremme her, som på 503.
            // ⛔ OG SESSIONEN RYDDES **IKKE** for at fremtvinge en frisk
            //   myntning. Det ville lukke en dør, huset har lukket med vilje:
            //   den anden 409 («indsendelsen er ændret») kommer på en HELT
            //   levende session, og en klient, der selv kan fremkalde den,
            //   ville dermed kunne nulstille sit tokenbudget uden om «Start ny
            //   samtale»s arv (`forrige_session`). En irritation for kunden
            //   vejer mindre end en gratis nulstilling af budgettet.
            kontaktFejl(tv("kontakt-fejl-igen"), true);
            return;
          }
          // ⛔ 503 OG ALT UVENTET: SIDSTE UDVEJ FREM.
          //   ⚠ NØGLEN BEHOLDES her — netop 503 er den tilstand, hvor et
          //     genforsøg skal ramme SAMME sag, hvis serveren nåede længere,
          //     end svaret nåede tilbage.
          // ⛔⛔ OG DEN NATIVE FORMULAR INDSENDES **IKKE** AF SIG SELV.
          //   Planen foreslog det modsatte, og det er fravalgt med åbne øjne:
          //     · 503 bærer `genindsend: true`, og fordi nøglen er stabil, er
          //       et genforsøg SIKKERT — det rammer samme sag, hvis serveren
          //       nåede længere end svaret. En tavs mail ville tage netop den
          //       chance fra hende og gøre et øjebliks hikke til en permanent
          //       sagsløs henvendelse.
          //     · Mailvejen giver INGEN sag. Sendte vi automatisk, ville huset
          //       systematisk få mails i stedet for sager, præcis når
          //       sagssystemet hikker — og medarbejderen ville igen have to
          //       kanaler at holde øje med. Det er det, krav 2.2 lukker.
          //     · Og næste sidevisning ville vise temaets `gmchat.kvittering`
          //       («vi har modtaget din besked»). Et system, der kvitterer for
          //       en sag, der ikke findes, er husets dyreste fejlklasse —
          //       også når mailen faktisk kom frem.
          //   ⇒ Kunden får ordene OG knappen, og vælger selv. Kun når vi ikke
          //     har ord (`kontaktFejl`), sendes der ordløst — da er
          //     alternativet ingenting.
          kontaktFejl(tv("kontakt-fejl-igen"), true);
        })
        .catch(function () {
          // Netværket svigtede. Samme regel som 503: teksten står, nøglen
          // beholdes, og den beviste vej tilbydes.
          frigivSendKnap();
          kontaktFejl(tv("kontakt-fejl-igen"), true);
        });
      });
      } catch (e) {
        // Samme udfald som en netværksfejl: ingen kvittering, teksten står,
        // og kunden får en vej ud.
        frigivSendKnap();
        kontaktFejl(tv("kontakt-fejl-igen"), true);
      }
    });
  }

  // ---------- Init ----------
  // ⭐ 27/08 v2.2 — SAMTALEN OVERLEVER ET SIDESKIFT (CEO's punkt 4).
  // ⛔ KUN når der FINDES en bagende. Uden endepunkt er der ingen server-session
  //   at genoptage, og så skal der heller ikke ligge et id i browseren: et
  //   nødstop, der tømmer `gm_chat_api_endpoint`, skal degradere NEDAD. Derfor
  //   ryddes lageret aktivt i den tilstand - vi efterlader ikke persondata for
  //   en funktion, der er slukket.
  // ⭐⭐ 10/09 — DET ER IKKE LÆNGERE SANDT, AT VI IKKE KAN VIDE DET.
  //   Her stod: *«Der vises INGEN besked om, at samtalen fortsætter. Vi kan
  //   ikke vide, om serveren stadig har sessionen, og et løfte uden dækning er
  //   værre end ingen.»* Den påstand var rigtig, så længe klienten kun havde
  //   sit eget lager at gå ud fra — og den er nu forældet: `POST
  //   <endpoint>/genoptag` er netop det serverfelt, forbeholdet efterlyste.
  //   ⇒ Påstanden er SKREVET OM her, hvor den stod, ikke slettet — husets
  //     ledelsesregel 7: et forbud overlever den kendsgerning, det bygger på,
  //     så det skal rettes DÉR hvor det står, samme dag.
  //   ⇒ Beskederne gendannes nu, og kontinuitets-mærket vises KUN, når
  //     serveren har svaret `kendt:true`. Uden det svar: ingen linje, præcis
  //     som før.
  if (apiEndpoint) {
    var startTilstand = gemtTilstand();
    // ⭐⭐ ARVEN GENOPTAGES FØR ALT ANDET (10/09). Klikkede kunden «Start ny
    //   samtale» og skiftede side, før hun nåede at skrive, skal den NÆSTE
    //   besked stadig bære `forrige_session` — ellers er knappens eneste
    //   BINDENDE spærre ophævet med et tryk på F5. Se `skrivArv`.
    var _arv = gemtArv();
    if (_arv) {
      forrigeSession = _arv.session;
      forrigeVarOpbrugt = _arv.opbrugt;
    }
    // ⚠ Billedfeltet sættes op UANSET om der er en samtale i gang: kunden må
    //   gerne vedhæfte som det første, hun gør. Se 409-grenen i `sendBillede`
    //   for hvad der sker, når serveren endnu ikke har en session til den.
    opsaetBilledfelt();
    if (startTilstand.session) {
      lagerFrigivet = true;
      sessionId = startTilstand.session.id;
      // ⭐ 10/09: SPØRG SERVEREN, HVAD DEN HUSKER. Se `genoptagSamtale`.
      //   ⚠ Kaldet er BEVIDST ikke afventet: fladen skal være brugbar med det
      //     samme, også hvis netværket er langsomt eller dødt. Lander svaret,
      //     tegner det loggen; lander det ikke, opfører fladen sig som i går.
      try { genoptagSamtale(sessionId); } catch (e) {}
    }
    // Historikken føres, uanset om kunden åbner chatten - det er dét, der gør
    // den brugbar, når hun ENDELIG åbner den efter at have set på tre varer.
    // ⚠ Kun handle og titel, og kun fra den side hun står på. Se
    //   `noterBesoegtVare`.
    try { noterBesoegtVare(laesAktivSide()); } catch (e) {}
    // ⭐ «Start ny samtale» er ALTID til rådighed, når der er en bagende —
    //   ikke kun når budgettet er opbrugt. Planen: *«Vis også «Start ny
    //   samtale».»* Den fremhæves kun i den opbrugte tilstand.
    // ⛔⛔ FLYTNINGEN SKAL SKE FØRST — MÅLT I BROWSEREN 10/09, IKKE GÆTTET.
    //   Skrivefeltet ligger i Liquid'en INDE i `.gmchat-body`, og knappen
    //   hænges ved siden af feltet. Blev den sat ind, mens feltet stadig lå
    //   derinde, slettede `renderIntro`s `body.innerHTML = ""` den ved første
    //   åbning af panelet — og `visNySamtaleKnap` ville bagefter se en node
    //   uden forælder og gøre ingenting. MÅLT: 0 knapper på alle tre bredder,
    //   uden en eneste fejl i konsollen.
    //   ⇒ Feltet (og dermed knappen) flyttes ud af `body` FØR knappen bygges.
    //     Det er den samme flytning, `renderIntro` selv laver — blot i tide.
    flytSkrivefeltUdAfBody();
    visNySamtaleKnap(false);
  } else {
    if (lagerLaes()) lagerRyd();
  }
  showServerState();
})();
